/**
 * @license
 * @qwik.dev/core 2.0.0-beta.38-dev+0bd3685
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as We, isBrowser as Ve } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { p as De } from "@qwik.dev/core/preloader";

const Ue = !1;

const Be = (t, ...n) => Qe(!1, t, ...n);

const Qe = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

/*@__INLINE__*/ const He = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const Je = (t, n, e, s, o = !1) => {
    const r = He(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const Ye = (t, n, e) => {
    const s = He(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const Ge = (t, n, e) => He(t, n, e) >= 0;

const Ze = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const Ke = t => typeof t === "object" && t !== null;

const tr = t => Array.isArray(t);

const nr = t => typeof t === "string";

const er = t => typeof t === "function";

const rr = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = Qe(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const ir = "<sync>";

const sr = t => typeof t === "function" && typeof t.getSymbol === "function";

const Od = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const or = "q:type";

const lr = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const fr = 124;

const ar = (t, n) => {
    const e = parseInt(t, 10) - 1;
    const s = e + n;
    return -(s * (s + 1) / 2 + n + 1);
};

function t(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const hr = "q:renderFn";

const dr = "q:targetEl";

const pr = "⚡️";

const $r = "q:slot";

const yr = "q:sparent";

const wr = "q:s";

const mr = "[q\\:patch]";

const vr = "q:r";

const Ld = "q:rp";

const br = "q:ebc";

const _r = "q:style";

const gr = "style[q\\:style]";

const Er = gr + ",style[q\\:sstyle]";

const Sr = "q:sstyle";

const kr = "q:ctx";

const Rr = "q:brefs";

const Pr = (t, n) => t["qFuncs_" + n] || [];

const Tr = "q:base";

const Ar = "q:container-island";

const Mr = "/" + Ar;

const qr = "q:ignore";

const Ir = "/" + qr;

const xr = "q:container";

const Nr = "/" + xr;

const Cr = "q:template";

const Or = "[q\\:container]:not([q\\:container=html]):not([q\\:container=text])";

const jr = "http://www.w3.org/1999/xhtml";

const Lr = "http://www.w3.org/2000/svg";

const Fr = "http://www.w3.org/1998/Math/MathML";

const Xr = "qRender";

const Dr = "q:id";

const Wr = "q:key";

const Vr = "q:props";

const Ur = "q:seq";

const zr = "q:seqIdx";

const Br = "q:p";

const Qr = "q:ps";

const Jr = ":on";

const Yr = ":onIdx";

const Gr = ":onFlags";

const Zr = ":cursorBoundary";

const Kr = ":nearestCursorBoundary";

const ti = ":";

const ni = "dangerouslySetInnerHTML";

const ri = 100;

const ii = t => {
    try {
        return !!t && typeof t == "object" && typeof t.then === "function";
    } catch {
        return !1;
    }
};

const si = (t, n, e) => {
    try {
        const s = t();
        return ii(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const oi = (t, n) => ii(t) ? t.then(n) : n(t);

const li = t => new Promise(n => {
    setTimeout(n, t);
});

const ui = t => {
    throw t;
};

function n(t, n = ui) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!ii(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = ri;
    const r = async e => {
        for (;ii(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!ii(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const ci = t => pr + t;

const fi = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + ci(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const ai = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function e(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + hi(t.slice(s, -1));
        }
    }
    return null;
}

const hi = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = di(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const di = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const pi = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

const $i = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const yi = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const wi = t => {
    if (!t) {
        return "";
    }
    if (nr(t)) {
        return t.trim();
    }
    const n = [];
    if (tr(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = wi(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const mi = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

const vi = t => {
    if (t == null) {
        return "";
    }
    if (typeof t == "object") {
        if (tr(t)) {
            throw rr(0, [ t, "style" ]);
        }
        {
            const n = [];
            for (const e in t) {
                if (Object.prototype.hasOwnProperty.call(t, e)) {
                    const s = t[e];
                    s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(mi(e) + ":" + bi(e, s)));
                }
            }
            return n.join(";");
        }
    }
    return t + "";
};

function r(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = wi(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = vi(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = (t => t != null ? t + "" : null)(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const bi = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => $i.has(t))(t)) {
        return n + "px";
    }
    return n;
};

const _i = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        let s = !0;
        e.port1.onmessage = () => t();
        n = () => {
            s && e.port2.postMessage(null);
        };
        n.$n = () => {
            if (s) {
                s = !1;
                e.port1.onmessage = null;
                e.port1.close();
                e.port2.close();
            }
        };
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const gi = () => ({
    isServer: We,
    importSymbol(t, n, e) {
        if (We) {
            const t = Od(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw rr(6, [ e ]);
        }
        if (!n) {
            throw rr(14, [ e ]);
        }
        if (!t) {
            throw rr(13, [ n, e ]);
        }
        const s = Ei(t.ownerDocument, t, n).toString();
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const Ei = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(Tr) ?? s, s);
    return new URL(e, o);
};

let Si = /*#__PURE__ */ gi();

const ki = t => Si = t;

const Ri = () => Si;

const jd = () => Si.isServer;

const Fd = typeof document !== "undefined";

const Pi = !We && Fd;

const Ti = Pi ? document : void 0;

const Ai = Pi && Ti.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload";

const Mi = /\.[mc]?js$/;

const qi = t => {
    let n = Ii.get(t);
    if (!n) {
        let e;
        n = ((t, n) => ({
            yn: t,
            Gt: Mi.test(t) ? 0 : 3,
            wn: n,
            mn: 1,
            vn: performance.now(),
            bn: 0,
            _n: 0
        }))(t, e);
        Ii.set(t, n);
    }
    return n;
};

const Ii = new Map;

let xi = 0;

const Ni = [];

const Ci = _i(function Xd() {
    ji = !1;
    if (!Ni.length) {
        return;
    }
    const t = performance.now() + 10;
    let n = !1;
    for (;Ni.length; ) {
        const e = Ni[0];
        const s = e.mn;
        const o = 1 - s;
        if (!(o >= .99 || xi < 25)) {
            break;
        }
        Ni.shift();
        Wi(e);
        if (performance.now() >= t) {
            n = !0;
            break;
        }
    }
    if (n && Ni.length && !ji) {
        ji = !0;
        Ci();
    }
});

const Oi = _i(i);

let ji = !1;

let Li = !1;

let Fi = !1;

const Xi = [];

const Di = () => {
    const t = Xi[Xi.length - 1];
    const n = t.gn;
    if (t.wn) {
        const e = t.Xt;
        if (e >= t.wn.length) {
            Xi.pop();
            return !1;
        }
        const s = t.wn[e];
        t.Xt = e + 1;
        const o = qi(s.yn);
        if (o.mn === 0) {
            return !0;
        }
        const r = 1 - n.mn;
        let i;
        if (r === 1 || r >= .99) {
            i = Math.min(.01, 1 - s.En);
        } else {
            const t = 1 - s.En * r;
            const n = s.Sn;
            const e = t / n;
            i = Math.max(.02, o.mn * e);
            s.Sn = e;
        }
        Xi.push({
            gn: o,
            mn: i,
            kn: t.kn
        });
        return !0;
    }
    if (t.kn?.has(n)) {
        Xi.pop();
        return !1;
    }
    const e = n.mn;
    n.mn = t.mn;
    if (e - n.mn < .01) {
        Xi.pop();
        return !1;
    }
    if (n.wn?.length) {
        const e = t.kn || new Set;
        e.add(n);
        t.kn = e;
        t.wn = n.wn;
        t.Xt = 0;
        return !1;
    }
    Xi.pop();
    return !1;
};

function i() {
    if (Fi || !Xi.length) {
        return;
    }
    Li = !1;
    Fi = !0;
    const t = Pi ? performance.now() + 10 : 0;
    let n = !1;
    for (;Xi.length; ) {
        n = !0;
        const e = Di();
        if (Pi && e && performance.now() >= t) {
            if (!Li) {
                Li = !0;
                Oi();
            }
            break;
        }
    }
    Fi = !1;
    n && Pi && Ci();
}

const Wi = t => {
    if (t.Gt >= 2) {
        return;
    }
    xi++;
    const n = performance.now();
    t.bn = n - t.vn;
    t.Gt = 2;
    const e = Ti.createElement("link");
    e.href = new URL("undefined" + t.yn, Ti.baseURI).toString();
    e.rel = Ai;
    e.as = "script";
    e.onload = e.onerror = () => {
        xi--;
        const s = performance.now();
        t._n = s - n;
        t.Gt = 4;
        e.remove();
        Ci();
    };
    Ti.head.appendChild(e);
};

const Vi = (t, n) => {
    const e = qi(t);
    e && ((t, n) => {
        Xi.unshift({
            gn: t,
            mn: n,
            kn: void 0
        });
    })(e, n);
};

Pi && document.addEventListener("qsymbol", t => {
    const {symbol: n, href: e} = t.detail;
    if (e) {
        const t = n.slice(n.lastIndexOf("_") + 1);
        (t => {
            if (!t?.length) {
                return;
            }
            if (Array.isArray(t)) {
                for (let n = t.length - 1; n >= 0; n--) {
                    const e = t[n];
                    Vi(e, 0);
                }
            } else {
                Vi(t, 0);
            }
            Pi ? Oi() : i();
        })(t);
    }
});

const Ui = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

const zi = t => ({
    write: t,
    writeRootRef(t) {
        return ((t, n) => t.write(n + ""))(this, t);
    },
    writeRootRefPath(t) {
        return ((t, n) => t.write((t => {
            let n = t[0] + "";
            for (let e = 1; e < t.length; e++) {
                n += " " + t[e];
            }
            return n;
        })(n)))(this, t);
    },
    writeRootRefDelta(t, n) {
        return ((t, n, e) => t.write(n - e + ""))(this, t, n);
    }
});

const Bi = '"';

const Qi = "[";

const Hi = "]";

const Ji = ",";

const Yi = "2.0.0-beta.38-dev+0bd3685";

const Gi = t => t.nodeType === 1;

const Zi = t => {
    const n = t.Rn;
    return n || t;
};

const Dd = t => t.xt;

const Ki = Symbol();

class ts {
    [Ki]=void 0;
}

const ns = t => t === "foreignObject";

const es = t => t === "svg" || ns(t);

const rs = t => t === "math";

function s(t, n, e, o = !1) {
    const r = t.ownerDocument.createElementNS(e, n);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== ti && r.setAttribute(e.name, e.value);
    }
    if (o) {
        for (let n = 0; n < t.childNodes.length; n++) {
            const i = t.childNodes[n];
            const c = i.nodeType;
            c === 3 ? r.appendChild(i.cloneNode()) : c === 1 && r.appendChild(s(i, i.localName, e, o));
        }
    }
    return r;
}

const is = {
    elementNamespace: jr,
    elementNamespaceFlag: 0
};

function o(t, n) {
    const e = !t || !!eu(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && ns(eu(t));
    let o = jr;
    let r = 0;
    const i = typeof n === "string" || Sl(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return es(t);
        }
        if (Sl(t)) {
            return es(eu(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = Lr;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return rs(t);
        }
        if (Sl(t)) {
            return rs(eu(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = Fr;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? Lr : e ? Fr : jr;
        r = t.flags & 1536;
    }
    is.elementNamespace = o;
    is.elementNamespaceFlag = r;
    return is;
}

class ss {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [Ki]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class os extends ss {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class ls extends os {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class us extends ss {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const cs = [];

const fs = [];

function l(t, n) {
    const e = y(n).priority;
    let s = cs.length;
    for (let t = 0; t < cs.length; t++) {
        const n = y(cs[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    cs.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function u() {
    for (let t = 0; t < cs.length; t++) {
        const n = cs[t];
        let e = !1;
        for (let t = 0; t < fs.length; t++) {
            const s = fs[t];
            if (Su(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function c(t, n) {
    fs.push(t);
    h(t, n, !0);
    n.o++;
}

function f(t, n) {
    d(t, n);
    if (!(t.flags & 256)) {
        return;
    }
    l(n, t);
}

function a(t, n, e) {
    const s = y(e);
    if (!s || s === n) {
        return;
    }
    h(e, t, !1);
    d(e, t);
    $(n, s);
    s.afterFlushTasks = null;
    s.extraPromises = null;
    s.journal = null;
    s.boundaries = null;
    s.position = null;
    s.promise = null;
}

function h(t, n, e) {
    e || (t.flags &= -257);
    const s = cs.indexOf(t);
    if (s !== -1) {
        cs.splice(s, 1);
        n.o--;
        return !0;
    }
    return !1;
}

function d(t, n) {
    const e = fs.indexOf(t);
    if (e === -1) {
        return !1;
    }
    const s = fs.length - 1;
    e !== s && (fs[e] = fs[s]);
    fs.pop();
    n.o--;
    return !0;
}

const as = new WeakMap;

const hs = ":nodeProps";

const ds = ":nodeDiff";

const ps = ":errorData";

const $s = ":signal";

const ys = ":inlineComponentData";

function p(t, n, e) {
    n.position = e;
    e && pn(e) && function s(t, n, e) {
        const s = y(e);
        if (!s || s === n) {
            return;
        }
        h(e, t);
        (function o(t, n) {
            if (n === t) {
                return;
            }
            const e = n.afterFlushTasks;
            if (e && e.length > 0) {
                const n = t.afterFlushTasks;
                n ? n.push(...e) : t.afterFlushTasks = e;
            }
            const s = n.extraPromises;
            if (s && s.length > 0) {
                const n = t.extraPromises;
                n ? n.push(...s) : t.extraPromises = s;
            }
            $(t, n);
        })(n, s);
    }(t, n, e);
}

function $(t, n) {
    if (n === t) {
        return;
    }
    const e = n.journal;
    if (e && e.length > 0) {
        const n = t.journal;
        n ? n.push(...e) : t.journal = e;
    }
    const s = n.boundaries;
    if (__EXPERIMENTAL__.suspense && s && s.length > 0) {
        const n = t.boundaries ||= [];
        for (let t = 0; t < s.length; t++) {
            const e = s[t];
            n.includes(e) || n.push(e);
        }
    }
}

function y(t) {
    return as.get(t) ?? null;
}

const ws = Symbol();

const ms = Symbol();

const vs = Symbol();

const bs = Symbol();

const _s = Symbol();

const gs = Symbol();

const Es = [];

const Ss = {};

Object.freeze(Es);

Object.freeze(Ss);

function w(t) {
    return new Proxy({}, new ks(t));
}

class ks {
    owner;
    ft=void 0;
    $=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === ws) {
            return this.owner.constProps;
        }
        if (n === ms) {
            return this.owner.varProps;
        }
        if (n === vs) {
            return this.owner;
        }
        if (n === bs) {
            return this;
        }
        let s;
        if (n === "children") {
            s = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            s = Ts(this.owner, n);
            n in this.owner.varProps && Rs(this, n);
        }
        return s instanceof so ? s.value : s;
    }
    set(t, n, s) {
        if (n === vs) {
            this.owner = s;
        } else if (n === "children") {
            this.owner.children = s;
        } else if (n === ws) {
            this.owner.constProps = s;
        } else if (n === ms) {
            this.owner.varProps = s;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === Ss ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== s) {
                this.owner.varProps[n] = s;
                Ps(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && Ps(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === ws || n === ms) {
            return !0;
        }
        const s = n in this.owner.varProps;
        if (typeof n === "string") {
            s && Rs(this, n);
            if (typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
        }
        return s || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const Rs = (t, n) => {
    const e = sa();
    e && t.$ === null && e.$ && (t.$ = e.$);
    const s = e?.hn;
    s && Nn(t.owner._proxy, n, t, s);
};

const Ps = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ft, n);
    e && Vu(t.$, t, e);
    return !!e;
};

const Ts = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const As = (t, n) => Ms(t)?.[n] || qs(t)?.[n] || null;

const Ms = t => {
    if (!t) {
        return null;
    }
    return ms in t ? "children" in t ? {
        ...t[ms],
        children: t.children
    } : t[ms] : t;
};

const qs = t => {
    if (!t) {
        return null;
    }
    return ws in t ? t[ws] : null;
};

const Is = t => t && ms in t;

const xs = Symbol();

class Ns {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const Cs = Symbol();

const Os = Symbol();

const js = Symbol();

function m(t, n, e) {
    t[Ki] || (We && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(Rr, new Map) : t[Ki] = new Map);
    const o = t[Ki];
    let r = o.get(n);
    if (!r) {
        r = new Ns(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const Ls = (t, n) => (e, s) => {
    const o = Fe();
    o.hn = m(t, ":");
    o.$ = n || void 0;
    return Oe(o, () => {
        if (er(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (Lu(e)) {
            return e.value;
        }
        if (Ke(e) && nc(e)) {
            Nn(Gu(e), js, Yu(e), o.hn);
            return e;
        }
        throw rr(2);
    });
};

class Fs {
    Dt;
    ft=void 0;
    $=null;
    Pn=null;
    constructor(t, n) {
        this.$ = t || sa()?.$ || null;
        this.Dt = n;
    }
    trigger() {
        Vu(this.$, this, this.ft);
    }
    force() {
        Vu(this.$, this, this.ft);
    }
    get untrackedValue() {
        return this.Dt;
    }
    set untrackedValue(t) {
        this.Dt = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = sa();
        if (!n) {
            return t;
        }
        this.$ === null && (this.$ = n.$);
        const e = n.hn;
        if (e) {
            const t = We;
            const s = this.ft ||= new Set;
            const o = __EXPERIMENTAL__.suspense && t;
            Fu(s, e);
            Xu(e, this);
            if (t) {
                const t = Wu(n.$, this.$);
                o && t?.Tn?.(this, e, null);
                Du(e, t);
            }
        }
        return t;
    }
    set value(t) {
        if (t !== this.Dt) {
            this.Dt = t;
            Vu(this.$, this, this.ft);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Dt
        };
    }
}

class Xs {
    An;
    Mn=null;
    qn=!1;
    In=!0;
    constructor(t, n, e) {
        this.An = t;
        if (n !== void 0) {
            this.info = n;
            this.xn = e;
        }
    }
    get track() {
        return this.Nn ||= Ls(this.An, this.An.$);
    }
    get abortSignal() {
        return (this.Cn ||= new AbortController).signal;
    }
    cache() {}
    get previous() {
        const t = this.An.Dt;
        if (t !== xs) {
            return t;
        }
    }
    cleanup(t) {
        typeof t === "function" && (this.On ||= []).push(t);
    }
}

class Ds extends Fs {
    Wt;
    h;
    [Ki]=void 0;
    constructor(t, n, e = 17, s) {
        super(t || sa()?.$, xs);
        this.Wt = n;
        this.h = e;
        if (!s) {
            return;
        }
        const o = s.initial;
        o !== void 0 && (this.Dt = typeof o === "function" ? o() : o);
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.zt = r;
            this.Bt = [];
        }
        s.timeout && (this.Qt = s.timeout);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 576);
        s.allowStale === !1 && (this.h |= 128);
        const i = s.expires ?? (s.interval ? Math.abs(s.interval) : void 0);
        i && (this.expires = i);
        (s.poll === !1 || s.interval !== void 0 && s.interval < 0) && (this.h |= 256);
    }
    invalidate(t) {
        if (arguments.length > 0) {
            this.jn = t;
            this.xn = this.xn === void 0 ? 1 : this.xn + 1;
        }
        if (this.h & 512) {
            this.Ln(!0, this.h & 128);
            return;
        }
        this.h |= 1;
        const e = Fe();
        e.$ = this.$ || void 0;
        const s = n(je.bind(this, e, this.p));
        ii(s) && s.catch(t => {
            this.$ ? this.$.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get value() {
        return super.value;
    }
    set value(t) {
        this.h &= -2;
        this.untrackedError = void 0;
        if (this.h & 512) {
            this.untrackedPending = !1;
            this.jn = void 0;
            if (this.Bt) {
                for (let t = 0; t < this.Bt.length; t++) {
                    this.Bt[t].In = !1;
                }
            } else {
                this.ot && (this.ot.In = !1);
            }
            this.Fn();
            super.value = t;
            this.Xn();
            return;
        }
        super.value = t;
    }
    get untrackedValue() {
        this.p();
        if (this.ot?.Mn) {
            if (this.Dt === xs || We) {
                throw this.ot?.Mn;
            }
            return this.Dt;
        }
        if (this.Vt) {
            if (this.Dt === xs) {
                throw this.Vt;
            }
            return this.Dt;
        }
        if (We && this.h & 64 && this.Dt === xs) {
            throw rr(35);
        }
        return this.Dt;
    }
    set untrackedValue(t) {
        this.Dt = t;
    }
    get pending() {
        const t = this.untrackedPending;
        const n = sa();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.hn;
            if (t) {
                Fu(this.yt ||= new Set, t);
                Xu(t, this);
                Du(t, this.$);
            }
        }
        return t;
    }
    set untrackedPending(t) {
        if (t !== !!this.Ut) {
            this.Ut = t;
            Vu(this.$, this, this.yt);
        }
    }
    get untrackedPending() {
        this.p();
        if (We && this.ot?.Mn) {
            throw this.ot?.Mn;
        }
        return !!this.Ut;
    }
    get loading() {
        return this.pending;
    }
    get untrackedLoading() {
        return this.untrackedPending;
    }
    set untrackedLoading(t) {
        this.untrackedPending = t;
    }
    get error() {
        const t = this.untrackedError;
        const n = sa();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.hn;
            if (t) {
                Fu(this.wt ||= new Set, t);
                Xu(t, this);
                Du(t, this.$);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.Vt) {
            this.Vt = t;
            Vu(this.$, this, this.wt);
        }
    }
    get untrackedError() {
        this.p();
        if (We && this.ot?.Mn) {
            throw this.ot?.Mn;
        }
        return this.Vt;
    }
    get expires() {
        return this.Tt || 0;
    }
    set expires(t) {
        this.Fn();
        this.Tt = t;
        this.Tt && this.Dn() && this.Xn();
    }
    get poll() {
        return !(this.h & 256);
    }
    set poll(t) {
        t ? this.h &= -257 : this.h |= 256;
        if (this.Tt && this.Dn()) {
            this.Fn();
            this.Xn();
        }
    }
    get interval() {
        const t = this.Tt || 0;
        return this.h & 256 ? -t : t;
    }
    set interval(t) {
        t < 0 ? this.h |= 256 : this.h &= -257;
        this.expires = Math.abs(t);
    }
    Ln(t, n) {
        this.h |= 1;
        this.Fn();
        n && (this.Dt = xs);
        t && (this.ft?.size || this.yt?.size || this.wt?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.ot && this.Wn(this.ot, t);
    }
    vt() {
        if (!(this.h & 32) || this.Dn()) {
            return;
        }
        if (!Ve) {
            return;
        }
        setTimeout(() => {
            this.Dn() || this.abort();
        });
    }
    async promise() {
        this.p();
        for (;this.ot?.Mn; ) {
            await (this.ot?.Mn);
        }
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        if (this.h & 512) {
            return this.Vn();
        }
        const t = this.Wt;
        ju(t);
        const e = this.ot;
        if (e && !e.qn) {
            e.qn = !0;
            e.Cn?.abort();
            this.Un(e);
        }
        const s = new Xs(this, this.jn, this.xn);
        this.ot = s;
        let o;
        try {
            o = this.zn(t.resolved, s);
        } catch (t) {
            if (ii(t)) {
                throw t;
            }
            s.xn === this.xn && (this.jn = void 0);
            this.h &= -2;
            this.Bn(s, t);
            return;
        }
        if (ii(o)) {
            this.h |= 512;
            this.h &= -2;
            let t = o;
            const e = () => {
                const n = t ?? this.zn(this.Wt.resolved, s);
                t = void 0;
                return n;
            };
            s.Mn = this.Qn(s, () => n(e));
            return;
        }
        s.xn === this.xn && (this.jn = void 0);
        this.h &= -2;
        this.untrackedError = void 0;
        super.value = o;
    }
    zn(t, n) {
        const e = t;
        if (this.h & 1024) {
            let t = sa();
            t?.hn && (t = {
                ...t,
                hn: void 0
            });
            return je(t, e, [ n ]);
        }
        const s = this.$ ||= sa()?.$ || null;
        const o = m(this, ".");
        s && Pn(s, o);
        const r = Fe();
        r.$ = s || void 0;
        r.hn = o;
        return je(r, e, [ n ]);
    }
    Vn() {
        if (We && this.h & 64) {
            this.Ut = !0;
            this.$?.serializationCtx.At.add(this);
            return;
        }
        this.Fn();
        this.h &= -2;
        const t = this.ot;
        t && this.Wn(t);
        const n = this.zt === 0 ? Infinity : this.zt ?? 1;
        if (this.Bt ? this.Bt.length >= n : t?.Mn) {
            this.h |= 1;
            return;
        }
        const e = this.xn;
        const s = new Xs(this, this.jn, e);
        this.ot = s;
        this.Bt && this.Bt.push(s);
        s.Mn = this.Hn(s);
    }
    async Hn(t) {
        let e = this.Wt.resolved;
        if (!e) {
            this.untrackedPending = !0;
            e = await this.Wt.resolve();
            if (t.Cn?.signal.aborted) {
                t.Mn = null;
                return;
            }
        }
        this.Qt && (this.Jn = setTimeout(() => {
            const n = Error(`timeout ${this.Qt}ms`);
            this.Bn(t, n);
            t.Cn?.abort(n);
        }, this.Qt));
        return this.Qn(t, () => n(() => this.zn(e, t)));
    }
    async Qn(t, n) {
        try {
            const e = n();
            let s;
            if (ii(e)) {
                this.untrackedPending = !0;
                s = await e;
            } else {
                s = e;
            }
            t.Mn = null;
            if (t.In) {
                const n = this.Bt;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s].In = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = s;
            }
        } catch (n) {
            t.Mn = null;
            this.Bn(t, n);
        }
        if ((() => t === this.ot)()) {
            clearTimeout(this.Jn);
            t.xn === this.xn && (this.jn = void 0);
            if (this.h & 1) {
                this.p();
            } else {
                this.untrackedPending = !1;
                this.Xn();
            }
        }
    }
    Bn(t, n) {
        if (t !== this.ot || !t.In) {
            return;
        }
        t.In = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
    }
    async $n() {
        this.Fn();
        clearTimeout(this.Jn);
        const t = this.ot;
        t && this.Wn(t);
        this.Bt ? await Promise.all(this.Bt.map(t => t.Mn)) : await (t?.Mn);
    }
    Fn() {
        if (this.Yn !== void 0) {
            clearTimeout(this.Yn);
            this.Yn = void 0;
        }
    }
    Xn() {
        if (We || !this.Tt) {
            return;
        }
        this.Fn();
        const t = !(this.h & 256);
        const n = this.h & 128 && !t;
        this.Yn = setTimeout(() => this.Ln(t, n), this.Tt);
        this.Yn?.unref?.();
    }
    Dn() {
        return !!(this.ft?.size || this.yt?.size || this.wt?.size);
    }
    Wn(t, n) {
        if (t.qn) {
            return;
        }
        t.qn = !0;
        t.Cn?.abort(n);
        t.Mn = oi(t.Mn, () => this.Gn(t));
    }
    Un(t) {
        const n = t.On;
        const e = t => {
            const n = this.$?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        let s;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const o = n[t]();
                    ii(o) && (s = (s ? s.then(() => o) : o).catch(e));
                } catch (t) {
                    e(t);
                }
            }
            n.length = 0;
        }
        return s;
    }
    Gn(t) {
        const n = () => {
            t.Mn = null;
            const n = this.Bt;
            if (n) {
                const e = n.indexOf(t);
                e !== -1 && n.splice(e, 1);
            }
            this.p();
        };
        const e = this.Un(t);
        if (e) {
            return e.then(n);
        }
        n();
    }
}

const Ws = t => (n, ...e) => t.call(null, Da(n), ...e);

class Vs extends Ds {
    constructor(t, n) {
        super(t, n, 17);
    }
    Zn=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        ju(this.Wt);
        const t = ca(this.Wt.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Dt === xs ? e : this.Dt;
        const r = aa(() => this.Zn ? s?.(o) || o : n(o), this, ".", this.$);
        this.Zn = !0;
        this.h &= -2;
        const i = this.Zn && r !== "undefined" || r !== this.Dt;
        if (i) {
            this.Dt = r;
            Vu(this.$, this, this.ft);
        }
    }
}

class Us extends Ds {
    constructor(t, n, e = 17, s) {
        super(t, n, 1536 | e, s);
    }
}

const zs = (t, n) => {
    const e = t;
    e.invalidate({
        __v: n
    });
    e.p();
};

const Bs = (t, n) => new Ds(n?.container || null, t, zu(n?.serializationStrategy || "always"), n);

const Qs = (t, n) => new Us(n?.container || null, t, zu(n?.serializationStrategy || "always"), n);

const Hs = t => new Vs(null, t);

const Js = t => new Fs(null, t);

const Ys = /*#__PURE__*/ Ws(Bs);

const Gs = /*#__PURE__*/ Ws(Qs);

const Zs = Ws(Hs);

const Ks = t => t.value;

const to = (t, n) => t[n];

const no = t => {
    if (t.length === 1) {
        if (Lu(t[0])) {
            return t[0].Pn ||= new so(null, Ks, t, null);
        }
        if (nc(t[0])) {
            return new so(null, Ks, t, null);
        }
        return t[0].value;
    }
    return new so(null, to, t, null);
};

const eo = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!Ke(n)) {
        return n[e];
    }
    if (Lu(n)) {
        if (n instanceof so) {
            return n;
        }
        return no(t);
    }
    if (Is(n)) {
        const s = n[ws];
        const o = n[ms];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return ro(n, t);
        }
    } else {
        const s = Gu(n);
        if (s) {
            const n = s[e];
            return ro(n, t);
        }
    }
    return n[e];
};

const ro = (t, n) => Lu(t) ? t : no(n);

const io = (t, n) => {
    const e = eo(t, n);
    if (e === _s) {
        return t[n];
    }
    return e;
};

class so extends Fs {
    ut;
    lt;
    Rt;
    h;
    m=void 0;
    [Ki]=void 0;
    constructor(t, n, e, s, o = 1) {
        super(t, xs);
        this.ut = e;
        this.lt = n;
        this.Rt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.$ && this.m) {
                this.$.setHostProp(this.m, $s, this);
                wn(this.$, this.m, 32);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            Vu(this.$, this, this.ft);
        }
    }
    get untrackedValue() {
        this.p();
        return this.Dt;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = aa(() => this.lt(...this.ut), this, ".", this.$);
        this.h &= -3;
        const n = t !== this.Dt;
        if (n) {
            this.h |= 2;
            this.Dt = t;
        }
    }
    it() {
        return this.lt === Ks && Lu(this.ut[0]) ? this.ut[0] : this;
    }
    set value(t) {
        throw rr(31);
    }
    get value() {
        return super.value;
    }
}

class oo {
    data;
    constructor(t) {
        this.data = t;
    }
}

Object.prototype.hasOwnProperty;

class lo {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || Ui(n) ? Ss : n;
        this.constProps = !e || Ui(e) ? null : e;
    }
    get props() {
        return this._proxy ||= w(this);
    }
}

const uo = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const co = t => t instanceof lo;

const fo = (t, n, e) => {
    if (typeof t === "string") {
        const s = Me(n);
        return na(s, () => {
            Ta(Aa(s, t));
            return e();
        });
    }
    return e();
};

function v(t, n) {
    return fo(this, n, () => {
        const t = Pa[0];
        t.value = n.type === "number" ? n.valueAsNumber : n.value;
    });
}

function b(t, n) {
    return fo(this, n, () => {
        const t = Pa[0];
        t.value = n.checked;
    });
}

function _(t, n) {
    return fo(this, n, () => {
        if (Pa) {
            for (let t = 0; t < Pa.length; t++) {
                const n = Pa[t];
                n instanceof Us && n.h & 64 && n.p();
            }
        }
    });
}

const ao = "bind:value";

const ho = "bind:checked";

const po = "passive:";

const $o = "preventdefault:";

const yo = Object.prototype.hasOwnProperty;

const wo = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(hi(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const mo = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return hi(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return hi(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return hi(t.slice(11, -1));
    }
    return null;
};

const vo = (t, n, s, o, r = !1) => {
    let i = t;
    let c = r;
    for (let t = 0; t < n.length; t++) {
        const r = n[t];
        const l = mo(r);
        const u = e(r, o.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = s.get(u);
            (t === void 0 || t < s.get(r)) && (i[u] = i[r]);
            delete i[r];
        }
    }
    return i;
};

const bo = (t, n, e, s, o, r, i) => new lo(t, n, e, s, o, r, !1, i);

const _o = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const i = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith(po)) {
                    r.push(o);
                    t.add(hi(o.slice(8)));
                } else {
                    o.startsWith($o) ? h.push(o) : mo(o) !== null ? s.push(o) : o === ho ? a = e[o] : o === ao && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith(po)) {
                    i.push(s);
                    t.add(hi(s.slice(8)));
                } else {
                    s.startsWith($o) ? d.push(s) : mo(s) !== null ? o.push(s) : s === ho ? a = n[s] : s === ao && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = wo(e, r, h, t, l);
            l = l || e !== n;
            e = vo(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = wo(n, i, d, t, u);
            u = u || n !== e;
            n = vo(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && yo.call(n, ho) && delete n[ho];
                if (e && yo.call(e, ho)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[ho];
                }
                n.checked = a;
                const t = xa(null, "_chk", b, null, [ a ]);
                if (e && yo.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = uo(n, "q-e:input", t) || c;
                }
                c = uo(n, "q-e:input", t) || c;
            } else if (f) {
                n && yo.call(n, ao) && delete n[ao];
                if (e && yo.call(e, ao)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[ao];
                }
                n.value = f;
                const t = xa(null, "_val", v, null, [ f ]);
                if (e && yo.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = uo(n, "q-e:input", t) || c;
                }
                c = uo(n, "q-e:input", t) || c;
            }
        }
        if (n && yo.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && yo.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new lo(t, n, e, s, o, r, c || !0, i);
};

const go = (t, n, e, s) => Ro(t, n, s);

const Eo = (t, n, e, s, o) => Ro(t, {
    ...e,
    ...n
}, o);

const So = (t, n, e, s, o, r) => Ro(t, {
    ...e,
    ...n,
    children: s
}, r);

const ko = t => t.children;

const Ro = (t, n, e, s, o) => _o(t, n, null, null, 0, e, o);

const Po = Ro;

const To = Ro;

function g(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return _o(t, n, null, s.children, 0, o);
}

const Ao = t => t.children;

const Mo = (t, n) => new lo(ko, null, null, t.children, 0, n);

const qo = t => bo(ko, null, {
    [wr]: ""
}, t.children, 0, t.name ?? "");

const Io = Symbol();

const xo = () => null;

const No = () => null;

const Co = t => t.children;

const Oo = (t, n) => Ro(Mo, {
    children: Ro(jo, t)
}, n);

const jo = () => null;

let Lo = null;

let Fo = null;

function E(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    Fo || (Fo = t.setAttributeNS);
                    Fo.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            Lo || (Lo = t.setAttribute);
            Lo.call(t, n, e);
        })(t, n, e);
    }
}

const Xo = Object.prototype.hasOwnProperty;

function S(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

function k(t) {
    if (t) {
        for (const n in t) {
            if (S(n)) {
                return !0;
            }
        }
    }
    return !1;
}

const Do = (t, n = [], e = {}) => {
    let s = null;
    const o = t[ws];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[ms];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return w(new lo(null, r, s, null, 0, null));
};

function R(t, n, e) {
    const s = n.constProps;
    if (s && typeof s == "object" && Xo.call(s, "name")) {
        const n = s.name;
        if (t && n instanceof so) {
            return ha(n, t, ":", e);
        }
    }
    return Ts(n, "name") || "";
}

class Wo {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Vo {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Uo {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class zo {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class Bo {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const Qo = t => new Wo(t);

const Ho = t => new Vo(t);

const Jo = (t, n) => new Uo(t, n);

const Yo = (t, n, e) => new zo(t, n, e);

const Go = (t, n, e, s = null, o = !1) => new Bo(t, n, e, s, o);

const Zo = () => {
    const t = la();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, Ur);
    if (s === null) {
        s = [];
        t.$.setHostProp(e, Ur, s);
    }
    let o = t.$.getHostProp(e, zr);
    o === null && (o = 0);
    t.$.setHostProp(e, zr, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const Ko = t => {
    const n = er(t) && !Qa(t) ? Oe(void 0, t) : t;
    return Js(n);
};

const tl = t => nl(Ko, t);

const nl = (t, ...n) => {
    const {val: e, set: s} = Zo();
    if (e != null) {
        return e;
    }
    t = er(t) && !Qa(t) ? ca(t, ...n) : t;
    return s(t);
};

function P(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    let e = null;
    let s = n;
    for (;s && !e; ) {
        e = M(s);
        s = s.slotParent || s.parent;
    }
    if (!e) {
        return;
    }
    const o = t.boundaries ||= [];
    if (!o.includes(e)) {
        o.push(e);
        e.value++;
    }
}

function T(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return Ml(t, Zr, null) || null;
}

function A(t) {
    q(t, null);
}

function M(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return Ml(t, Kr, null) || T(t);
}

function q(t, n) {
    __EXPERIMENTAL__.suspense && ql(t, Kr, n);
}

function I(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    q(t, n);
    const e = t.dirtyChildren;
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const s = e[t];
        I(s, T(s) || n);
    }
}

const el = t => {
    if (t.$n) {
        try {
            t.$n();
        } catch (t) {
            Be(t);
        }
        t.$n = null;
    }
};

function x(t, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    if (!o) {
        const n = Me(s);
        return na(n, () => x(t, e, s, ua(e, s, n)));
    }
    const r = o.$;
    const i = o.m;
    Nl(r, i);
    let c = t;
    if (i.flags & 64) {
        let n;
        if (!(i.flags & 128)) {
            n = !0;
            i.flags |= 128;
        }
        const o = n ? r._ : null;
        const l = Ml(i, Br, o);
        if (l !== null) {
            c = () => t(e, s, l);
        } else {
            const n = Ml(i, Qr, o);
            n !== null && (c = () => t(e, s, ...n));
        }
    }
    return n(() => {
        if (!(i.flags & 32)) {
            return je(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i, "event"));
}

function N(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = Me(n);
    return na(e, () => {
        const s = ua(t, n, e);
        typeof this === "string" && Ta(Aa(s.$, this));
        const o = Pa[0];
        return x(o, t, n, s);
    });
}

function C(t) {
    return t.k === t.R ? t.T : null;
}

function O(t) {
    return t.M || C(t);
}

function j(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = C(t);
    return e === o ? null : e;
}

const rl = Object.prototype.hasOwnProperty;

function L(t, n, e, s, o, r) {
    ql(n, e, r);
    mn(t, Go(n.node, e, s, o, (n.flags & 512) !== 0));
}

function F(t, n, e, s) {
    return {
        $: t,
        q: n,
        N: e,
        O: s,
        j: [],
        L: [],
        X: [],
        k: null,
        M: null,
        D: null,
        T: null,
        R: null,
        W: null,
        U: null,
        B: null,
        H: null,
        J: null,
        Y: 0,
        G: 0,
        Z: !0,
        K: !1,
        tt: {
            nt: new oo({
                O: s,
                et: !0
            }),
            rt: new oo({
                O: s,
                et: !1
            })
        }
    };
}

function X(t, n, e, s, o) {
    const r = t ?? F(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.$ = n;
        t.q = e;
        t.N = s;
        t.O = o;
        t.tt.nt.data.O = o;
        t.tt.rt.data.O = o;
        t.L.length = 0;
        t.X.length = 0;
    })(r, n, e, s, o);
    return r;
}

const il = (t, n, e, s, o, r, i) => D(X(i, t, n, o, r), e, s);

const sl = (t, n, e, s, o, r, i, c, l = !1, u) => D(X(u, t, n, i, c), e, s, o, r, l);

function D(t, n, e, s = su(e), o = null, r = !1) {
    W(t, n, e, s, o, r);
    const i = Z(t);
    if (ii(i)) {
        return i.finally(() => {
            K(t);
        });
    }
    K(t);
}

function W(t, n, e, s = su(e), o = null, r = !1) {
    const i = t.K;
    t.K = r || i;
    t.k = e;
    t.D = null;
    t.M = s;
    t.T = o;
    t.R = e;
    Q(t, n, !0);
    try {
        if (t.k.flags & 32) {
            return;
        }
        for (;t.j.length; ) {
            for (;t.Y < t.G; ) {
                if (typeof t.J === "string") {
                    mt(t, t.J);
                } else if (typeof t.J === "number") {
                    mt(t, t.J + "");
                } else if (t.J && typeof t.J === "object") {
                    if (co(t.J)) {
                        const n = t.J.type;
                        if (typeof n === "string") {
                            et(t);
                            ft(t, t.J, n);
                            const e = t.J.constProps && rl.call(t.J.constProps, ni) || rl.call(t.J.varProps, ni);
                            e ? t.D || tt(t, !1) : z(t, t.J.children, !0);
                        } else if (typeof n === "function") {
                            if (n === Ao) {
                                et(t);
                                pt(t, "F", t.J.key);
                                z(t, t.J.children, !0);
                            } else if (n === qo) {
                                et(t);
                                Y(t) || z(t, t.J.children, !0);
                            } else if (n === _t) {
                                J(t);
                                z(t, t.J.children, !0, !0);
                            } else if (n === No) {
                                nt(t);
                            } else if (n === xo) {
                                nt(t);
                            } else {
                                et(t);
                                $t(t, n);
                            }
                        }
                    } else if (Array.isArray(t.J)) {
                        z(t, t.J, !1);
                    } else if (Lu(t.J)) {
                        pt(t, "S", null);
                        const n = t.J instanceof so ? t.J.it() : t.J;
                        const e = t.M?.[Ki]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof so && (s = xt(e, n));
                        if (!s) {
                            const e = t.D || t.M;
                            z(t, V(t, () => ha(n, e, ".", t.$)), !0);
                        }
                    } else if (ii(t.J)) {
                        pt(t, "A", null);
                        t.L.push(t.J, t.D || t.M);
                    }
                } else {
                    t.J === Io || mt(t, "");
                }
                U(t);
            }
            nt(t);
            G(t);
            B(t);
        }
    } finally {
        t.K = i;
    }
}

function V(t, e) {
    try {
        return e();
    } catch (s) {
        if (ii(s)) {
            const o = s.then(() => n(e));
            t.L.push(o, t.D || t.M);
            return null;
        }
        throw s;
    }
}

function U(t) {
    if (!t.Z) {
        t.Z = !0;
        return;
    }
    t.Y++;
    if (t.Y < t.G) {
        t.J = t.H[t.Y];
    } else if (t.j.length > 0 && t.j[t.j.length - 1] === !1) {
        return B(t);
    }
    t.D !== null ? t.D = null : t.M = j(t, t.M);
}

function z(t, n, e, s = !1) {
    if (!s && (n == null || e && tr(n) && n.length === 0)) {
        tt(t);
        return;
    }
    Q(t, n, e);
    if (e) {
        const n = !s && t.K || !!t.D || !su(t.M);
        t.K = n;
        t.B = null;
        t.W = null;
        t.U = null;
        t.k = t.D || t.M;
        t.M = su(t.k);
        t.D = null;
    }
    t.Z = !1;
}

function B(t) {
    const n = t.j.pop();
    if (n) {
        t.K = t.j.pop();
        t.B = t.j.pop();
        t.W = t.j.pop();
        t.U = t.j.pop();
        t.D = t.j.pop();
        t.M = t.j.pop();
        t.k = t.j.pop();
    }
    t.J = t.j.pop();
    t.G = t.j.pop();
    t.Y = t.j.pop();
    t.H = t.j.pop();
    U(t);
}

function Q(t, n, e) {
    t.j.push(t.H, t.Y, t.G, t.J);
    e && t.j.push(t.k, t.M, t.D, t.U, t.W, t.B, t.K);
    t.j.push(e);
    if (Array.isArray(n)) {
        t.Y = 0;
        t.G = n.length;
        t.H = n;
        t.J = t.G > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.Y = 0;
        t.J = null;
        t.H = null;
        t.G = 0;
    } else {
        t.Y = 0;
        t.J = n;
        t.H = null;
        t.G = 1;
    }
}

function H(t) {
    if (t.D) {
        return O(t);
    }
    return j(t, t.M) || C(t);
}

function J(t) {
    const n = t.J;
    const e = n.key;
    t.M = Ml(t.k, e, n => Ll(t.$.rootVNode, n));
    t.M = t.M && t.M.flags & 32 ? null : t.M;
    if (t.M == null) {
        t.D = gl();
        ql(t.D, $r, e);
        t.D.slotParent = t.k;
        ql(t.k, e, t.D);
    }
}

function Y(t) {
    const n = t.J;
    const e = Iu(t.k);
    const s = R(e, n, t.$);
    const o = Ts(n, Zr) || null;
    const r = e ? Ml(e, s, null) : null;
    if (r == null) {
        t.D = gl();
        ql(t.D, $r, s);
        ql(t.D, Zr, o);
        I(t.D, o);
        e && ql(e, s, t.D);
        Gl(t.q, t.k, t.D, H(t));
        return !1;
    }
    if (r === t.M) {} else {
        const n = r.parent;
        t.D = r;
        ql(t.D, $r, s);
        ql(t.D, Zr, o);
        I(t.D, o);
        e && ql(e, s, t.D);
        Yl(t.q, t.D);
        Gl(t.q, t.k, t.D, H(t));
        n && Sl(n) && !n.firstChild && eu(n) === Cr && tu(t.q, n.parent, n, !0);
    }
    return !0;
}

function G(t) {
    const n = t.B;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            St(t.$, t.q, e, t.N);
            tu(t.q, t.k, e, !0);
        }
        n.clear();
        t.B = null;
    }
    t.M = null;
}

function Z(t) {
    for (;t.L.length; ) {
        const n = t.L.shift();
        const e = t.L.shift();
        if (ii(n)) {
            return n.then(n => {
                W(t, n, e);
                return Z(t);
            }).catch(n => {
                t.$.handleError(n, e);
                return Z(t);
            });
        }
        W(t, n, e);
    }
    if (t.X.length) {
        const n = t.X.splice(0);
        return Promise.all(n).then(() => Z(t));
    }
}

function K(t) {
    t.q = null;
    t.N = null;
}

function tt(t, n = !0) {
    const e = t.M && su(t.M);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            St(t.$, t.q, s, t.N);
            s = s.nextSibling;
        }
        nu(t.q, t.M, e, n);
    }
}

function nt(t) {
    const n = C(t);
    if (t.M !== null && t.M !== n) {
        for (;t.M && t.M !== n; ) {
            const n = t.M;
            t.M = j(t, t.M);
            if (t.k === n.parent) {
                St(t.$, t.q, n, t.N);
                tu(t.q, t.k, n, !0);
            }
        }
    }
}

function et(t) {
    if (t.M !== null && Pl(t.M)) {
        const n = t.M;
        t.M = j(t, t.M);
        tu(t.q, t.k, n, !0);
    }
}

function rt(t, n, e) {
    if (Lu(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw rr(15, [ e ]);
}

function it(t, e, s, o, r) {
    return n(() => ha(o, e, s, t, r));
}

function st(t, n, e, s, o) {
    const i = t.O;
    const c = s.then(t => E(n, e, r(e, t, i), o));
    t.X.push(c);
}

function ot(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(xr, "html");
    }
}

function lt(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function ut(t, n, e, s) {
    const i = function c(t, n) {
        const e = Kl(t.k, !0);
        const s = o(e, n);
        const r = document;
        const i = s.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(s.elementNamespace, n);
        t.D = vl(i, n);
        t.D.flags |= s.elementNamespaceFlag;
        return i;
    }(t, e);
    const l = t.D;
    const u = (l.flags & 512) !== 0;
    const {constProps: f} = n;
    if (f) {
        for (const n in f) {
            let o = f[n];
            if (ai(n)) {
                ct(n, o, i, l, t);
                continue;
            }
            if (n === "ref" && rt(o, i, s)) {
                continue;
            }
            Lu(o) && (o = it(t.$, t.D, n, o, t.tt.nt));
            if (ii(o)) {
                st(t, i, n, o, u);
                continue;
            }
            if (n === ni) {
                ot(i, o);
                continue;
            }
            if (e === "textarea" && n === "value" && lt(i, o)) {
                continue;
            }
            E(i, n, r(n, o, t.O), u);
        }
    }
    const a = n.key;
    a && (t.D.key = a);
    if (t.O) {
        const e = rl.call(n.varProps, "class") || n.constProps && rl.call(n.constProps, "class");
        e || i.setAttribute("class", t.O);
    }
    zl(t.q, t.k, t.D, O(t));
}

function ct(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(x.bind(null, n));
                }
            } else {
                e && s.push(x.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = x.bind(null, n));
    }
    t.charAt(2) !== "e" && Il(o.q, s, t, "");
    (function i(t, n) {
        const e = window;
        e && (e._qwikEv ||= []).push(n);
    })(0, r);
}

function ft(t, n, e) {
    if (t.K) {
        ut(t, n, e, null);
    } else {
        const s = t.M && Sl(t.M);
        const o = s && e === eu(t.M);
        const r = n.key;
        const i = s && t.M.key;
        if (o && r === i) {
            ht(t, e, r);
        } else {
            const s = at(e, r);
            dt(t, e, r, s, t.k) && ut(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.D || t.M;
    s && function r(t, n, e, s) {
        t.K || Nl(t.$, n);
        const o = n.props;
        const r = (n.flags & 1536) === 0;
        for (const i in e) {
            const c = e[i];
            const l = o && r && !rl.call(o, i) ? i.toLowerCase() : i;
            if (o && rl.call(o, l)) {
                const e = o[l];
                if (l !== i) {
                    ql(n, l, null);
                    ql(n, i, e);
                }
                Tt(c, e) || ol(t, n, i, c, s);
            } else {
                c != null && ol(t, n, i, c, s);
            }
        }
        if (o) {
            for (const r in o) {
                rl.call(e, r) || r.charAt(0) === ":" || ai(r) || ol(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const ol = (t, n, e, s, o) => {
    if (ai(e)) {
        ct(e, s, n.node, n, t);
        return;
    }
    if (e === Br || e === Qr) {
        ql(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (rt(s, t, o)) {
            return;
        }
    }
    const i = n[Ki]?.get(e);
    if (Lu(s)) {
        const o = s instanceof so ? s.it() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && Pn(t.$, i);
        const r = n;
        s = it(t.$, r, e, o, t.tt.rt);
    } else {
        i && Pn(t.$, i);
    }
    if (ii(s)) {
        const o = n;
        const i = s.then(n => {
            L(t.q, o, e, n, t.O, r);
        });
        t.X.push(i);
        return;
    }
    L(t.q, n, e, s, t.O, r);
};

function at(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function ht(t, n, e) {
    const s = at(n, e);
    if (s && t.B?.has(s)) {
        t.B.delete(s);
        return !0;
    }
    return !1;
}

function dt(t, n, e, s, o, r) {
    t.D = function i(t, n, e) {
        let s = null;
        if (t.W === null) {
            const o = t.M;
            if (o) {
                const s = Sl(o) ? eu(o) : null;
                const r = vt(o) || bt(o, t.$._);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.W = new Map;
            t.U = [];
            const r = C(t);
            let i = t.M;
            for (;i && i !== r; ) {
                const o = Sl(i) ? eu(i) : null;
                const r = vt(i) || bt(i, t.$._);
                s === null && r == e && o == n ? s = i : r === null ? t.U.push(o, i) : t.W.set(at(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.U.length; e += 2) {
                if (t.U[e] === n) {
                    s = t.U[e + 1];
                    t.U.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = at(n, e);
            const r = t.W.get(o);
            if (r) {
                s = r;
                t.W.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.M) {
                    const n = Sl(t.M) ? eu(t.M) : null;
                    const e = vt(t.M) || bt(t.M, t.$._);
                    if (e != null) {
                        const s = at(n, e);
                        t.B ||= new Map;
                        t.B.set(s, t.M);
                        t.W?.delete(s);
                    }
                }
                return;
            }
            const e = C(t);
            let s = t.M;
            for (;s && s !== n && s !== e; ) {
                const n = Sl(s) ? eu(s) : null;
                const e = vt(s) || bt(s, t.$._);
                if (e != null) {
                    const o = at(n, e);
                    t.B ||= new Map;
                    t.B.set(o, s);
                    t.W?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.D) {
        s || Gl(t.q, o, t.D, O(t));
        t.M = t.D;
        t.D = null;
        return !1;
    }
    if (s != null) {
        const n = t.B?.get(s) || null;
        if (n) {
            t.B.delete(s);
            if (r && t.M) {
                const n = vt(t.M) || bt(t.M, t.$._);
                if (n != null) {
                    const e = Sl(t.M) ? eu(t.M) : null;
                    const s = at(e, n);
                    if (s != null) {
                        t.B ||= new Map;
                        t.B.set(s, t.M);
                    }
                }
            }
            n !== t.M && Gl(t.q, o, n, O(t));
            t.M = n;
            t.D = null;
            return !1;
        }
    }
    return !0;
}

function pt(t, n, e) {
    const s = n === "F";
    const o = vt(t.M);
    const r = t.M && Tl(t.M);
    const i = r && o === e && (!s || !!e);
    if (i) {
        ht(t, null, o);
        return;
    }
    if (e === null || t.K) {
        Bl(t.q, t.k, t.D = gl(), H(t));
        t.D.key = e;
        return;
    }
    if (dt(t, null, e, at(null, e), t.k, !0)) {
        Bl(t.q, t.k, t.D = gl(), H(t));
        t.D.key = e;
    }
}

function $t(t, n) {
    const e = n[Ba];
    let s = t.D || t.M;
    const o = t.J;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.st;
        const l = bt(s, t.$._);
        const u = o.key || c;
        const f = vt(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                ht(t, null, u);
            } else {
                yt(t, s, i, n);
                s = t.D;
                r = !0;
            }
        } else {
            if (dt(t, null, u, u, t.k)) {
                yt(t, s, i, n);
                r = !0;
            }
            s = t.D || t.M;
        }
        if (s) {
            const e = Ml(s, Vr, t.$._);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = gt(n[ws], e[ws], e[bs], s, !1);
                        o ||= t;
                        const r = gt(n[ms], e[ms], e[bs], s, !0);
                        o ||= r;
                        e[vs] = n[vs];
                    } else if (n) {
                        ql(t, Vr, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.$);
                if (c && o.key == null) {
                    yt(t, s, i, n);
                    s = t.D;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                ql(s, hr, i);
                s.flags &= -33;
                wn(t.$, s, 4, t.N);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new lo(_t, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (S(n)) {
                            const t = n;
                            Je(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (co(n) && Ts(n, $r) || "") + "";
                const i = He(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            z(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = vt(s);
        const i = e === r;
        const c = bt(s, t.$._);
        const l = c == null;
        if (s && !l || !s) {
            wt(t);
            s = t.D;
        } else if (i) {
            ht(t, null, e);
        } else {
            dt(t, null, e, e, t.k) && wt(t);
            s = t.D || t.M;
        }
        if (s) {
            let e = s;
            for (;e && (!Tl(e) || Ml(e, hr, null) === null); ) {
                e = e.parent || Iu(e);
            }
            (function r(t, n, e, s) {
                const o = t.props ||= {};
                o[ys] = {
                    componentFn: n,
                    subscriptionHost: e,
                    props: s
                };
            })(s, n, e, o.props);
            wn(t.$, s, 8, t.N);
        }
    }
}

function yt(t, n, e, s) {
    n && Rn(t.$, n);
    Bl(t.q, t.k, t.D = gl(), H(t));
    const o = t.J;
    ql(t.D, hr, e);
    ql(t.D, Vr, s);
    t.D.key = o.key;
}

function wt(t) {
    Bl(t.q, t.k, t.D = gl(), H(t));
    const n = t.J;
    ql(t.D, Vr, n.props);
    n.key && (t.D.key = n.key);
}

function mt(t, n) {
    if (t.M !== null) {
        const e = Mu(t.M);
        if (e === 3) {
            if (n !== ru(t.M)) {
                iu(t.q, t.M, n);
                return;
            }
            return;
        }
    }
    zl(t.q, t.k, t.D = _l(document.createTextNode(n), n), O(t));
}

function vt(t) {
    if (t == null || Pl(t)) {
        return null;
    }
    return t.key;
}

function bt(t, n) {
    if (t == null || Pl(t)) {
        return null;
    }
    const e = Ml(t, hr, n);
    return e ? e.st : null;
}

function _t() {}

function gt(t, n, e, s, o = !0) {
    if (Et(t) && Et(n)) {
        return !1;
    }
    e.$ = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === Rr) {
                continue;
            }
            const i = t[s];
            const c = n?.[s];
            if (!n || !Tt(i, c) && !At(i, c)) {
                if (s === "class") {
                    if (qt(i, c)) {
                        continue;
                    }
                } else if (s === "style" && Mt(i, c)) {
                    continue;
                }
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = i);
                    const t = Ps(e, s);
                    t || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === Rr) {
                continue;
            }
            if ((!t || !rl.call(t, s)) && o) {
                delete n[s];
                const t = Ps(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function Et(t) {
    if (!t) {
        return !0;
    }
    return Ui(t);
}

function St(t, n, e, s = null) {
    let o = e;
    const r = s && pn(s) ? y(s) : null;
    if (Pl(e)) {
        Pt(o);
        return;
    }
    let i = null;
    for (;;) {
        r && o !== s && pn(o) && a(t, r, o);
        const c = o.flags;
        if (c & 3) {
            Rn(t, o);
            Pt(o);
            const r = c & 2 && Ml(o, hr, null) !== null;
            if (r) {
                const e = t.getHostProp(o, Ur);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (Ke(r)) {
                            const n = Ou(r);
                            if (n && r.h & 1) {
                                r.h |= 16;
                                wn(t, o, 128, s);
                                continue;
                            }
                            (r instanceof Ds || r instanceof so) && (r.h & 4 || Rn(t, r));
                            (n || r instanceof Ds && (r.h & 512 || r.ot)) && el(r);
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (S(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? Ll(t.rootVNode, e) : e;
                                let c = su(o);
                                for (;c; ) {
                                    St(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                Rt(t, n, o);
                            }
                        }
                    }
                }
            }
            const i = Al(o);
            if (i) {
                if (o === e) {
                    const n = su(o);
                    if (n) {
                        _n(n);
                        return;
                    }
                    kt(t, o);
                }
            } else {
                const t = su(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            c & 4 && Pt(o);
        }
        if (o === e) {
            return;
        }
        const l = o.nextSibling;
        if (l) {
            o = l;
            continue;
        }
        i = o.parent;
        for (;i; ) {
            if (i === e) {
                return;
            }
            const t = i.nextSibling;
            if (t) {
                o = t;
                break;
            }
            i = i.parent;
        }
        if (i == null) {
            return;
        }
    }
}

function kt(t, n) {
    if (!n.slotParent) {
        return;
    }
    const e = t.getHostProp(n, $r);
    e != null && t.getHostProp(n.slotParent, e) === n && ql(n.slotParent, e, null);
}

function Rt(t, n, e) {
    const s = e.parent;
    if (s) {
        const o = s.flags;
        if (o & 1 && eu(s) === Cr) {
            kt(t, e);
            tu(n, s, e, !0);
        }
    }
}

function Pt(t) {
    t.flags |= 32;
}

function Tt(t, n) {
    if (t === n) {
        return !0;
    }
    return t instanceof so && n instanceof so && It(n, t);
}

function At(t, n) {
    if (t === n) {
        return !0;
    }
    if (Lu(t) && Lu(n)) {
        const e = t instanceof so ? t.it() : t;
        const s = n instanceof so ? n.it() : n;
        return ca(() => e.value === s.value);
    }
    return !1;
}

function Mt(t, n) {
    if (t === n) {
        return !0;
    }
    return vi(t) === vi(n);
}

function qt(t, n) {
    if (t === n) {
        return !0;
    }
    return wi(t) === wi(n);
}

function It(t, n) {
    if (t === n) {
        return !0;
    }
    return n.lt === t.lt && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.ut, t.ut);
}

function xt(t, n) {
    if (!(n instanceof so)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof so && It(s, n)) {
            return !0;
        }
    }
    return !1;
}

const ll = (t, n, e, s, o) => {
    const r = Le(t.fn, n, t);
    if (e) {
        r.hn = m(e, ":");
        r.$ = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, hr));
    if (sr(s)) {
        o = o || t.getHostProp(n, Vr) || Ss;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (Qa(s)) {
        const t = s;
        i = () => je(r, t, [ o || Ss, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => je(r, t, [ o || Ss ]);
    }
    const l = We;
    const u = (e = 0) => si(() => {
        if (!c) {
            t.setHostProp(n, zr, null);
            t.setHostProp(n, Yr, null);
        }
        e > 0 && El(n) && Rn(t, n);
        return oi(i(o), t => oi(r.dn, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < ri) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, Jr);
        if (o) {
            return function r(t, n, e) {
                const s = jt(n);
                let o = n;
                const r = "q-e:qvisible";
                return oi(s, n => {
                    const s = !n;
                    let i = null;
                    for (const c in e) {
                        if (Object.prototype.hasOwnProperty.call(e, c)) {
                            let l = n;
                            let u = c;
                            if (s) {
                                if (c !== r && !c.startsWith("q-d:") && !c.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!i) {
                                    i = Ft();
                                    const n = We;
                                    n && t.ct(i) || (o = Lt(o, i));
                                }
                                l = i;
                            }
                            if (l) {
                                l.type === "script" && c === r && (u = "q-d:qinit");
                                Ct(l, u, e[c]);
                            }
                        }
                    }
                    return o;
                });
            }(t, s, o);
        }
        return s;
    }, t => {
        if (ii(t) && e < ri) {
            return t.then(() => u(++e));
        }
        if (e >= ri) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function Ct(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = pi(n);
    c && Ot(t, f, "capture");
    l && Ot(t, f, "preventdefault");
    u && Ot(t, f, "stoppropagation");
}

function Ot(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === Ss && (t.varProps = {});
    t.varProps[s] = !0;
}

function jt(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (co(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (tr(t)) {
            n.push(...t);
        } else {
            if (ii(t)) {
                return oi(t, t => jt(t));
            }
            if (Lu(t)) {
                return jt(t.untrackedValue);
            }
        }
    }
    return null;
}

function Lt(t, n) {
    if (co(t)) {
        if (t.type !== Ao) {
            return bo(Ao, null, null, [ t, n ], 0, null);
        }
        t.children == null ? t.children = n : tr(t.children) ? t.children.push(n) : t.children = [ t.children, n ];
        return t;
    }
    if ((t => typeof t !== "object" && typeof t !== "function" || t === null || t === void 0)(t)) {
        return bo(Ao, null, null, [ t, n ], 0, null);
    }
    if (tr(t) && t.length > 0) {
        Lt(t[0], n);
        return t;
    }
    return t;
}

function Ft() {
    return new lo("script", null, {
        hidden: ""
    }, null, 0, null);
}

function Xt(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Dt(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = Xt(t[c], c, r, s);
    }
    return i;
}

function Wt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function Vt(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = su(e);
    const f = F(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return sl(c, n, Dt(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        nu(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return sl(c, n, Dt(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        nu(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= r(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const w = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== w; ) {
            const s = t.nextSibling;
            tu(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = w;
        return sl(c, n, Dt(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const m = d - h + 1;
    const b = new Map;
    for (let t = h; t <= d; t++) {
        b.set(a[t], t - h);
    }
    const _ = function v(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const g = [];
    const E = new Map;
    for (let t = 0; t < _.length; t++) {
        const s = _[t];
        const o = s.key;
        if (b.has(o)) {
            E.set(o, g.length);
            g.push(s);
        } else {
            tu(n, e, s, !0);
        }
    }
    const S = new Int32Array(m);
    S.fill(-1);
    const k = [];
    const R = [];
    for (let t = 0; t < m; t++) {
        const n = E.get(a[h + t]);
        if (n !== void 0) {
            S[t] = n;
            R.push(t);
            k.push(n);
        }
    }
    const P = new Uint8Array(m);
    const T = function q(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(k);
    for (let t = 0; t < T.length; t++) {
        P[R[T[t]]] = 1;
    }
    let M = d;
    let A = w;
    const I = () => {
        for (;M >= h; ) {
            const t = M - h;
            if (P[t] === 1) {
                A = g[S[t]];
                M--;
                continue;
            }
            const r = S[t];
            if (r !== -1) {
                const t = g[r];
                const s = A === null ? e.lastChild === t : t.nextSibling === A;
                s || Gl(n, e, t, A);
                A = t;
                M--;
                continue;
            }
            let l = M;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (P[t] === 1 || S[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = M - l + 1;
            const d = sl(c, n, Dt(o, a, null, i, l, M), e, A, A, s, null, !0, f);
            return oi(d, () => {
                const t = Wt(e, A, u);
                A = t;
                M = l - 1;
                return I();
            });
        }
    };
    return I();
}

function Ut(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, Ur);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof Cu) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = Nu(s, n, t);
                ii(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function zt(t, n) {
    const e = t.props ||= {};
    e[ds] = n;
}

function Bt(t, n) {
    t.dirty &= -513;
    const e = function s(t) {
        const n = t.props;
        return n?.[ps] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[ps] = n;
    })(t, null);
    const r = t;
    const i = r.parent;
    const c = r.nextSibling;
    const l = Vl(n, document, r, e);
    const u = Sl(r) && i || r;
    const f = u === r ? null : c;
    zl(n, u, l, f);
    t.dirty &= -65;
    t.dirtyChildren = null;
}

function Qt(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[ds];
    }(t);
    if (!r) {
        return;
    }
    zt(t, null);
    Lu(r) && (r = r.value);
    return il(n, e, r, o, s, null);
}

function Ht(t, n, e, s) {
    const o = t;
    const r = n.getHostProp(o, hr);
    if (r && !r.resolved) {
        return r.resolve();
    }
    t.dirty &= -5;
    if (!r) {
        return;
    }
    const i = n.getHostProp(o, Vr) || null;
    return Yt(n, o, o, r, i, e, s);
}

function Jt(t, n, e, s) {
    t.dirty &= -9;
    const o = t;
    const r = function i(t) {
        const n = t.props;
        const e = n?.[ys] || null;
        e && delete n[ys];
        return e;
    }(t);
    if (!r) {
        return;
    }
    return Yt(n, o, r.subscriptionHost || n.rootVNode, r.componentFn, r.props, e, s);
}

function Yt(t, e, s, o, r, i, c) {
    const l = si(() => ll(t, e, s, o, r), s => {
        const o = t.getHostProp(e, Sr);
        return n(() => il(t, i, s, e, c, fi(o)));
    }, n => {
        t.handleError(n, e);
    });
    if (ii(l)) {
        return l;
    }
    return;
}

function Gt(t, n, e, s, o, r = null) {
    n.push(Go(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Zt(t, n) {
    t.dirty &= -17;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[hs] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        Lu(e) && (e = e.value);
        const r = s.isConst;
        Gt(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[hs];
    })(t);
}

function Kt(t, n) {
    t.dirty &= -129;
    const e = n.getHostProp(t, Ur);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof Cu && n.h & 16) {
            n.h &= -17;
            const t = n;
            el(t);
        }
    }
}

function tn(t, e) {
    t.dirty &= -33;
    const s = e.getHostProp(t, $s);
    if (!s) {
        return;
    }
    const o = s.ft;
    const r = Fe();
    r.$ = e;
    return oi(n(() => Oe.call(s, r, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return Vu(e, s, o);
        }
    });
}

function nn(t, n, e, s) {
    t.dirty &= -257;
    const o = t;
    const r = n.getHostProp(o, Vr) || null;
    if (!r) {
        return;
    }
    let i = As(r, "items");
    Lu(i) && (i = ca(i));
    const c = As(r, "key$");
    const l = As(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return Vt(n, e, o, s, i, u, f);
    }
    return oi(c.resolve(), t => oi(l.resolve(), r => Vt(n, e, o, s, i, t, r)));
}

let ul = null;

const cl = (t, n, e) => {
    ul || (ul = t.insertBefore);
    ul.call(t, n, e);
};

function en(t) {
    let n = null;
    let e = null;
    let s = null;
    const o = new Set;
    const i = () => {
        if (s) {
            if (s.length === 1) {
                cl(n, s[0], e);
            } else {
                const t = n.ownerDocument || n;
                const o = t.createDocumentFragment();
                for (let t = 0; t < s.length; t++) {
                    o.appendChild(s[t]);
                }
                cl(n, o, e);
            }
            s = null;
            n = null;
            e = null;
            o.clear();
        }
    };
    for (let c = 0; c < t.length; c++) {
        const l = t[c];
        if (l instanceof zo) {
            if (n === l.parent && e === l.beforeTarget) {
                s || (s = []);
                s.push(l.target);
                o.add(l.target);
                continue;
            }
            if (!s) {
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (n === l.parent) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (o.has(l.target) || e && l.target === e || n && l.target === n) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            cl(l.parent, l.target, l.beforeTarget);
            continue;
        }
        if (l instanceof Wo) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && i();
            l.target.remove();
            continue;
        }
        if (l instanceof Vo) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && i();
            const t = l.target;
            t.textContent = "";
            continue;
        }
        if (l instanceof Uo) {
            l.target.nodeValue = l.text;
        } else if (l instanceof Bo) {
            const t = l.target;
            const e = l.attrName;
            const s = l.attrValue;
            const o = s != null ? r(e, s, l.scopedStyleIdPrefix) : null;
            const c = o == null || o === !1;
            if (fl(t, e)) {
                t[e] = al(o);
            } else if (e === ni) {
                n === t && i();
                t.innerHTML = o;
                t.setAttribute(xr, "html");
            } else {
                c ? t.removeAttribute(e) : e === "value" && e in t ? t.value = o : E(t, e, o, l.isSvg);
            }
        }
    }
    i();
}

const fl = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const al = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const hl = (t => () => queueMicrotask(t))(on);

const pl = _i(on);

let $l = !1;

function rn() {
    if (!$l) {
        $l = !0;
        hl();
    }
}

function sn() {
    if (!$l) {
        $l = !0;
        pl();
    }
}

function on() {
    $l = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = u(); ) {
        if (ln(e, n)) {
            sn();
            return;
        }
    }
}

function ln(t, n) {
    const e = We;
    const s = y(t);
    const o = s.promise;
    if (o) {
        return;
    }
    const r = s.container;
    if (!t.dirty) {
        un(r, t, s, e);
        return;
    }
    const i = s.journal ||= [];
    let l = null;
    for (;l = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(l.dirty & 1023)) {
            __EXPERIMENTAL__.suspense && A(l);
            p(r, s, an(l, t, r));
            continue;
        }
        if (l.flags & 32) {
            if (l.dirty & 128) {
                Kt(l, r);
            } else if (l.dirty & 64) {
                const n = fn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            }
            l.dirty &= -1024;
            p(r, s, an(l, t, r));
            continue;
        }
        let e;
        try {
            if (l.dirty & 1) {
                e = Ut(l, r, s);
            } else if (l.dirty & 2) {
                e = Qt(l, r, i, t);
            } else if (l.dirty & 4) {
                e = Ht(l, r, i, t);
            } else if (l.dirty & 8) {
                e = Jt(l, r, i, t);
            } else if (l.dirty & 256) {
                e = nn(l, r, i, t);
            } else if (l.dirty & 16) {
                Zt(l, i);
            } else if (l.dirty & 32) {
                e = tn(l, r);
            } else if (l.dirty & 64) {
                const n = fn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            } else {
                l.dirty & 512 && Bt(l, i);
            }
        } catch (t) {
            r.handleError(t, l);
        }
        if (e && ii(e)) {
            P(s, l);
            const n = e;
            s.promise = n;
            c(t, r);
            const o = l;
            n.catch(t => {
                s.promise === n && r.handleError(t, o);
            }).finally(() => {
                if (s.promise !== n) {
                    return;
                }
                s.promise = null;
                f(t, r);
                rn();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    un(r, t, s, e);
}

function un(t, n, e, s) {
    if (!(n.dirty & 1023)) {
        h(n, t);
        s || function o(t, n) {
            const e = y(t);
            const s = e.journal;
            if (s && s.length > 0) {
                en(s);
                e.journal = null;
            }
            (function o(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                for (let n = 0; n < e.length; n++) {
                    const s = e[n];
                    Nu(s, t, s.ht);
                }
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.suspense) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.value = Math.max(0, e.value - 1);
            }
        })(e);
        (function i(t) {
            __EXPERIMENTAL__.suspense && t.props && Zr in t.props && ql(t, Zr, null);
        })(n);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                cn(t);
            });
            return;
        }
        cn(t);
    }
}

function cn(t) {
    t.dt();
}

function fn(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -65;
        A(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = an(o[0], s, t);
    p(t, n, i);
    return i;
}

function an(t, n, e) {
    if (t === n) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 64 ? s = t.slotParent : t.parent && t.parent.dirty & 64 && (s = t.parent);
    if (!s) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 1023) {
            if (e && hn(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -65;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.suspense && A(s);
    return an(s, n, e);
}

function hn(t, n) {
    if (!T(n)) {
        return !1;
    }
    pn(n) || dn(t, n, 0);
    return !0;
}

function dn(t, n, e) {
    if (pn(n)) {
        rn();
        return n;
    }
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        as.set(t, n);
    })(n, s);
    const r = n;
    r.flags |= 256;
    l(t, r);
    rn();
    return r;
}

function pn(t) {
    return (t.flags & 256) !== 0;
}

function $n(t, n) {
    if (!(n.flags & 1)) {
        n.dirty & 16 && function e(t, n) {
            n.dirty &= -17;
            const e = n.getProp(hs);
            if (!e || e.size === 0) {
                return;
            }
            for (const [s, o] of e.entries()) {
                let e = o.value;
                Lu(e) && (e = e.value);
                const i = r(s, e, o.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, s, i);
            }
        }(t, n);
        n.dirty & 32 && tn(n, t);
        n.dirty &= -1024;
        return;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(Ur);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof Cu) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = Nu(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        ii(s) && (e = s);
    }
    if (n.dirty & 256) {
        const s = async function o(t, n) {
            n.dirty &= -257;
            const e = n;
            const s = t.getHostProp(e, Vr) || null;
            if (!s) {
                return;
            }
            let o = As(s, "items");
            Lu(o) && (o = ca(o));
            const r = await As(s, "key$").resolve();
            const i = await As(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -1020;
    if (e) {
        return e;
    }
}

const yl = [];

function yn(t) {
    for (let n = 0; n < yl.length; n++) {
        const e = yl[n];
        const s = yl[n + 1] || t;
        s.dirty |= 64;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function wn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return We;
    }()) {
        const e = $n(t, n);
        ii(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return;
    }
    const i = e & 1023;
    if ((i ? o & 1023 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function t(n, e) {
            yl.push(n);
            let s = T(n);
            let o = n.slotParent || n.parent;
            for (;o; ) {
                const t = o.dirty & 1023;
                const r = pn(o);
                __EXPERIMENTAL__.suspense && (s ||= T(o) || (t ? M(o) : null));
                if (o === e || t) {
                    q(n, s);
                    yn(o);
                    if (r) {
                        const t = y(o);
                        t.position !== o && (t.position = n);
                    }
                    yl.length = 0;
                    return;
                }
                if (r) {
                    const t = y(o);
                    t.position !== o && (t.position = n);
                }
                yl.push(o);
                o = o.slotParent || o.parent;
            }
            yl.length = 0;
            ((t, ...n) => {
                const e = Qe(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(n, s);
        return;
    }
    if (c && c.dirty & 1023) {
        q(n, T(n) || M(c));
        i && (c.dirty |= 64);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if (pn(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = y(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        pn(n) ? q(n, T(n)) : function l(t) {
            yl.push(t);
            let n = T(t);
            let e = t.slotParent || t.parent;
            for (;e; ) {
                const s = pn(e);
                __EXPERIMENTAL__.suspense && (n ||= T(e) || (s ? M(e) : null));
                if (s) {
                    q(t, n);
                    yn(e);
                    yl.length = 0;
                    return !0;
                }
                yl.push(e);
                e = e.slotParent || e.parent;
            }
            q(t, n);
            yl.length = 0;
            return !1;
        }(n) || dn(t, n, 0);
    }
}

function mn(t, n) {
    t.push(n);
}

const wl = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const ml = t => {
    let n = null;
    return e => {
        n || (n = wl(e, t));
        return n.call(e);
    };
};

const vl = (t, n, e = null) => {
    const s = new ls(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const bl = t => {
    const n = new ls(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const _l = (t, n) => {
    const e = new us(-4084, null, null, null, null, t, n);
    return e;
};

const gl = () => {
    const t = new os(null, -4094, null, null, null, null, null, null);
    return t;
};

const El = t => t instanceof ss;

const Sl = t => (t.flags & 1) === 1;

const kl = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const Rl = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const Pl = t => (t.flags & 4) === 4;

const Tl = t => (t.flags & 2) === 2;

const Al = t => {
    const n = t.flags;
    return (n & 2) === 2 && Ml(t, $r, null) !== null;
};

const Wd = t => t;

const Ml = (t, n, e) => {
    if (Sl(t) || Tl(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const ql = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const Il = (t, n, e, s, o = null) => {
    if (Sl(n)) {
        ql(n, e, s);
        mn(t, Go(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const xl = t => {
    if (t.key) {
        return;
    }
    const n = fu(t.node, ti);
    n && (t.key = n);
};

const Nl = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (ai(c)) {
                vn(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== ti && c) {
                if (c.startsWith(xr)) {
                    const t = i.value;
                    t === "html" ? ql(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && ql(e, "value", s.value);
                } else {
                    const t = i.value;
                    ql(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        Ml(e, Br, null) === null && Ml(e, Qr, null) === null || (n.flags |= 64);
    }
};

const Cl = t => {
    if (t._t === "_run") {
        const n = t.getCaptured()?.[0];
        if (sr(n)) {
            return n;
        }
    }
    return t;
};

function vn(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = Cl(Fn(i[t], e));
        c.push(x.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function bn(t, n, e) {
    let s = su(n);
    for (;s; ) {
        if (Pl(s)) {
            jl(t, s);
            e(s, n);
        } else {
            Sl(s) ? e(s, n) : bn(t, s, e);
        }
        s = s.nextSibling;
    }
}

function _n(t) {
    let n = t;
    if (Pl(t)) {
        return;
    }
    let e = null;
    for (;;) {
        const s = su(n);
        if (s) {
            n = s;
            continue;
        }
        if (n === t) {
            return;
        }
        const o = n.nextSibling;
        if (o) {
            n = o;
            continue;
        }
        e = n.parent;
        for (;e; ) {
            if (e === t) {
                return;
            }
            const s = e.nextSibling;
            if (s) {
                n = s;
                break;
            }
            e = e.parent;
        }
        if (e == null) {
            return;
        }
    }
}

const Ol = (t, n, e) => {
    let s = t;
    for (;e && s && Tl(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !Tl(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !Tl(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (Pl(t) && e && Sl(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && Ru(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const jl = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = Zl(n, !0);
        const o = e.node;
        const r = bu(s);
        let i = Ol(n, !1, !0);
        const c = Ol(n, !0, !0);
        const l = o || (c && Sl(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && Pl(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                mn(t, Yo(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = Ol(i, !1, !0);
        }
        i = n;
        for (;i && Pl(i); ) {
            const n = Ol(i, !0, !0);
            const e = !n || !Pl(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    mn(t, Jo(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    mn(t, Yo(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const Ll = (t, n) => {
    let e = t;
    const s = t.node;
    const o = s.qVNodeRefs;
    let r = -1;
    let i;
    const c = typeof n === "string" ? n : "";
    if (typeof n === "string") {
        r = parseInt(c);
        i = o.get(r);
    } else {
        i = n;
        const t = i;
        const s = t.vNode;
        if (s) {
            return s;
        }
        if (__EXPERIMENTAL__.suspense && t._qSegment) {
            e = bl(i);
            xl(e);
            t.vNode = e;
            return e;
        }
    }
    if (El(i)) {
        e = i;
    } else {
        if (__EXPERIMENTAL__.suspense && i._qSegment) {
            e = i.vNode || bl(i);
            xl(e);
        } else {
            let t = i;
            const n = [ i ];
            for (;t && t !== s && !t.vNode; ) {
                t = t.parentElement;
                n.push(t);
            }
            t.vNode && (e = t.vNode);
            for (let t = n.length - 2; t >= 0; t--) {
                e = Dl(e, n[t]);
            }
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = c.length;
        let n = Wl(c, t);
        let s = 0;
        for (;n < t; ) {
            const t = c.charCodeAt(n);
            s *= 26;
            if (t >= 97) {
                s += t - 97;
            } else {
                s += t - 65;
                e = Fl(e, s);
                s = 0;
            }
            n++;
        }
    }
    return e;
};

const Fl = (t, n) => {
    let e = su(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const Xl = [];

const Dl = (t, n) => {
    let e = su(t);
    for (;e && (!(e instanceof ls) || e.node !== n); ) {
        if (Tl(e)) {
            const t = e.nextSibling;
            const n = su(e);
            if (n) {
                t && Xl.push(t);
                e = n;
            } else {
                e = t || (Xl.length ? Xl.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || Xl.pop();
        }
    }
    for (;Xl.length; ) {
        Xl.pop();
    }
    return e;
};

const Wl = (t, n) => {
    let e = t.charCodeAt(0) === 45 ? 1 : 0;
    for (;e < n; ) {
        const n = t.charCodeAt(e);
        if (!(n >= 48 && n <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const Vl = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = vl(o, "errored-host");
    if (kl(e)) {
        Gl(t, r, e, null);
    } else {
        const n = [];
        bn(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            Gl(t, r, n[e], null);
        }
    }
    return r;
};

const Ul = en;

const zl = (t, n, e, s) => {
    const o = Sl(n);
    o && ou(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    Jl(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : Zl(n, !1);
    l && !c && mn(t, Yo(i, l, Ql(t, n, s)?.node ?? null));
    Hl(n, e, s);
    c && (e.flags |= 32);
};

const Bl = (t, n, e, r) => {
    const i = Sl(n);
    i && ou(n);
    const c = e.parent;
    if (e === r) {
        if (c) {
            return;
        }
        r = null;
    }
    Jl(t, c, n, e);
    const l = n.flags & 32;
    const u = !i && n.flags & 2048 ? n.props?.[dr] : null;
    const f = u ? null : i ? n : Kl(n, !1);
    const a = u || f?.node;
    const h = Ql(t, n, r);
    const d = h?.node ?? null;
    const p = Al(e);
    if (p && f && (f.flags & 1536) !== 0) {
        const i = Kl(n, !1);
        const c = Ql(t, n, r)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = o(i, e);
        bn(t, e, n => {
            if (Pl(n)) {
                mn(t, Yo(n.node, a, c));
            } else {
                if ((n.flags & 1536) !== u) {
                    const t = function e(t, n, r, i) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let e = null;
                            let a = null;
                            if (Sl(c)) {
                                e = c.node;
                                const t = eu(c);
                                const l = c.parent;
                                const h = u == null ? n : l && Kl(l, !0);
                                if (h) {
                                    const t = o(h, eu(c));
                                    r = t.elementNamespace;
                                    i = t.elementNamespaceFlag;
                                }
                                const d = su(c);
                                a = s(e, t, r, !d);
                                e.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= i;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (uu(e)) {
                                    const t = qe(e);
                                    if (t) {
                                        const n = su(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(n, i, l, u);
                    t && (n.node = t);
                }
                mn(t, Yo(n.node, a, c));
            }
        });
    } else {
        a && !l && bn(t, e, n => {
            mn(t, Yo(n.node, a, d));
        });
    }
    Hl(n, e, r);
    l && (e.flags |= 32);
};

const Ql = (t, n, e) => {
    let s = null;
    e == null ? Tl(n) && (s = Ol(n, !0, !1)) : s = Tl(e) ? Ol(e, !0, !0) : e;
    s && Pl(s) && jl(t, s);
    return s;
};

const Hl = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const Jl = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && tu(t, n, s, !1);
};

const Yl = (t, n) => {
    let e = n;
    for (;e && Tl(e); ) {
        e = e.lastChild;
    }
    e && Pl(e) && (e.flags & 8) === 0 && jl(t, e);
};

const Gl = (t, n, e, s) => {
    kl(e) ? zl(t, n, e, s) : Bl(t, n, e, s);
};

const Zl = (t, n) => {
    for (;t && !Sl(t); ) {
        if (t.flags & 2048) {
            return t.props?.[dr];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const Kl = (t, n) => {
    for (;t && !Sl(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const tu = (t, n, e, s) => {
    Pl(e) && jl(t, e);
    if (s) {
        const s = Ml(n, ni, null) !== null;
        if (s) {
            return;
        }
        kl(e) ? mn(t, Qo(e.node)) : bn(t, e, n => {
            mn(t, Qo(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const nu = (t, n, e, s = !0) => {
    const o = Zl(n, !0);
    if (o && s) {
        if (kl(n)) {
            mn(t, Ho(n.node));
        } else {
            const e = Kl(n, !1);
            e && e.firstChild === n && e.lastChild === n ? mn(t, Ho(o)) : bn(t, n, n => {
                mn(t, Qo(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const eu = t => {
    const n = Wd(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = vu(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = mu(t);
            switch (n) {
              case Lr:
                return 512;

              case Fr:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const ru = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const iu = (t, n, e) => {
    jl(t, n);
    n.text = e;
    mn(t, Jo(n.node, e));
};

const su = t => {
    if (Pl(t)) {
        return null;
    }
    let n = t.firstChild;
    if (__EXPERIMENTAL__.suspense && n === void 0 && Sl(t) && function e(t) {
        const n = t.getAttribute(Ld);
        if (n === null) {
            return !1;
        }
        const e = wu(t);
        return qu(e) && e.localName === "template" && e.getAttribute(vr) === n && pu(e) === null;
    }(t.node)) {
        return null;
    }
    n === void 0 && (n = ou(t));
    return n;
};

const ou = n => {
    const e = Wd(n);
    let s = e.firstChild;
    if (s === void 0) {
        const n = e.node;
        s = e.parent && uu(n) ? e.firstChild = e.lastChild = null : (n => {
            const e = n.node;
            const s = wu(e);
            const o = bu(e)?.qVNodeData?.get(e);
            const r = ((n, e, s, o) => {
                xl(n);
                __EXPERIMENTAL__.suspense && e._qSegment;
                if (o) {
                    if (o.charCodeAt(0) === fr && o.charCodeAt(1) === fr) {
                        const t = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(o);
                        const e = t.elementVNodeData;
                        o = t.virtualVNodeData;
                        const r = _u(n, s, e);
                        if (!o) {
                            return r;
                        }
                    }
                    return function r(n, e, s, o) {
                        let r = 0;
                        let i = null;
                        let c = null;
                        let l = null;
                        const u = t => {
                            t.flags = t.flags & 4095 | r << 12;
                            r++;
                            c && (c.nextSibling = t);
                            t.previousSibling = c;
                            t.parent = n;
                            i || (n.firstChild = i = t);
                            c = t;
                        };
                        let f = 0;
                        let a = null;
                        let h = null;
                        const d = t => {
                            const n = qu(t);
                            return !n || n && kn(t);
                        };
                        let p = null;
                        gu(e, ($, y, w, m, b, _) => {
                            if (Pu($())) {
                                for (;d(o); ) {
                                    o = pu(o);
                                    if (!o) {
                                        throw rr(27, [ e, $(), b ]);
                                    }
                                }
                                a = null;
                                l = null;
                                let t = 0;
                                for (;Pu($()); ) {
                                    t *= 10;
                                    t += w() - 48;
                                }
                                for (;t--; ) {
                                    const n = bl(o);
                                    xl(n);
                                    u(n);
                                    o = pu(o);
                                    for (;qu(o) && kn(o); ) {
                                        o = pu(o);
                                        if (!o && t > 0) {
                                            throw rr(27, [ e, $(), b ]);
                                        }
                                    }
                                }
                            } else if ($() === 59) {
                                ql(n, Sr, y());
                            } else if ($() === 60) {
                                (p ||= []).push(n);
                                ql(n, hr, y());
                            } else if ($() === 61) {
                                h || (h = Me(s));
                                const t = y();
                                h.Kn(parseInt(t, 10), n);
                            } else if ($() === 62) {
                                ql(n, Vr, y());
                            } else if ($() === 64) {
                                n.key = _();
                            } else if ($() === 91) {
                                ql(n, Ur, y());
                            } else if ($() === 94) {
                                ql(n, zr, y());
                            } else if ($() === 96) {
                                h || (h = Me(s));
                                En(n, y(), h);
                            } else if ($() === 63) {
                                h || (h = Me(s));
                                n.slotParent = Ll(h.rootVNode, y());
                            } else if ($() === 93) {
                                ql(n, kr, y());
                            } else if ($() === 123) {
                                w();
                                u(gl());
                                Au.push(n, i, c, l, r);
                                r = 0;
                                n = c;
                                i = c = null;
                            } else if ($() === fr) {
                                const e = y();
                                const s = decodeURIComponent(t(e));
                                const o = b + e.length + 1;
                                const r = m(o + 1) === fr;
                                let i;
                                if (r) {
                                    w();
                                    i = decodeURI(t(y()));
                                    w();
                                } else {
                                    i = t(y());
                                }
                                ql(n, s, i);
                            } else if ($() === 125) {
                                w();
                                n.lastChild = c;
                                r = Au.pop();
                                l = Au.pop();
                                c = Au.pop();
                                i = Au.pop();
                                n = Au.pop();
                            } else if ($() === 126) {
                                ql(n, $r, _());
                            } else {
                                for (;qu(o) && kn(o); ) {
                                    o = pu(o);
                                }
                                const t = o && au(o) === 3 ? o : null;
                                if (a === null) {
                                    a = t ? t.nodeValue : null;
                                    f = 0;
                                }
                                let n = 0;
                                for (;Tu($()); ) {
                                    n += w() - 97;
                                    n *= 26;
                                }
                                n += w() - 65;
                                const e = a === null ? "" : a.substring(f, f + n);
                                u(l = ((t, n, e) => {
                                    const s = new us(-4092, null, t, null, null, n, e);
                                    return s;
                                })(l, t, e));
                                f += n;
                            }
                        });
                        if (p) {
                            h || (h = Me(s));
                            for (let t = 0; t < p.length; t++) {
                                h.ensureProjectionResolved(p[t]);
                            }
                            p = null;
                        }
                        n.lastChild = c;
                        return i;
                    }(n, o, e, s);
                }
                return _u(n, s, void 0);
            })(n, e, s, o);
            return r;
        })(e);
    }
    return s;
};

let lu = null;

const uu = t => {
    lu || (lu = t.hasAttribute);
    return lu.call(t, xr);
};

let cu = null;

const fu = (t, n) => {
    cu || (cu = t.getAttribute);
    return cu.call(t, n);
};

const au = ml("nodeType");

const hu = t => {
    const n = au(t);
    return n === 3 || n === 1;
};

let du = null;

const pu = t => {
    du || (du = wl(t, "nextSibling"));
    yu || (yu = wl(t, "firstChild"));
    for (;t; ) {
        t = du.call(t);
        if (t !== null) {
            const n = au(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(qr)) {
                    return gn(t, Ar, du, yu);
                }
                if (t.nodeValue?.startsWith(Mr)) {
                    return gn(t, [ Ar, Ir ], du, yu);
                }
                if (n?.startsWith(xr)) {
                    for (;t && (t = du.call(t)) && (au(t) !== 8 || !t.nodeValue?.startsWith(Nr)); ) {}
                }
            }
        }
    }
    return t;
};

function gn(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = $u(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const $u = ml("parentNode");

let yu = null;

const wu = t => {
    yu || (yu = wl(t, "firstChild"));
    t = t && yu.call(t);
    if (t && au(t) === 8) {
        du || (du = wl(t, "nextSibling"));
        if (t.nodeValue?.startsWith(qr)) {
            return gn(t, Ar, du, yu);
        }
    }
    for (;t && !hu(t); ) {
        t = pu(t);
    }
    return t;
};

const mu = ml("namespaceURI");

const vu = ml("nodeName");

const bu = ml("ownerDocument");

const _u = (t, n, e) => {
    let s = null;
    let o = 0;
    const r = () => {
        for (;qu(i) && kn(i); ) {
            i = pu(i);
        }
    };
    let i = n;
    r();
    let c = null;
    for (;i; ) {
        const n = au(i);
        let e = null;
        if (n === 3) {
            e = _l(i, i.textContent ?? void 0);
        } else if (n === 1) {
            e = bl(i);
            xl(e);
        }
        if (e) {
            e.flags = e.flags & 4095 | o << 12;
            o++;
            e.parent = t;
            c && (c.nextSibling = e);
            e.previousSibling = c;
            c = e;
        }
        s || (t.firstChild = s = c);
        i = pu(i);
        r();
    }
    t.lastChild = c || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        gu(e, (e, s) => {
            if (e() === 61) {
                n || (n = Me(t.node));
                const e = s();
                n.Kn(parseInt(e, 10), t);
            } else if (e() === 96) {
                n || (n = Me(t.node));
                En(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function En(t, n, e) {
    if (t[Ki]) {
        const s = t[Ki];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e._(n));
    } else {
        Object.defineProperty(t, Ki, {
            get() {
                const s = e._(n);
                t[Ki] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, Ki, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const gu = (n, e) => {
    let s = 0;
    let o = 0;
    let r = 0;
    const i = t => t < n.length ? n.charCodeAt(t) : 0;
    const c = () => r !== 0 ? r : r = i(s);
    const l = () => {
        o = c();
        r = 0;
        s++;
        return o;
    };
    const u = () => {
        l();
        const t = s;
        for (;c() <= 58 && r !== 0 || r === 92 || r === 95 || r >= 65 && r <= 90 || r >= 97 && r <= 122; ) {
            l();
        }
        return n.substring(t, s);
    };
    const f = () => {
        if (i(s + 1) !== fr) {
            return u();
        }
        l();
        const n = decodeURIComponent(t(u()));
        l();
        return n;
    };
    for (;c() !== 0; ) {
        e(c, u, l, i, s, f);
    }
};

const Eu = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        Nl(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(ti) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const Su = (t, n) => {
    let e = ku(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = ku(e);
    }
    return !1;
};

const ku = t => t.parent || t.slotParent;

const Ru = t => {
    if (t === null || Tl(t)) {
        return null;
    }
    return t.node;
};

function Sn(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if (Sl(e)) {
                        const t = Ie(e.node);
                        if (!t) {
                            return null;
                        }
                        return qe(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (Pl(i)) {
            c.push(In(ru(i)));
        } else if (Tl(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = Eu(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== or && e !== "__scopedStyleIdPrefix__") {
                        const t = Ml(i, e, null);
                        s.push(" " + e + "=" + In(t));
                    }
                }
                i.slotParent && s.push(" slotParent=(C)");
            }
            const l = (o ? "[34m" : "") + (lr[Ml(i, or, null) || "V"] || lr.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = su(i);
            u && c.push("  " + Sn.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if (Sl(i)) {
            const s = eu(i);
            const l = [];
            pn(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? Eu(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = Ml(i, n, null);
                l.push(" " + n + "=" + In(e));
            }
            const f = Ru(i);
            if (f) {
                const t = bu(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + In(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + In(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (Rl(i) || e) {
                const e = su(i);
                e && c.push("  " + Sn.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const Pu = t => 48 <= t && t <= 57;

const Tu = t => 97 <= t && t <= 122;

function kn(t) {
    return !t.hasAttribute(ti) || t.nodeName === "STYLE" && (t.hasAttribute(Sr) || t.hasAttribute(_r));
}

const Au = [];

const Mu = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw rr(26, [ n ]);
};

const qu = t => t && typeof t == "object" && au(t) === 1;

const Iu = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!Tl(t) || Ml(t, hr, null) === null); ) {
            const e = t.slotParent;
            const s = Tl(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function Rn(t, n) {
    El(n) && Sl(n) && ou(n);
    const e = n[Ki];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        Pn(t, n);
    }
    e.clear();
}

function Pn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof Fs) {
            Tn(t, s, n);
            s instanceof Ds && An(s, n);
        } else if (Is(s)) {
            const t = s[bs];
            Mn(t, n);
        } else if (t.$t.has(s)) {
            const e = t.$t.get(s);
            const o = Yu(e);
            Mn(o, n);
        }
    }
    e.clear();
}

function Tn(t, n, e) {
    const s = n.ft;
    s && s.has(e) && s.delete(e);
    if (n instanceof so && !s?.size) {
        n.m = void 0;
        Rn(t, n);
    }
}

function An(t, n) {
    const e = t.yt;
    e && e.has(n) && e.delete(n);
    const s = t.wt;
    s && s.has(n) && s.delete(n);
    t.vt();
}

function Mn(t, n) {
    const e = t?.ft;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const xu = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = Zo();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new Cu(6 | i, r, o.m, t, null);
    s(c);
    const l = o.$;
    const {dn: u} = o;
    const f = oi(u, () => Nu(c, l, o.m));
    ii(f) && (o.dn = f);
};

const Nu = (t, n, e) => {
    const s = t.te;
    if (s) {
        return s;
    }
    t.h &= -5;
    const o = t => {
        zf(t, "hook");
        n.handleError(t, e, "hook");
    };
    let r = null;
    const i = oi(((t, n) => {
        const e = t.ne;
        if (e) {
            return e;
        }
        const s = t.$n;
        if (!s) {
            return;
        }
        t.$n = null;
        try {
            const e = s();
            if (ii(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.ne === s && (t.ne = void 0);
                });
                t.ne = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        const s = Fe(n.fn, e, "qTask");
        s.$ = n;
        const i = t.bt.getFn(s, () => Rn(n, t));
        const c = Ls(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.$n = () => {
                            t.$n = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    ii(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return si(() => i(u), l, s => {
            if (ii(s)) {
                return s.then(() => {
                    t.te === r && (t.te = null);
                    return Nu(t, n, e);
                });
            }
            o(s);
        });
    });
    if (ii(i)) {
        r = i.finally(() => {
            t.te === r && (t.te = null);
        });
        t.te = r;
        return r;
    }
    return i;
};

class Cu extends ts {
    h;
    Xt;
    ht;
    bt;
    $n;
    ne;
    te=null;
    constructor(t, n, e, s, o) {
        super();
        this.h = t;
        this.Xt = n;
        this.ht = e;
        this.bt = s;
        this.$n = o;
    }
}

const Ou = t => t instanceof Cu;

function qn(t, n) {
    const e = Me(n);
    return na(e, () => {
        typeof this === "string" && Ta(Aa(e, this));
        const t = Pa[0];
        if (!t.ht) {
            return;
        }
        t.h |= 4;
        wn(e, t.ht, 1);
    });
}

const ju = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const Lu = t => t instanceof Fs;

const Fu = (t, n) => {
    t.add(n);
};

const Xu = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const Du = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        Ou(e) ? o = e.bt : e instanceof Ds ? o = e.Wt : s === ":" && (o = n.getHostProp(e, hr));
        o && n.serializationCtx.Ft.add(o);
    }
};

const Wu = (t, n) => {
    if (t && (!n || t === n || Dd(t))) {
        return t;
    }
    return n;
};

const Vu = (t, n, e) => {
    const s = Ve;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (Ou(o)) {
                o.h |= 4;
                wn(t, o.ht, 1);
            } else if (o instanceof Fs) {
                o.invalidate();
            } else if (r === ":") {
                wn(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    zt(o, n);
                    wn(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof oo) {
                    const e = i.data;
                    const c = {
                        isConst: e.et,
                        scopedStyleIdPrefix: e.O,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[hs];
                            if (!o) {
                                o = new Map;
                                s[hs] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(hs);
                        if (!n) {
                            n = new Map;
                            t.setProp(hs, n);
                        }
                        n.set(r, c);
                    }
                    wn(t, o, 16);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const Uu = t => Ke(t) && typeof t[Tf] === "function";

const zu = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const Bu = t => {
    t.h |= 4;
};

const Qu = t => {
    const n = t;
    return !!n && !(n.h & 1) && n.Dt !== xs;
};

const Hu = [];

function In(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (Ou(t)) {
            return `Task(${In(t.bt)})`;
        }
        if (sr(t)) {
            return `Qrl(${t._t})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (Hu.includes(t)) {
                return "*";
            }
            Hu.length;
            try {
                Hu.push(t);
                if (Array.isArray(t)) {
                    return El(t) ? "(" + (Ml(t, or, null) || "vnode") + ")" : t.map(In);
                }
                if (Lu(t)) {
                    return t instanceof so ? "WrappedSignal" : t instanceof Ds ? "ComputedSignal" : "Signal";
                }
                if (nc(t)) {
                    return "Store";
                }
                if (co(t)) {
                    return Ju(t);
                }
                if (El(t)) {
                    return "(" + (Ml(t, or, null) || "vnode") + ")";
                }
            } finally {
                Hu.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const Ju = t => {
    if (co(t)) {
        if (typeof t.type === "function") {
            const n = t.type[Ba];
            if (n) {
                const [t] = n;
                return "Component(" + t._t + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + In(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += Ju(e);
                    }
                } else {
                    n += Ju(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const Yu = t => t[Os];

const Gu = t => {
    try {
        return t?.[Cs] || null;
    } catch {
        return null;
    }
};

const Zu = (t, n) => {
    const e = Yu(t);
    e && e.force(n);
};

const Ku = (t, n) => {
    const e = Yu(t);
    if (e) {
        return (e.ft?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const tc = t => Gu(t) || t;

const nc = t => Cs in t;

function xn(t, n, e) {
    return new Proxy(n, new rc(e, t || null));
}

const ec = (t, n, e) => {
    if (Ze(t) && e) {
        let s = e.$t.get(t);
        if (!s) {
            s = xn(e, t, n);
            e.$t.set(t, s);
        }
        return s;
    }
    return t;
};

class rc {
    h;
    $;
    ft=void 0;
    constructor(t, n) {
        this.h = t;
        this.$ = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = Gu(this);
        Vu(this.$, this, On(n, t, this.ft));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === Cs) {
                return t;
            }
            if (n === Os) {
                return this;
            }
            return t[n];
        }
        const e = sa();
        const s = t[n];
        if (e) {
            if (this.$ === null) {
                if (!e.$) {
                    return s;
                }
                this.$ = e.$;
            }
            const o = e.hn;
            o && Nn(t, Array.isArray(t) ? js : n, this, o, e.$);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        let r = !1;
        if (o & 1 && Ke(s)) {
            try {
                r = !Object.isFrozen(s) && !nc(s) && !Object.isFrozen(t);
            } catch {}
        }
        if (r) {
            return ec(s, this.h, this.$);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? tc(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && Cn(n, s, t, this);
        } else {
            Cn(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || Vu(this.$, this, On(t, n, this.ft));
        return !0;
    }
    has(t, n) {
        if (n === Cs) {
            return !0;
        }
        if (typeof n === "string") {
            const e = sa();
            if (e) {
                const s = e.hn;
                s && Nn(t, Array.isArray(t) ? js : n, this, s, e.$);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = sa();
        const e = n?.hn;
        e && Nn(t, js, this, e, n.$);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function Nn(t, n, e, s, o) {
    const r = e.ft ||= new Map;
    let i = r.get(n);
    if (!i) {
        i = new Set;
        r.set(n, i);
    }
    const c = We;
    const l = __EXPERIMENTAL__.suspense && e instanceof rc && c;
    Fu(i, s);
    Xu(s, t);
    if (c) {
        const i = Wu(o, e.$);
        l && i?.Tn?.(t, s, n, r);
        Du(s, i);
    }
}

function Cn(t, n, e, s) {
    e[t] = n;
    const o = On(e, t, s.ft);
    o && Vu(s.$, s, o);
}

function On(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(js);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const ic = Symbol();

const sc = [ void 0, null, !0, !1, "", Es, Ss, xs, js, gs, qo, Ao, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER, ":", ".", "id", "ref" ];

const oc = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER", "':'", "'.'", "'id'", "'ref'" ];

const lc = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription", "SubscriptionPatch", "SubscriptionDataConstTrue", "SubscriptionDataConstFalse", "EffectSubscriptionNoData" ];

function jn(t, n, e) {
    let s = n._t;
    let o = n.gt;
    const r = Ri();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => sr(t) && t._t == ir)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t.Et(null, 0, e) + "";
    } else {
        o || (o = t.St(n.st));
        if (!o) {
            throw rr(14, [ n._t ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    if (c && c.length > 0) {
        let n = 0;
        let e = "";
        for (let s = 0; s < c.length; s++) {
            const o = t.kt(c[s]);
            const r = o - n;
            n = o;
            e += (s === 0 ? "" : " ") + r;
        }
        l = e;
    }
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function Ln(t, n, e, s) {
    return xa(t, n, null, null, e, s);
}

function Fn(t, n) {
    const e = t.indexOf("#");
    const s = t.indexOf("#", e + 1);
    const o = t.slice(0, e);
    const r = s === -1 ? t.slice(e + 1) : t.slice(e + 1, s);
    const i = s !== -1 && s + 1 < t.length ? t.slice(s + 1) : null;
    return Ln(o, r, i, n);
}

class uc {
    rootId;
    subscriptions;
    constructor(t = 0, n = new Set) {
        this.rootId = t;
        this.subscriptions = n;
    }
}

class cc {
    ee;
    re=0;
    Pt=[];
    ie=0;
    se=new Set;
    oe=new Map;
    le;
    ue=new Map;
    ce=0;
    Yt;
    fe=typeof Temporal !== "undefined";
    constructor(t) {
        this.ee = t;
        this.Yt = t.Yt;
    }
    async serialize() {
        const t = this.ce;
        this.ce = 0;
        try {
            await this.outputRoots();
        } finally {
            this.ce = t;
        }
    }
    async serializePatch(t, n, e, s = t) {
        const o = this.ce;
        this.ce = s;
        this.Yt.write(Qi);
        this.ee.ae = 0;
        try {
            this.Yt.write(t + "");
            this.Yt.write(Ji);
            this.Yt.write(Qi);
            await this.outputSelectedRoots(n);
            this.Yt.write(Hi);
            const s = this.getForwardRefsPayload();
            this.ee.ae = s?.length ?? 0;
            if (s || e !== void 0) {
                this.Yt.write(Ji);
                s ? this.outputForwardRefsArray(s) : this.Yt.write("0");
            }
            if (e !== void 0) {
                this.Yt.write(Ji);
                if (typeof e === "number") {
                    this.writeRootRef(e);
                } else if (typeof e === "string") {
                    this.outputString(e);
                } else {
                    this.Yt.write(Bi);
                    this.writeRootRefPath(e);
                    this.Yt.write(Bi);
                }
            }
        } finally {
            this.ce = o;
        }
        this.Yt.write(Hi);
    }
    he(t) {
        this.Yt = t;
    }
    outputArray(t, n, e) {
        this.Yt.write(Qi);
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Yt.write(Ji) : s = !0;
            e(t[n], n);
        }
        this.Yt.write(Hi);
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    rebaseQrlCaptureDeltas$(t, n) {
        let e = 0;
        let s = t;
        const o = n.split(" ");
        for (let t = 0; t < o.length; t++) {
            const n = e + +o[t];
            o[t] = n - s + "";
            e = n;
            s = n;
        }
        return o.join(" ");
    }
    outputShortStringConstant$(t) {
        switch (t) {
          case ":":
            this.output(3, 18);
            return !0;

          case ".":
            this.output(3, 19);
            return !0;

          case "id":
            this.output(3, 20);
            return !0;

          case "ref":
            this.output(3, 21);
            return !0;

          default:
            return !1;
        }
    }
    outputString(t) {
        const n = this.stringNeedsJsonEscape$(t) ? JSON.stringify(t) : Bi + t + Bi;
        let e = -1;
        let s = 0;
        for (;(e = n.indexOf("</", s)) !== -1; ) {
            this.Yt.write(n.slice(s, e));
            this.Yt.write("<\\/");
            s = e + 2;
        }
        this.Yt.write(s === 0 ? n : n.slice(s));
    }
    writeRootRef(t) {
        this.Yt.writeRootRef(t);
    }
    writeRootRefPath(t) {
        this.Yt.writeRootRefPath(t);
    }
    writeRootRefDelta(t, n) {
        this.Yt.writeRootRefDelta(t, n);
    }
    outputStringChunks(t) {
        this.Yt.write(Bi);
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            typeof e === "string" ? this.Yt.write(e) : typeof e === "number" ? this.writeRootRef(e) : "base" in e ? this.writeRootRefDelta(e.id, e.base) : this.writeRootRefPath(e.path);
        }
        this.Yt.write(Bi);
    }
    output(t, n, e) {
        if (t === 1) {
            this.Yt.write(t + Ji);
            if (typeof n === "number") {
                this.writeRootRef(n);
            } else if (typeof n === "string") {
                this.outputString(n);
            } else {
                this.Yt.write(Bi);
                this.writeRootRefPath(n);
                this.Yt.write(Bi);
            }
        } else if (t === 9 && Array.isArray(n)) {
            this.Yt.write(t + Ji);
            this.outputStringChunks(n);
        } else if (typeof n === "number") {
            this.Yt.write(t + Ji + n);
        } else if (typeof n === "string") {
            this.Yt.write(t + Ji);
            this.outputString(n);
        } else {
            this.Yt.write(t + Ji);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.ee.getSeenRef(t);
        const o = !e && this.oe.get(t);
        if (s) {
            s.le && this.isSeenInStreamedRoot(s) && (s = this.ee.de(t));
        } else {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.ee.pe(t, this.le, n);
            }
            s = this.ee.kt(t, !0);
        }
        if (s.le) {
            if (this.le) {
                this.ee.$e(s, t);
            } else {
                this.ee.$e(s, t, n);
                t = this.ee.ye[n];
            }
        }
        if (typeof o === "number") {
            this.Pt[o] = s.Xt;
            this.oe.delete(t);
        }
        const r = t instanceof vc ? t.we : s.Xt;
        if (!this.le && r === n) {
            return s;
        }
        this.output(1, r);
    }
    isSeenInStreamedRoot(t) {
        for (;t.le; ) {
            t = t.le;
        }
        return t.Xt < this.ce;
    }
    writeValue(t, n) {
        if (kf(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                if (t.length === 0) {
                    this.output(3, 4);
                } else {
                    if (this.outputShortStringConstant$(t)) {
                        break;
                    }
                    (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                }
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, t.toString());
                break;

              case "symbol":
                if (t === xs) {
                    this.output(3, 7);
                } else if (t === js) {
                    this.output(3, 8);
                } else if (t === gs) {
                    this.output(3, 9);
                } else {
                    if (t !== ic) {
                        throw rr(20, [ typeof t ]);
                    }
                    this.output(3, 0);
                }
                break;

              case "function":
                if (t === qo) {
                    this.output(3, 10);
                } else if (t === Ao) {
                    this.output(3, 11);
                } else if (sr(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = jn(this.ee, t, !0);
                        let o;
                        if (n !== "") {
                            const r = this.ee.kt(n);
                            const i = this.ee.kt(e);
                            const c = s ? this.rebaseQrlCaptureDeltas$(i, s) : null;
                            o = [ r, "#", {
                                id: i,
                                base: r
                            } ];
                            if (s) {
                                let t = 0;
                                let n = i;
                                let e = 0;
                                o.push("#");
                                for (let r = 0; r <= s.length; r++) {
                                    if (r === s.length || s[r] === " ") {
                                        if (r > e) {
                                            const i = t + +s.slice(e, r);
                                            e > 0 && o.push(" ");
                                            o.push({
                                                id: i,
                                                base: n
                                            });
                                            t = i;
                                            n = i;
                                        }
                                        e = r + 1;
                                    }
                                }
                            }
                            const l = `${r}#${i - r}${c ? "#" + c : ""}`;
                            const u = this.ue.get(l);
                            if (u) {
                                const t = this.ee.kt(u);
                                this.output(1, t);
                                return;
                            }
                            this.ue.set(l, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!Qa(t)) {
                        throw rr(34, [ t.toString() ]);
                    }
                    {
                        const [n] = t[Ba];
                        this.ee.me.add(n._t);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === Es) {
                    this.output(3, 5);
                } else if (t === Ss) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof vc) {
                    this.output(1, t.we);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.le;
                        this.le = e;
                        this.writeObjectValue(t);
                        this.le = n;
                    }
                }
                break;

              default:
                throw rr(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (Is(t)) {
            const n = t[vs];
            this.output(38, [ wc(n), n.varProps, n.constProps, t[bs].ft ]);
        } else if (t instanceof oo) {
            const {O: n, et: e} = t.data;
            n === null ? this.output(e ? 42 : 43, 0) : this.output(39, [ n, e ]);
        } else if (t instanceof Ns) {
            t.data === null ? this.output(44, [ t.consumer, t.property ]) : this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (t instanceof uc) {
            this.output(41, [ t.rootId, t.subscriptions ]);
        } else if (nc(t)) {
            const n = Yu(t);
            const e = Gu(t);
            const s = n.h;
            const o = n.ft;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.ee.$t.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (Uu(t)) {
            const n = t[Tf](t);
            if (ii(n)) {
                const t = this.resolvePromise(n, (t, n) => new fc(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.le.Xt;
                this.le = this.le.le;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        kf(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.ee.ve(t)) {
            this.ee.be(t._e, 16);
            this.output(11, t._e.id);
        } else if (t instanceof Fs) {
            if (t instanceof Vs) {
                const n = function e(t, n) {
                    if (n === xs) {
                        return n;
                    }
                    return oi(t.Wt.resolved || t.Wt.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && Tf in n && (e = n[Tf](n));
                        e === void 0 && (e = xs);
                        return e;
                    });
                }(t, t.Dt);
                if (ii(n)) {
                    const e = this.resolvePromise(n, (n, e) => new fc(34, n, e, t.ft, t.Wt));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.Wt, t.ft, n ]);
                }
                return;
            }
            if (t instanceof so) {
                this.output(31, [ ...Xn(this.ee, t), t.h, t.m, ...t.ft || [] ]);
            } else if (t instanceof Ds) {
                let n = t.Dt;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = kf(t.Dt);
                const i = !!(t.h & 512);
                const c = i && t.Tt !== 0 ? t.Tt : void 0;
                const l = i && t.zt !== 1 ? t.zt : void 0;
                const u = i && t.Qt !== 0 ? t.Qt : void 0;
                const f = i && t.h & -25 || void 0;
                o || r ? n = xs : e ? n = t.Dt : s && (n = xs);
                const a = [ t.Wt, t.ft ];
                if (i) {
                    const n = t.Vt;
                    a.push(t.yt, t.wt, n === void 0 ? n : Lf(n));
                    a.push(f || void 0);
                }
                n === xs && c === void 0 && l === void 0 && u === void 0 || a.push(n === void 0 ? ic : n);
                if (i) {
                    a.push(c);
                    a.push(l);
                    a.push(u);
                }
                this.output(i ? 33 : 32, a);
            } else {
                const n = t.Dt;
                const e = [ n === void 0 ? ic : n ];
                t.ft && e.push(...t.ft);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (t instanceof RegExp) {
            this.output(8, t.toString());
        } else if (t instanceof Error) {
            const n = [ t.message ];
            for (const e of Object.entries(t)) {
                n.push(e[0], e[1]);
            }
            this.output(23, n);
        } else if (this.ee.ge(t)) {
            if (t.vnodeData && t.vnodeData[0] & 32 && /[A-Za-z]/.test(t.id)) {
                this.output(3, 0);
                return;
            }
            const n = this.ee.kt(t);
            this.ee.Ee(t, Dr, n);
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                ac(e, this.ee);
                this.ee.be(t, 16);
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    this.ee.be(n, 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, t.toString());
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (co(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof Cu) {
            const n = [ t.bt, t.h, t.Xt, t.ht ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (ii(t)) {
            const n = this.resolvePromise(t, (t, n) => new fc(24, t, n));
            this.output(2, n);
        } else if (t instanceof fc) {
            if (t.Se === 34) {
                if (t.bt) {
                    this.output(34, [ t.bt, t.ft, t.ke ]);
                } else {
                    if (!t.Re) {
                        console.error(t.ke);
                        throw rr(33);
                    }
                    {
                        const n = this.le.Xt;
                        this.le = this.le.le;
                        this.writeValue(t.ke, n);
                    }
                }
            } else {
                this.output(24, [ t.Re, t.ke ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof yc) {
            const n = t.Pe;
            if (this.getSeenRefOrOutput(n, this.le.Xt, !0)) {
                let t = this.oe.get(n);
                if (t === void 0) {
                    t = this.ie++;
                    this.oe.set(n, t);
                    this.Pt[t] = -1;
                }
                this.output(2, this.getForwardRefId(t));
            }
        } else if (this.fe && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.fe && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.fe && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.fe && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.fe && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.fe && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.fe && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.fe && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else {
            if (!El(t)) {
                throw rr(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.ie++;
        t.then(s => {
            this.se.delete(t);
            this.Pt[e] = this.ee.kt(n(!0, s));
        }).catch(s => {
            this.se.delete(t);
            this.Pt[e] = this.ee.kt(n(!1, s));
        });
        this.se.add(t);
        return this.getForwardRefId(e);
    }
    getForwardRefId(t) {
        return this.ee.Te + t;
    }
    async outputPendingRoots() {
        let t = 0;
        const {ye: n} = this.ee;
        for (;this.re < n.length || this.se.size; ) {
            let e = t > 0;
            for (;this.re < n.length; this.re++) {
                e ? this.Yt.write(Ji) : e = !0;
                this.writeValue(n[this.re], this.re);
                t++;
            }
            if (this.se.size) {
                try {
                    await Promise.race(this.se);
                } catch {}
            }
        }
        return t;
    }
    async outputSelectedRoots(t) {
        let n = !1;
        let e = 0;
        for (;e < t.length || this.se.size; ) {
            if (e < t.length) {
                n ? this.Yt.write(Ji) : n = !0;
                const s = t[e++];
                this.writeValue(this.ee.ye[s], s);
                continue;
            }
            try {
                await Promise.race(this.se);
            } catch {}
        }
    }
    getForwardRefsPayload() {
        let t = this.Pt.length - 1;
        for (;t >= 0 && this.Pt[t] === -1; ) {
            t--;
        }
        if (t < 0) {
            return null;
        }
        return t === this.Pt.length - 1 ? this.Pt : this.Pt.slice(0, t + 1);
    }
    outputForwardRefsArray(t) {
        this.outputArray(t, !0, t => {
            if (typeof t === "string") {
                this.outputString(t);
            } else if (Array.isArray(t)) {
                this.Yt.write(Bi);
                this.writeRootRefPath(t);
                this.Yt.write(Bi);
            } else {
                this.writeRootRef(t);
            }
        });
    }
    async outputRoots() {
        this.Yt.write(Qi);
        const t = await this.outputPendingRoots();
        const n = this.getForwardRefsPayload();
        this.ee.Ae = this.ee.ye.length;
        this.ee.Me = !!n;
        const e = n?.length ?? 0;
        if (n) {
            t > 0 && this.Yt.write(Ji);
            this.Yt.write(14 + Ji);
            this.outputForwardRefsArray(n);
        }
        this.Yt.write(Hi);
        this.ee.qe = this.ee.ye.length + (this.ee.Me ? 1 : 0);
        this.ee.ae = e;
    }
}

class fc {
    Se;
    Re;
    ke;
    ft;
    bt;
    constructor(t, n, e, s, o) {
        this.Se = t;
        this.Re = n;
        this.ke = e;
        this.ft = s;
        this.bt = o;
    }
}

const ac = (t, n) => {
    const e = t.length;
    for (let s = 1; s < e; s++) {
        const e = t[s];
        if (hc(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || typeof s === "number" && t === Dr || t === Vr && (Ui(s) || dc(e, s))) {
                    continue;
                }
                n.kt(s);
            }
        }
    }
};

const hc = t => typeof t === "object" && t !== null && !Ui(t);

const dc = (t, n, e = !1) => {
    if (e || !Object.prototype.hasOwnProperty.call(t, hr)) {
        return !1;
    }
    const s = n[vs];
    return Ui(s.varProps) && !pc(n) && !$c(t[Rr]);
};

const pc = t => !!t[bs].ft?.size;

const $c = t => t instanceof Map && t.has(":");

function Xn(t, n) {
    n.Rt && n.Rt[0] === "{" && (n.Rt = `(${n.Rt})`);
    const e = t.Et(n.Rt, n.ut.length, n.lt);
    return [ e, n.ut ];
}

class yc {
    Pe;
    constructor(t) {
        this.Pe = t;
    }
}

const wc = t => new yc(t);

let mc = () => !1;

class vc {
    we;
    constructor(t) {
        this.we = t;
    }
}

class bc {
    NodeConstructor;
    DomRefConstructor;
    St;
    Ee;
    $t;
    Yt;
    Ie=new Map;
    xe=new Map;
    Ne=0;
    Ce=[];
    ye=[];
    Oe=[];
    je;
    Te=0;
    qe=0;
    ae=0;
    Ae=0;
    Me=!1;
    At=new Set;
    Ft=new Set;
    Lt=new Set;
    me=new Set;
    Le;
    be=(t, n) => {
        t.vnodeData[0] |= n;
    };
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.St = e;
        this.Ee = s;
        this.$t = o;
        this.Yt = r;
        this.Le = new cc(this);
    }
    async Jt() {
        await this.Le.serialize();
    }
    async Fe(t, n, e, s) {
        await this.Le.serializePatch(t, n, e, s);
    }
    he(t) {
        this.Yt = t;
        this.Le.he(t);
    }
    getSeenRef(t) {
        return this.Ie.get(t);
    }
    pe(t, n, e) {
        const s = {
            Xt: e,
            le: n
        };
        this.Ie.set(t, s);
        return s;
    }
    Xe(t) {
        const n = [];
        for (;t.le; ) {
            n.unshift(t.Xt);
            t = t.le;
        }
        n.unshift(t.Xt);
        return n;
    }
    $e(t, n, e) {
        const s = this.Xe(t);
        const o = e === void 0;
        e === void 0 && (e = this.ye.length);
        this.ye[e] = new vc(s);
        o && (this.Oe[e] = n);
        t.le = null;
        t.Xt = e;
        o && this.je?.(e, this.ye[e], n);
    }
    kt(t, n = !1) {
        let e = this.Ie.get(t);
        let s;
        if (e) {
            e.le && this.$e(e, t);
            s = e.Xt;
        } else {
            s = this.ye.length;
            e = {
                Xt: s
            };
            this.Ie.set(t, e);
            this.ye.push(t);
            this.Oe.push(t);
            this.je?.(s, t, t);
        }
        return n ? e : s;
    }
    de(t) {
        const n = this.ye.length;
        const e = {
            Xt: n
        };
        this.Ie.set(t, e);
        this.ye.push(t);
        this.Oe.push(t);
        this.je?.(n, t, t);
        return e;
    }
    De(t, n) {
        const e = this.ye.length;
        const s = {
            Xt: e
        };
        this.Ie.set(n, s);
        this.ye.push(t);
        this.Oe.push(n);
        return e;
    }
    ge(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    ve(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    We(t) {
        const n = this.Ie.get(t);
        return n && (n.le ? void 0 : n.Xt);
    }
    Et(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || e.toString());
        let o = this.xe.get(t);
        if (o === void 0) {
            o = this.Ne + this.Ce.length;
            this.xe.set(t, o);
            if (s) {
                this.Ce.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.Ce.push(e += ")=>" + t);
            }
        }
        return o;
    }
    Ve(t, n) {
        this.Ne = t;
        if (n) {
            this.xe.clear();
            for (let t = 0; t < n.length; t++) {
                this.xe.set(n[t], t);
            }
        }
    }
}

const _c = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = Object.assign(zi(n => {
            t.push(n);
        }), {
            toString: () => t.join("")
        });
    }
    mc = n ? t => t instanceof n : () => !1;
    return new bc(t, n, e, s, o, r);
};

const gc = (t, n) => t[n];

const Ec = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        nc(t) && (t = Gu(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!Ec(ca(gc, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!Ec(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (Ou(t)) {
            return !0;
        }
        if (Is(t)) {
            return !0;
        }
        if (ii(t)) {
            return !0;
        }
        if (co(t)) {
            return !0;
        }
        if (Uu(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof oo) {
            return !0;
        }
        if (mc?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (sr(t) || Qa(t) || t === qo || t === Ao) {
            return !0;
        }
    } else if (t === gs || t === xs || t === js) {
        return !0;
    }
    return !1;
};

const Sc = (t, n) => {
    let e = El(t) ? Sn.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (Ke(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let kc = !1;

const Rc = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && (kc = !0);
            const n = `{${Ke(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${Sc(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = Tc(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${Rc(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${Pc(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = kc ? "" : `(${JSON.stringify(t).length} chars)`;
        kc = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const Pc = t => lc[t] || `Unknown(${t})`;

const Tc = t => oc[t] || `Unknown(${t})`;

function Dn(t, n, e, s = 0) {
    const o = Wn(t, n, s);
    for (;!o.next().done; ) {}
}

function* Wn(t, n, e = 0) {
    const s = (t, n) => t === 1 && typeof n === "string" && n.indexOf(" ") !== -1;
    const o = t => t === 14;
    const r = n => {
        const e = t[n + 1].split(" ");
        const s = parseInt(e[0], 10);
        let o = t;
        let r = 1;
        let i = 0;
        let c = 0;
        let l = null;
        for (let n = 0; n < e.length; n++) {
            l = o;
            i = (n === 0 ? s : parseInt(e[n], 10)) * 2;
            c = i + 1;
            const u = o;
            r = u[i];
            o = u[c];
            if (r === 1) {
                const n = typeof o === "string" ? parseInt(o, 10) : o;
                const e = n * 2;
                r = t[e];
                o = t[e + 1];
            }
        }
        if (l) {
            l[i] = 1;
            l[c] = n / 2;
        }
        t[n] = r;
        t[n + 1] = o;
    };
    for (let i = e; i < t.length; i += 2) {
        s(t[i], t[i + 1]) ? r(i) : o(t[i]) && (n.Pt = t[i + 1]);
        yield;
    }
}

const Ac = new WeakMap;

const Mc = /^[A-Za-z0-9+/]*$/;

const qc = t => {
    const n = t.Ht === void 0;
    t.Ht ??= new Map;
    return n;
};

const Ic = (t, n) => {
    if (n) {
        t.Ht.clear();
        t.Ht = void 0;
    }
};

const xc = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t._(e);

      case 2:
        const s = t.Zt(e);
        return s === -1 || s === void 0 ? gs : t._(s);

      case 14:
        return e;

      case 3:
        return sc[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const s = e;
                const o = s.indexOf("#");
                const r = s.indexOf("#", o + 1);
                const i = +s.slice(0, o);
                const c = r === -1 ? +s.slice(o + 1) : +s.slice(o + 1, r);
                const l = i + c;
                const u = t._(i);
                const f = t._(l);
                n = Ln(u, f, r !== -1 ? s : null, t);
            } else {
                n = Ln("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new Cu(-1, -1, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return za(null);

      case 30:
        return new Fs(t, 0);

      case 31:
        return new so(t, null, null, null);

      case 32:
        return new Ds(t, null);

      case 33:
        return new Us(t, null, void 0, {});

      case 34:
        return new Vs(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = xc(t, s, o);
            const i = ec(r, 0, t);
            df(s) && t.Ht.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new lo(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        Ac.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        {
            if (!(t => {
                if (typeof t !== "string" || !Mc.test(t)) {
                    return !1;
                }
                const n = t.length % 4;
                if (n === 0) {
                    return !0;
                }
                if (n === 1) {
                    return !1;
                }
                const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(t[t.length - 1]);
                return (e & (n === 2 ? 15 : 3)) === 0;
            })(e)) {
                throw rr(38);
            }
            const t = e.length;
            const n = Math.floor(t / 4);
            const s = t % 4;
            const o = n * 3 + (s ? s - 1 : 0);
            return new Uint8Array(o);
        }

      case 38:
        return w(null);

      case 10:
        return Vn(t, e);

      case 11:
        const l = Vn(t, e);
        if (El(l)) {
            ou(l);
            return Ru(l);
        }
        throw rr(17, [ typeof l ]);

      case 39:
        return new oo({});

      case 42:
        return new oo({
            O: null,
            et: !0
        });

      case 43:
        return new oo({
            O: null,
            et: !1
        });

      case 40:
      case 44:
        return new Ns(null, null, null, null);

      case 41:
        return new uc;

      default:
        throw rr(18, [ n ]);
    }
};

function Vn(t, n) {
    return n ? t.rootVNode ? Ll(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const Nc = (t, n, e) => {
    let s = null;
    let o = null;
    if (er(t)) {
        o = t;
    } else {
        if (!nr(t)) {
            throw rr(7, [ t ]);
        }
        s = t;
    }
    return xa(s, n, null, o, e);
};

const Cc = (t, n, e) => xa(null, n, t, null, e);

const Oc = (t, n) => xa(null, t, null, null, n);

const jc = (t, n, e) => {
    const s = Oc(t, e);
    return s;
};

const Lc = (t, n, e, s) => xa(t, e, null, n, s);

const Fc = (t, n, e, s, o) => {
    const r = Lc(t, n, e, o);
    r.Ue(s);
    return r;
};

const Xc = (t, n, e, s) => {
    const o = Nc(t, n, s);
    return o;
};

const Dc = (t, n, e, s) => {
    const o = Cc(t, n, s);
    return o;
};

const Wc = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

const Vc = () => {
    const t = globalThis.process;
    return t?.getBuiltinModule?.("node:async_hooks")?.AsyncLocalStorage;
};

function Un(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const Uc = (t, n, e) => new so(null, t, n, e || null);

class zc {
    ze;
    $t;
    Rn=null;
    xt=!1;
    fn;
    _;
    pn;
    Be=0;
    Kt=null;
    Qe=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.pn = t;
        this.fn = n;
        this.ze = Yi;
        this.$t = new WeakMap;
        this._ = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return ha(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        return _c(t, n, e, this.setHostProp.bind(this), this.$t, s);
    }
    dt() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

const Bc = Symbol();

const Vd = t => {
    const n = () => {
        throw Error("Internal server component must be handled by the SSR renderer.");
    };
    n[Bc] = t;
    return n;
};

class Qc {}

class Hc {}

const Jc = t => {
    const n = t.Mt;
    return !!n && (n.vnodeData[0] & 32) !== 0;
};

const Yc = t => {
    t.catch(() => {});
};

function zn(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function Bn(t, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    const i = t => {
        Yc(t);
        o.push(t);
        o.push(Promise);
    };
    await (async () => {
        for (;o.length; ) {
            let e = "render";
            try {
                const c = o.pop();
                if (c === Qc) {
                    const s = o.pop();
                    if (__EXPERIMENTAL__.errorBoundary && Jc(t)) {
                        continue;
                    }
                    e = "hook";
                    await n(() => o.push(s()));
                    continue;
                }
                if (__EXPERIMENTAL__.errorBoundary && c === Hc) {
                    const n = o.pop();
                    if (Jc(t)) {
                        continue;
                    }
                    const e = n.apply(t);
                    ii(e) && await e;
                    continue;
                }
                if (typeof c === "function") {
                    if (c === Promise) {
                        const n = o.pop();
                        if (__EXPERIMENTAL__.errorBoundary && Jc(t)) {
                            continue;
                        }
                        o.push(await n);
                    } else {
                        const n = c.apply(t);
                        ii(n) && await n;
                    }
                    continue;
                }
                if (__EXPERIMENTAL__.errorBoundary && Jc(t)) {
                    ii(c) && c.catch(() => {});
                    continue;
                }
                Hn(t, r, i, c, s);
            } catch (n) {
                t.handleError(n, t.getOrCreateLastNode(), e);
            } finally {
                const n = t.streamHandler.waitForPendingFlush();
                ii(n) && await n;
            }
        }
    })();
}

function Qn(t, n) {
    t(n);
    __EXPERIMENTAL__.errorBoundary && typeof n === "function" && t(Hc);
}

function Hn(t, n, e, s, o) {
    if (s == null) {
        t.textNode("");
    } else if (typeof s === "boolean") {
        t.textNode("");
    } else if (typeof s === "number") {
        t.textNode(s + "");
    } else if (typeof s === "string") {
        t.textNode(s);
    } else if (typeof s === "object") {
        if (Array.isArray(s)) {
            for (let t = s.length - 1; t >= 0; t--) {
                Qn(n, s[t]);
            }
        } else if (Lu(s)) {
            (function e(t, n) {
                const e = n instanceof so ? n.it() : n;
                if (e instanceof Ds) {
                    const n = e.Tt;
                    if (n && !(e.h & 256)) {
                        t.kt(e);
                        t.At.add(e);
                    }
                }
            })(t.serializationCtx, s);
            t.openFragment(Ss);
            const o = t.getOrCreateLastNode();
            const r = s instanceof so ? s.it() : s;
            n(t.closeFragment);
            n(() => ha(r, o, ".", t));
            n(Qc);
        } else if (ii(s)) {
            t.openFragment(Ss);
            n(t.closeFragment);
            e(s);
            n(() => t.streamHandler.flush());
        } else if (function r(t) {
            return !!t[Symbol.asyncIterator];
        }(s)) {
            n(async () => {
                if (__EXPERIMENTAL__.errorBoundary && Jc(t)) {
                    return;
                }
                const n = () => ({
                    currentStyleScoped: o.currentStyleScoped,
                    parentComponentFrame: o.parentComponentFrame
                });
                try {
                    for await (const e of s) {
                        await Bn(t, e, n());
                        await t.streamHandler.flush();
                    }
                } catch (e) {
                    t.handleError(e, t.getOrCreateLastNode(), "render");
                    await Bn(t, null, n());
                }
            });
        } else {
            const r = s;
            const i = r.type;
            if (typeof i === "string") {
                (function e(t, n) {
                    const e = Ts(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(r, o.currentStyleScoped);
                let s = null;
                const c = t.openElement(i, r.key, r.varProps, r.constProps, o.currentStyleScoped, s, !!(r.flags & 4));
                c && t.htmlNode(c);
                __EXPERIMENTAL__.errorBoundary && Ts(r, br) && n(((t, n) => {
                    const e = t.Mt;
                    t.Mt = n;
                    return () => {
                        t.Mt = e;
                    };
                })(t, t.getOrCreateLastNode()));
                n(t.closeElement);
                if (i === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (i === "body") {
                    n(t.additionalBodyNodes);
                } else {
                    const n = t;
                    if (!t.isHtml && !n._didAddQwikLoader && !t.qt) {
                        t.emitQwikLoaderAtTopIfNeeded();
                        t.emitPreloaderPre();
                        n._didAddQwikLoader = !0;
                    }
                }
                const l = r.children;
                l != null && Qn(n, l);
            } else if (er(i)) {
                if ((__EXPERIMENTAL__.suspense || __EXPERIMENTAL__.errorBoundary) && (t => typeof t === "function" && Bc in t)(i)) {
                    n(() => (t => t[Bc])(i)(t, r, o, n));
                    return;
                }
                if (i === Ao) {
                    const e = r.key != null ? {
                        [Wr]: r.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = r.children;
                    s != null && Qn(n, s);
                } else if (i === qo) {
                    const e = o.parentComponentFrame;
                    if (e) {
                        const s = e.componentNode.id || "";
                        const i = {};
                        i[yr] = s;
                        t.openProjection(i);
                        const c = e.componentNode;
                        const l = t.getOrCreateLastNode();
                        const u = R(c, r, t);
                        i[$r] = u;
                        n(zn(o, o.currentStyleScoped, o.parentComponentFrame));
                        n(t.closeProjection);
                        const f = r.children || null;
                        const a = e.consumeChildrenForSlot(l, u) || f;
                        f && a !== f && t.addUnclaimedProjection(e, "", f);
                        Qn(n, a);
                        n(zn(o, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = Ss;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (i === No) {
                    t.commentNode(Ts(r, "data") || "");
                } else if (i === Oo) {
                    t.streamHandler.flush();
                    const s = r.children;
                    let i;
                    i = er(s) ? s({
                        async write(n) {
                            await Bn(t, n, {
                                currentStyleScoped: o.currentStyleScoped,
                                parentComponentFrame: o.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : s;
                    ii(i) ? e(i) : n(i);
                } else if (i === xo) {
                    t.htmlNode(Ts(r, "data"));
                } else if (i === Co) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    Qn(n, r.children);
                } else if (Qa(i)) {
                    const e = {};
                    t.openComponent(e);
                    const s = t.getOrCreateLastNode();
                    n(zn(o, o.currentStyleScoped, o.parentComponentFrame));
                    n(() => t.closeComponent());
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(r.children, o.currentStyleScoped, o.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[Ba];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(hr, o);
                        s.setProp(Vr, r);
                        n.key !== null && s.setProp(Wr, n.key);
                        return ll(t, s, s, o, r);
                    })(t, r, i);
                    if (ii(l)) {
                        Yc(l);
                        n(async () => {
                            await t.streamHandler.flush();
                            const e = await l;
                            const r = fi(s.getProp(Sr));
                            n(e);
                            n(zn(o, r, c));
                        });
                    } else {
                        n(l);
                        const t = fi(s.getProp(Sr));
                        n(zn(o, t, c));
                    }
                } else {
                    const s = {
                        [Wr]: r.key
                    };
                    t.openFragment(s);
                    n(t.closeFragment);
                    const o = t.getParentComponentFrame();
                    const c = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return ll(t, o, n, e, s.props);
                    })(t, o && o.componentNode, i, r);
                    ii(c) ? e(c) : n(c);
                }
            }
        }
    }
}

function Jn(t, n, e, s) {
    if (!__EXPERIMENTAL__.errorBoundary) {
        throw n;
    }
    for (let o = e; o; o = o.parentComponent) {
        const e = Gn(o);
        if (!e || !e.It) {
            continue;
        }
        if (t.xt && e.Nt) {
            throw n;
        }
        Bf(e, n, s);
        Zi(t).Ct = !0;
        t.xt && Vf(e);
        Yn(t, o, e);
        return;
    }
    throw n;
}

function Yn(t, n, e) {
    const s = new Map;
    let o = null;
    let r = 0;
    for (let t = n; t; t = t.parentComponent) {
        t.id && s.set(t.id, {
            node: t,
            depth: r++
        });
        if (t !== n && !o) {
            const n = Gn(t);
            n?.error === void 0 && k(t.getProp(Vr)) || (o = t);
        }
    }
    const i = {
        node: null,
        depth: -1
    };
    const c = n.children;
    if (c) {
        for (let n = 0; n < c.length; n++) {
            Zn(t, c[n], s, i);
        }
    }
    if (i.node) {
        const s = i.node.parentComponent;
        if (i.node === n) {
            t.Ot(o);
        } else if (s?.id) {
            t.Ot(s);
            e.projectedContentOwner = s;
        }
    }
}

function Gn(t) {
    const n = t.getProp(kr);
    return n ? Ye(n, xf.id, 0) : null;
}

function Zn(t, n, e, s) {
    n.vnodeData[0] |= 32;
    const o = n.getProp(yr);
    if (o) {
        const t = e.get(o);
        if (t) {
            t.node.removeProp(n.getProp($r) ?? "");
            if (t.depth > s.depth) {
                s.node = t.node;
                s.depth = t.depth;
            }
        }
    }
    Rn(t, n);
    const r = n.getProp(Ur);
    if (r) {
        for (let n = 0; n < r.length; n++) {
            const e = r[n];
            Ou(e) && Rn(t, e);
        }
    }
    const i = n.children;
    if (i) {
        for (let n = 0; n < i.length; n++) {
            Zn(t, i[n], e, s);
        }
    }
}

const Gc = () => Pa;

const Zc = async t => {
    const [n, e] = Pa;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = xn(n.$, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const Kc = (t, n) => {
    const {val: e, set: s, iCtx: o} = Zo();
    if (e) {
        return e;
    }
    const r = xa(null, "_rsc", Zc, null, [ t, {} ], o.$);
    const i = Qs(r, {
        timeout: n?.timeout,
        container: o.$,
        concurrency: 0
    });
    i.p();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const tf = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (ii(t)) {
        return t.then(n, s);
    }
    const o = nf(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s && r.error) {
        return s(r.error);
    }
    const i = o ? r.value?.r : r.value;
    return ii(i) ? i.then(n, s) : n(i);
};

const nf = t => t && t.__brand === "resource";

function Kn(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o == null ? o = t : typeof o === "string" && typeof t === "string" ? o += "|" + t : o = [ ...typeof o === "string" ? [ o ] : o, "|", ...typeof t === "string" ? [ t ] : t ];
    };
    const c = n => {
        n._t.startsWith("_") || !Array.isArray(n.jt) && !s || (n = xa(null, "_run", N, null, [ n ]));
        return function e(t, n) {
            const [e, s, o] = jn(t, n, !0);
            const r = `${e}#${s}`;
            if (!o) {
                return r;
            }
            const i = [ r, "#" ];
            let c = 0;
            let l = 0;
            for (let t = 0; t <= o.length; t++) {
                if (t === o.length || o[t] === " ") {
                    if (t > l) {
                        const n = c + +o.slice(l, t);
                        if (l > 0) {
                            i.push(" ");
                            i.push({
                                id: n,
                                base: c
                            });
                        } else {
                            i.push(n);
                        }
                        c = n;
                    }
                    l = t + 1;
                }
            }
            return i;
        }(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (sr(o)) {
                i(c(o));
                te(t, n, o);
            } else if (o != null) {
                const e = Kn(t, n, o, s);
                e && i(e);
            }
        }
    } else if (sr(r)) {
        o = c(r);
        te(t, n, r);
    }
    return o;
}

function te(t, n, e) {
    const s = pi(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.Lt.add(r);
        t.Ft.add(e);
    }
}

const ef = (t, n, e) => {
    of(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const rf = (t, n, e) => {
    of(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const sf = (t, n, e) => {
    of(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const of = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = lf();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + di(i), e, s);
            }
        } else {
            r(t + di(n), e, s);
        }
    }
};

const lf = () => {
    const t = la();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, Jr);
    if (s === null) {
        s = {};
        t.$.setHostProp(e, Jr, s);
    }
    let o = t.$.getHostProp(e, Yr);
    o === null && (o = 0);
    t.$.setHostProp(e, Yr, o + 1);
    let r = t.$.getHostProp(e, Gr);
    if (r === null) {
        r = [];
        t.$.setHostProp(e, Gr, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const uf = function(t, n) {
    const e = Me(n);
    return na(e, () => {
        typeof this === "string" && Ta(Aa(e, this));
        const s = Pa?.[1];
        const o = s ?? n.getAttribute("data-qwik-inspector");
        if (!o || !t.detail.files.some(t => o.startsWith(t))) {
            return;
        }
        const r = Pa?.[0];
        if (!r || r.flags & 32) {
            return;
        }
        wn(e, r, 4);
        const i = n.ownerDocument;
        i.__hmrDone = i.__hmrT;
    });
};

let cf;

function ne(t) {
    const n = sa();
    if (!n) {
        return;
    }
    cf ||= Cc(uf, "_hmr");
    const e = n.m;
    const s = cf.w([ e, t ]);
    rf("qHmr", s);
}

function ee(t, n, e, s, o) {
    const r = gl();
    ql(r, $r, o);
    r.parent = n;
    ql(n, o, r);
    ql(r, hr, e);
    ql(r, Vr, s);
    r.dirty = 4;
    dn(t, r, 1);
    return r;
}

function re(t, n) {
    ql(t, dr, n);
    t.flags |= 2048;
}

function ie(t, n, e) {
    ql(n, Vr, e);
    wn(t, n, 4);
}

function se(t, n, e, s) {
    ql(n, s, null);
    const o = [];
    St(t, o, e);
    Ul(o);
    if (e.flags & 2048) {
        const t = Ml(e, dr, null);
        t && t.replaceChildren();
        ql(e, dr, null);
        e.flags &= -2049;
    }
}

let ff = Promise.resolve();

const af = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const hf = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !af.has(t));
};

function* oe(t, n, e = Array(n.length / 2)) {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = yield* ue(t, n[s], n[s + 1]);
        yield;
    }
    return e;
}

function* le(t, n, e = Array(n.length / 2)) {
    const s = qc(t);
    const o = n.length / 2;
    const r = new Uint8Array(o);
    const i = t._;
    const c = s => {
        if (!r[s]) {
            r[s] = 1;
            const o = s * 2;
            const i = n[o];
            const c = n[o + 1];
            e[s] = i === 0 ? c : xc(t, i, c);
        }
        return e[s];
    };
    t._ = t => c(typeof t === "string" ? parseInt(t, 10) : t);
    try {
        for (let t = 0; t < o; t++) {
            c(t);
            yield;
        }
        for (let s = 0; s < o; s++) {
            const o = s * 2;
            const r = n[o];
            const i = n[o + 1];
            const c = e[s];
            n[o] = 0;
            n[o + 1] = c;
            df(r) && (yield* ce(t, c, r, i));
            yield;
        }
    } finally {
        t._ = i;
        Ic(t, s);
    }
    return e;
}

function* ue(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = xc(t, n, e);
    df(n) && (yield* ce(t, s, n, e));
    return s;
}

function* ce(t, n, e, s) {
    if (e === 0) {
        return;
    }
    if (e === 5 && s !== 0 && !Array.isArray(s)) {
        throw Error("Invalid Object payload");
    }
    e !== 4 && Array.isArray(s) && (s = yield* oe(t, s));
    switch (e) {
      case 4:
        yield* oe(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!hf(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
                yield;
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = Ac.get(t);
            if (e) {
                if (Ac.has(o)) {
                    throw rr(37);
                }
                r(o);
            } else {
                i(o);
            }
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                const s = t[e];
                const o = t[e + 1];
                hf(s, o) && (n[s] = o);
                yield;
            }
            break;
        }

      case 28:
        {
            const t = n;
            const e = s;
            t.bt = e[0];
            t.h = e[1];
            t.Xt = e[2];
            t.ht = e[3];
            break;
        }

      case 29:
        n[Ba][0] = s[0];
        break;

      case 30:
        {
            const t = n;
            const e = s;
            t.Dt = e[0];
            t.ft = new Set(e.slice(1));
            ae(t.ft, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.lt = t.getSyncFn(o[0]);
            e.ut = o[1];
            e.Dt = xs;
            e.h = o[2];
            e.h |= 1;
            e.m = o[3];
            e.ft = new Set(o.slice(4));
            (function r(t) {
                if (t.m !== null && El(t.m)) {
                    const n = t.m;
                    const e = t.ft;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (nr(e)) {
                                const o = Ml(n, e, null);
                                if (o !== null) {
                                    t.Dt = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = su(n);
                        e && n.firstChild === n.lastChild && Pl(e) && (t.Dt = ru(e));
                    }
                }
            })(e);
            ae(e.ft, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.Wt = e[0];
            e[1] && (t.ft = new Set(e[1]));
            e[2] && (t.yt = new Set(e[2]));
            e[3] && (t.wt = new Set(e[3]));
            e[4] && (t.Vt = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.Ut = !0);
            const o = e.length > 6;
            o && (t.Dt = e[6]);
            t.Dt !== xs || t.Vt || (t.h |= 1);
            const r = e[7] ?? 0;
            t.expires = Math.abs(r);
            r < 0 && (t.h |= 256);
            if (e[8] !== void 0 && e[8] !== 1) {
                t.zt = e[8] ?? 1;
                t.Bt = [];
            }
            t.Qt = e[9] ?? 0;
            ae(t.ft, t);
            ae(t.yt, t);
            ae(t.wt, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.Wt = r[0];
            const i = o.Wt.resolve(t).catch(() => {});
            ff = ff.finally(() => i);
            r[1] && (o.ft = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Dt = r[2]);
            e !== 34 && o.Dt !== xs && (o.h &= -2);
            ae(o.ft, o);
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 38:
        {
            const t = n;
            const e = s;
            let o = e[0];
            if (o === gs) {
                o = new lo(Ao, null, null, null, 0, null);
                o.varProps = e[1];
                o.constProps = e[2];
                o._proxy = t;
            }
            t[vs] = o;
            const r = t[bs];
            r.ft = e[3];
            he(r.ft, t);
            break;
        }

      case 39:
        {
            const t = n;
            t.data.O = s[0];
            t.data.et = s[1];
            break;
        }

      case 42:
      case 43:
        break;

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            fe(t);
            break;
        }

      case 41:
        {
            const t = n;
            const e = s;
            t.rootId = e[0];
            t.subscriptions = e[1];
            break;
        }

      case 44:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = null;
            fe(t);
            break;
        }

      case 27:
        {
            const t = n;
            const e = atob(s);
            for (let n = 0; n < e.length; n++) {
                t[n] = e.charCodeAt(n);
                (n & 31) === 31 && (yield);
            }
            break;
        }

      case 35:
        {
            const e = tc(n);
            const o = t.Ht.get(e);
            if (o) {
                t.Ht.delete(e);
                yield* ce(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = Yu(n);
            c.h = r;
            c.ft = i;
            he(c.ft, e);
            break;
        }

      default:
        throw rr(16, [ e ]);
    }
}

function fe(t) {
    const n = We;
    const e = t.consumer;
    if (n && !e) {
        return;
    }
    e[Ki] ||= new Map;
    e[Ki].set(t.property, t);
}

function ae(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function he(t, n) {
    if (t) {
        for (const [, e] of t) {
            ae(e, n);
        }
    }
}

const df = t => t >= 23 || t === 4 || t === 5;

const pf = new WeakMap;

const $f = Symbol();

const yf = (t, n) => {
    if (!Array.isArray(n) || El(n) || (t => Ke(t) && $f in t)(n)) {
        return n;
    }
    let e = pf.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new wf(t, n));
        pf.set(n, e);
    }
    return e;
};

class wf {
    $;
    He;
    constructor(t, n) {
        this.$ = t;
        this.He = n;
    }
    get(t, n, e) {
        if (n === $f) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.He.length / 2) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.He[o];
        const i = this.He[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.$;
        const l = qc(c);
        try {
            const e = xc(c, r, i);
            Reflect.set(t, n, e);
            this.He[o] = 0;
            this.He[o + 1] = e;
            df(r) && ((t, n, e, s) => {
                const o = qc(t);
                try {
                    const o = ce(t, n, e, s);
                    for (;!o.next().done; ) {}
                } finally {
                    Ic(t, o);
                }
            })(c, e, r, i);
            return e;
        } finally {
            Ic(c, l);
        }
    }
    has(t, n) {
        if (n === $f) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === $f) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.He.length / 2) {
            return o;
        }
        const i = r * 2;
        this.He[i] = 0;
        this.He[i + 1] = e;
        return !0;
    }
}

const mf = t => {
    if (!t.Je) {
        t.Je = !0;
        t.Ye();
    }
};

const vf = (t, n, e) => {
    const s = {
        Ge: t,
        Ye: void 0,
        Je: !1
    };
    const o = _i(() => {
        ((t, n, e) => {
            t.Je = !1;
            const s = performance.now() + 10;
            let o = 0;
            try {
                for (;;) {
                    const e = t.Ge.next();
                    if (e.done) {
                        n(e.value);
                        return;
                    }
                    if ((31 & ++o) === 0 && performance.now() >= s) {
                        mf(t);
                        return;
                    }
                }
            } catch (t) {
                e(t);
            }
        })(s, t => {
            o.$n?.();
            n(t);
        }, t => {
            o.$n?.();
            e(t);
        });
    });
    s.Ye = o;
    return s;
};

async function de(t) {
    const n = _c(null, null, () => "", () => {}, new WeakMap);
    n.kt(t);
    await n.Jt();
    return n.Yt.toString();
}

async function pe(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = Array(n.length / 2);
    const s = we(n, () => e);
    s.Gt = e;
    await bf(le(s, n, e));
    return e[0];
}

const bf = t => new Promise((n, e) => {
    const s = vf(t, n, e);
    mf(s);
});

function $e(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function ye(t) {
    let n;
    const e = we(t, () => n);
    n = yf(e, t);
    e.Gt = n;
    return e;
}

function we(t, n) {
    const e = {
        _: t => $e(t, n()),
        Zt: t => e.Pt?.[+t],
        getSyncFn: () => () => {},
        $t: new WeakMap,
        element: null,
        Pt: null
    };
    Dn(t, e);
    return e;
}

const _f = (t, n) => {
    const e = new WeakSet;
    return ca(gf, t, e, "_", n);
};

const gf = (t, n, e, s) => {
    const o = tc(t);
    if (o == null) {
        return t;
    }
    if (Sf(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (Lu(o)) {
            return t;
        }
        if (Ec(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (ii(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (tr(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw rr(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw rr(3, [ o ]);
                    }
                    gf(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof ss) {
                return t;
            }
            if (Ze(o)) {
                for (const [t, s] of Object.entries(o)) {
                    gf(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw rr(3, [ i ]);
    }
    return t;
};

const Ef = /*#__PURE__*/ new WeakSet;

const Sf = t => {
    if (Ke(t) || er(t)) {
        return !Ef.has(t) && !(Pf in t);
    }
    return !0;
};

const kf = t => !!t && (Ke(t) || typeof t === "function") && (Ef.has(t) || Pf in t);

const Rf = t => {
    (Ke(t) && t !== null || typeof t === "function") && Ef.add(t);
    return t;
};

const Pf = Symbol();

const Tf = Symbol();

const Af = t => /*#__PURE__*/ Object.freeze({
    id: di(t)
});

const Mf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Zo();
    if (e !== void 0) {
        return;
    }
    o.$.setContext(o.m, t, n);
    s(1);
};

const qf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Zo();
    if (e !== void 0) {
        return e;
    }
    const r = o.$.resolveContext(o.m, t);
    if (typeof n === "function") {
        return s(Oe(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw rr(8, [ t.id ]);
};

const If = t => {
    const n = oa();
    const e = n.m;
    if (!e) {
        return;
    }
    return n.$?.resolveContext(e, t);
};

const xf = /*#__PURE__*/ Af("qk-error");

const Nf = (t, n) => {
    try {
        return t();
    } catch {
        return n;
    }
};

const Cf = "An error occurred";

const Of = t => yi(Nf(() => t instanceof Error ? `${t.name}: ${t.message}\n${t.stack ?? ""}` : t + "", "unknown"));

const jf = /*#__PURE__*/ Symbol();

const Lf = t => {
    const n = Error(Cf);
    n.digest = Of(t);
    Object.defineProperty(n, jf, {
        value: !0
    });
    return n;
};

const Ff = t => {
    if (t instanceof Error) {
        return t;
    }
    let n;
    try {
        n = t + "";
    } catch {
        try {
            n = Object.prototype.toString.call(t);
        } catch {
            n = Cf;
        }
    }
    const e = Error(n);
    e.cause = t;
    return e;
};

const Xf = (t, n, e) => {
    try {
        if (e) {
            const s = e(t);
            if (s instanceof Error) {
                return (t => Nf(() => {
                    t.message;
                    t.name;
                    for (const n in t) {
                        t[n];
                    }
                    return !0;
                }, !1))(s) ? s : Lf(t);
            }
            if (s != null) {
                n && ii(s);
                return Lf(t);
            }
        }
        if (Nf(() => t instanceof Error && jf in t, !1)) {
            return t;
        }
        if (!n) {
            return Lf(t);
        }
        if (t instanceof Error) {
            return t;
        }
        const s = t?.message;
        if (typeof s === "string") {
            const n = Error(s);
            n.cause = t;
            return n;
        }
        return Ff(t);
    } catch {
        return Lf(t);
    }
};

const Df = (t, n, e, s) => {
    if (!t) {
        return;
    }
    try {
        const o = Of(n);
        Promise.resolve(t(Ff(n), {
            phase: e,
            boundaryId: s,
            digest: o
        })).catch(Be);
    } catch (t) {
        Be(t);
    }
};

const Wf = /*#__PURE__*/ new WeakSet;

const Vf = t => {
    Wf.add(t);
};

const Uf = /*#__PURE__*/ Symbol();

const zf = (t, n) => {
    try {
        Object.defineProperty(t, Uf, {
            value: n,
            configurable: !0
        });
    } catch {}
};

const Bf = (t, n, e = "render") => {
    t.error = n ?? Ff(n);
    const s = t.Ze;
    s && Df(s, n, (t => Nf(() => t?.[Uf], void 0))(n) ?? e, t.boundaryId ?? "");
};

const Qf = t => {
    const n = t.detail;
    if (n?.importError) {
        return;
    }
    const e = n.element;
    if (!e || e.ownerDocument !== t.currentTarget) {
        return;
    }
    const s = e.closest(Or)?.qContainer;
    const o = s?.vNodeLocate(e);
    if (!s || !o) {
        return;
    }
    try {
        s.handleError(n.error, o, "event");
    } catch (t) {
        Be(t);
    }
};

function me(t, n) {
    const e = t.getHostProp(n, kr);
    return e ? Ye(e, xf.id, 0) : null;
}

const Ud = (t, n = t => t.boundary.untrackedValue > 0) => {
    if (t === null) {
        return !0;
    }
    const e = t.reveal;
    const s = t.item;
    const o = e.items;
    switch (e.order) {
      case "together":
        for (let t = 0; t < o.length; t++) {
            if (n(o[t])) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < o.length; t++) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = o.length - 1; t >= 0; t--) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const zd = new WeakMap;

class Bd {
    id;
    collapsed;
    count=0;
    pendingItems=new Set;
    orderCode;
    constructor(t, n, e) {
        this.id = t;
        this.collapsed = e;
        this.orderCode = Qd(n);
    }
    register(t) {
        this.pendingItems.add(t.item);
        const n = this.count++;
        return {
            attrs: ` q:g="${this.id}" q:i="${n}" q:o="${this.orderCode}"` + (this.collapsed ? " q:c" : ""),
            showFallback: this.canReveal(t) || !this.collapsed,
            resolve: () => {
                this.pendingItems.delete(t.item);
            }
        };
    }
    canReveal(t) {
        return Ud(t, t => this.pendingItems.has(t));
    }
    script() {
        return this.count === 0 ? "" : `qO.g(${this.id},${this.count},"${this.orderCode}");`;
    }
}

const Qd = t => {
    switch (t) {
      case "sequential":
        return "s";

      case "reverse":
        return "r";

      case "together":
        return "t";

      default:
        return "p";
    }
};

const Hd = () => {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    const t = sa()?.$;
    return t?.outOfOrderStreaming === !0 && !Dd(t);
};

const Hf = (t, n, e, s, o) => {
    let r;
    for (const t of o) {
        if (!s.has(t)) {
            s.add(t);
            (r ||= new Set).add(t);
        }
        (t.backRef ||= new Set).add(e);
    }
    r && Vu(t, n, r);
};

const Jf = new WeakMap;

function* ve(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = t;
    const s = e.element.querySelectorAll(`script[type="qwik/state"][q\\:instance="${e.Kt}"]${mr}`);
    const o = Yf(t);
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (n !== void 0 && i.getAttribute(vr) !== n) {
            continue;
        }
        if (o.has(i)) {
            continue;
        }
        o.add(i);
        yield* be(t, e, i.textContent);
        yield;
    }
}

const Yf = t => {
    let n = Jf.get(t);
    if (!n) {
        n = new WeakSet;
        Jf.set(t, n);
    }
    return n;
};

function* be(t, n, e) {
    if (!e) {
        return;
    }
    const [s, o, r, i] = JSON.parse(e);
    yield* function* c(t, n, e, s) {
        const o = n.tn.length / 2;
        if (e !== o) {
            return;
        }
        for (let t = 0; t < s.length; t++) {
            n.tn[e * 2 + t] = s[t];
            yield;
        }
        yield* Wn(n.tn, t, e * 2);
        n.nn = yf(t, n.tn);
        n.nn.length = n.tn.length / 2;
        n.en = n.Pt;
    }(t, n, s, o);
    Gf(n, r || void 0);
    ((t, n) => {
        if (!__EXPERIMENTAL__.suspense || !n) {
            return;
        }
        for (let e = 0; e < n.length; e++) {
            const s = n[e];
            const o = t._(s.rootId);
            const r = s.subscriptions;
            if (o instanceof Fs) {
                r instanceof Set && Hf(t, o, o, o.ft ||= new Set, r);
            } else {
                if (!(r instanceof Map)) {
                    continue;
                }
                const n = Yu(o);
                const e = Gu(o);
                if (!n || !e) {
                    continue;
                }
                const s = n.ft ||= new Map;
                for (const [o, i] of r) {
                    let r = s.get(o);
                    if (!r) {
                        r = new Set;
                        s.set(o, r);
                    }
                    Hf(t, n, e, r, i);
                }
            }
        }
    })(t, i === void 0 ? void 0 : n._(i));
}

const Gf = (t, n) => {
    if (!n) {
        return;
    }
    const e = t.en ||= [];
    for (let t = 0; t < n.length; t++) {
        const s = n[t];
        s !== void 0 && e.push(s);
    }
    t.Pt = e;
};

const Zf = (t, n) => {
    const e = t;
    e.qVNodeDataReady ? n() : (e.qVNodeDataCallbacks ||= []).push(n);
};

function _e(t, n) {
    const e = t.qVNodeDataState ||= {
        rn: [],
        sn: null
    };
    t.qProcessVNodeDataPatch ||= n => _e(t, Se(t, n));
    t.qVNodeDataReady = !1;
    e.rn.push(n);
    ge(t, e);
}

function ge(t, n) {
    if (n.sn) {
        return;
    }
    const e = n.rn.shift();
    if (!e) {
        Ee(t);
        return;
    }
    n.sn = vf(function* s(t, n, e) {
        for (;t.qVNodeDataState === n; ) {
            if (e.next().done) {
                return;
            }
            yield;
        }
    }(t, n, e), () => {
        if (t.qVNodeDataState === n) {
            n.sn = null;
            ge(t, n);
        }
    }, e => {
        n.sn = null;
        Be(e);
        Ee(t);
    });
    mf(n.sn);
}

function Ee(t) {
    if (t.qVNodeDataReady) {
        return;
    }
    t.qVNodeDataReady = !0;
    t.qVNodeDataState = void 0;
    const n = t.qVNodeDataCallbacks;
    t.qVNodeDataCallbacks = void 0;
    if (n) {
        for (let t = 0; t < n.length; t++) {
            n[t]();
        }
    }
}

function* Se(t, n) {
    const e = n?.closest("[q\\:container]");
    const s = n?.getAttribute("q:r");
    const o = e && (s ? e.querySelector(`[q\\:rp="${s}"]`) : e);
    e && o && (yield* ke(t, s || void 0, e, o, n.textContent));
}

function* ke(t, n, e, s, o) {
    const r = "q:container";
    const i = "/" + r;
    const c = "q:ignore";
    const l = "/" + c;
    const u = "q:container-island";
    const f = "/" + u;
    const a = "q:rp";
    const h = t;
    const d = h.qVNodeData ||= new WeakMap;
    const p = t.body;
    const $ = p.getAttribute;
    const y = p.hasAttribute;
    const w = ((t, n) => {
        let e;
        for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
            t = Object.getPrototypeOf(t);
        }
        return e || function() {
            return this[n];
        };
    })(p, "nodeType");
    const m = function*(t) {
        const n = t.querySelectorAll('script[type="qwik/vnode"]');
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            const s = e.closest("[q\\:container]");
            s.qVNodeRefs ||= new Map;
            if (e.hasAttribute("q:patch")) {
                h.qProcessVNodeDataPatch?.(e);
                yield;
                continue;
            }
            const o = e.textContent;
            const r = __EXPERIMENTAL__.suspense && e.getAttribute("q:r");
            r ? (s.qSegmentVnodeData ||= new Map).set(r, o) : s.qVnodeData = o;
            yield;
        }
        const e = t.querySelectorAll("[q\\:shadowroot]");
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            const s = n.shadowRoot;
            s && (yield* m(s));
            yield;
        }
    };
    const b = t => {
        const n = w.call(t);
        if (n === 1) {
            if ($.call(t, r) !== null) {
                return 3;
            }
            if (y.call(t, "q:shadowroot")) {
                return 6;
            }
            if (__EXPERIMENTAL__.suspense && $.call(t, a) !== null) {
                return 130;
            }
            return y.call(t, ":") ? 2 : 0;
        }
        if (n === 8) {
            const n = t.nodeValue || "";
            if (n.startsWith(u)) {
                return 65;
            }
            if (n.startsWith(c)) {
                return 16;
            }
            if (n.startsWith(r)) {
                return 9;
            }
            if (n.startsWith(f)) {
                return 64;
            }
            if (n.startsWith(l)) {
                return 32;
            }
            if (n.startsWith(i)) {
                return 8;
            }
        }
        return 0;
    };
    const _ = t => {
        for (;t && (t = t.nextSibling) && b(t) === 0; ) {}
        return t;
    };
    const v = function*(n, e, s, o, r, i, c, l) {
        const u = __EXPERIMENTAL__.suspense && l !== void 0;
        const f = r.length;
        let h = 0;
        let p = -1;
        let y = 0;
        let w = 0;
        let m = 0;
        let g = -1;
        let S = null;
        const k = () => {
            let t = 0;
            for (;Kf(m = r.charCodeAt(y)); ) {
                t += 1 << m - 33;
                y++;
                if (y >= f) {
                    break;
                }
            }
            return t;
        };
        if (!s) {
            return;
        }
        do {
            if (s === o) {
                return;
            }
            S = null;
            const R = s == e ? 2 : b(s);
            if (R === 3) {
                const t = s;
                let e = s;
                for (;e && !(S = _(e)); ) {
                    e = e.parentNode;
                }
                yield* v(n, t, s, S, t.qVnodeData || "", t.qVNodeRefs, t);
            } else if (R === 16) {
                let t = s;
                do {
                    t = n.nextNode();
                    if (!t) {
                        throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                    }
                } while (b(t) !== 65);
            } else if (R === 64) {
                S = s;
                let t;
                do {
                    S = n.nextNode();
                    if (!S) {
                        throw Error("Ignore block not closed!");
                    }
                    t = b(S);
                } while (t !== 32 && t !== 65);
                S = null;
            } else if (R === 9) {
                S = s;
                do {
                    S = _(S);
                    if (!S) {
                        throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                    }
                } while (b(S) !== 8);
                yield* v(n, s, s, S, "", null, c);
            } else if (R === 6) {
                S = _(s);
                const n = s;
                const e = n?.shadowRoot;
                e && (yield* v(t.createTreeWalker(e, 129), null, e, null, "", null, null));
            }
            if ((R & 2) === 2) {
                if (u && s !== e) {
                    const t = s;
                    t._qSegment = l;
                }
                if (p < h) {
                    p === -1 && (p = 0);
                    y = w;
                    if (y < f) {
                        p += k();
                        if (m === 126) {
                            g = p;
                            y++;
                            m = y < f ? r.charCodeAt(w) : 33;
                        }
                        w = ta(r, y, f);
                    } else {
                        p = Number.MAX_SAFE_INTEGER;
                    }
                }
                const t = __EXPERIMENTAL__.suspense && !u && R === 130 ? $.call(s, a) : null;
                if (h === p) {
                    g !== h || u && s === e || i.set(u ? ar(l, h) : h, s);
                    const t = r.substring(y, w);
                    if (u && s === e) {
                        const n = d.get(s);
                        n === void 0 || n === "" ? d.set(s, t) : n.charCodeAt(0) !== fr || n.charCodeAt(1) !== fr || n.endsWith(t) || d.set(s, n + t);
                    } else {
                        d.set(s, t);
                    }
                }
                h++;
                if (__EXPERIMENTAL__.suspense && t !== null) {
                    yield* E(c, s, t);
                    S = _(s);
                    S && (n.currentNode = S);
                }
            }
            yield;
        } while (s = S || n.nextNode());
    };
    const g = function*(n, e, s, o) {
        n.qVNodeRefs ||= new Map;
        const r = t.createTreeWalker(t, 129);
        r.currentNode = e;
        yield* v(r, e, e, _(e), s, n.qVNodeRefs, n, o);
    };
    const E = function*(t, n, e, s) {
        s ||= t?.qSegmentVnodeData?.get(e);
        t && s && (yield* g(t, n, s, e));
    };
    if (e && s && o !== void 0) {
        e.qVNodeRefs ||= new Map;
        __EXPERIMENTAL__.suspense && n !== void 0 ? yield* E(e, s, n, o) : yield* g(e, s, o);
        return;
    }
    yield* m(t);
    const S = t.createTreeWalker(t, 129);
    yield* v(S, null, S.firstChild(), null, "", null, null);
}

const Kf = t => 33 <= t && t <= 46;

const ta = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && Kf(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function Re(t) {
    return t.ln === 3;
}

function Pe(t, n) {
    const e = t.un ||= {
        rn: [],
        sn: null
    };
    t.ln = 2;
    e.rn.push(n);
    Te(t, e);
}

const na = (t, n) => {
    const e = t;
    if (Re(e) && e.document.qVNodeDataReady) {
        return n();
    }
    return new Promise((t, s) => {
        ((t, n) => {
            const e = t;
            const s = () => {
                if (!Re(e)) {
                    (e.cn ||= []).push(s);
                    return;
                }
                Zf(e.document, () => {
                    Re(e) ? n() : s();
                });
            };
            s();
        })(e, () => {
            try {
                t(n());
            } catch (t) {
                s(t);
            }
        });
    });
};

function Te(t, n) {
    if (n.sn) {
        return;
    }
    const e = n.rn.shift();
    if (!e) {
        Ae(t);
        return;
    }
    n.sn = vf(e, () => {
        n.sn = null;
        Te(t, n);
    }, e => {
        n.sn = null;
        Be(e);
        Ae(t);
    });
    mf(n.sn);
}

function Ae(t) {
    const n = t.ln;
    if (n !== 2) {
        return;
    }
    t.ln = 3;
    t.un = void 0;
    const e = t.cn;
    t.cn = void 0;
    if (e) {
        for (let t = 0; t < e.length; t++) {
            e[t]();
        }
    }
}

function Me(t) {
    const n = Ie(t);
    if (!n) {
        throw rr(24);
    }
    return qe(n);
}

function qe(t) {
    const n = t;
    return n.qContainer ||= new ea(n);
}

function Ie(t) {
    return t.closest(Or);
}

function xe(t, n) {
    const e = t + "";
    const s = n?.closest(Or);
    const o = s?.qContainer;
    if (o) {
        const t = o.element.ownerDocument;
        (function s(t, n, e) {
            if (!__EXPERIMENTAL__.suspense || !e) {
                return;
            }
            const s = e.closest("[q\\:container]");
            if (!s) {
                return;
            }
            const o = s.querySelector(`script[type="qwik/vnode"][q\\:r="${n}"]:not([q\\:patch])`);
            const r = s.querySelectorAll(`script[type="qwik/vnode"][q\\:r="${n}"][q\\:patch]`);
            _e(t, function* i(t, n, e, s, o, r) {
                yield* ke(t, n, e, s, o);
                for (let n = 0; n < r.length; n++) {
                    yield* Se(t, r[n]);
                }
            }(t, n, s, e, o?.textContent || void 0, r));
        })(t, e, n);
        Zf(t, () => {
            o.element.qContainer === o && Pe(o, ve(o, e));
        });
    }
}

class ea extends zc {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    $t=new WeakMap;
    Ke;
    Kt;
    Pt=null;
    vNodeLocate=t => Ll(this.rootVNode, t);
    ln=0;
    cn=void 0;
    un=void 0;
    tn;
    nn;
    en=null;
    tr=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(xr);
        if (!this.qContainer) {
            throw rr(25);
        }
        const n = t.ownerDocument;
        this.document = n;
        this.element = t;
        this.Qe = t.getAttribute(Tr);
        this.Kt = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = bl(this.element);
        this.tn = [];
        this.nn = [];
        __EXPERIMENTAL__.suspense && n.querySelector("template[q\\:r]") && (n.qProcessOOOS ||= xe);
        this.Ke = Pr(n, this.Kt) || Es;
        this.nr();
        t.qContainer = this;
        t.qDestroy = () => this.$n();
        __EXPERIMENTAL__.errorBoundary && function e(t) {
            if (!t.qErrorHandler) {
                t.qErrorHandler = Qf;
                t.addEventListener?.("qerror", Qf);
            }
        }(this.document);
        this.ln = 1;
        (function s(t, n) {
            const e = t;
            if (n?.qVNodeRefs) {
                return;
            }
            if (e.qVNodeDataStarted && !e.qVNodeDataProcessed) {
                return;
            }
            e.qVNodeDataStarted = !0;
            e.qVNodeData ||= new WeakMap;
            _e(e, function* s(t) {
                yield* ke(t);
                const n = t;
                n.qVNodeDataProcessed = !0;
                n.qVNodeDataStarted = !1;
            }(t));
        })(n, t);
        Zf(n, () => {
            this.ln === 1 && Pe(this, this.er());
        });
    }
    * er() {
        const t = this.element;
        if (t.qContainer !== this) {
            return;
        }
        const n = t.querySelector(`script[type="qwik/state"][q\\:instance="${this.Kt}"]:not(${mr})`) || t.querySelector(`script[type="qwik/state"]:not([q\\:instance]):not(${mr})`);
        if (n) {
            this.tn = JSON.parse(n.textContent);
            yield* Wn(this.tn, this);
            this.en = this.Pt;
            const e = this.tn.length / 2;
            const s = t.getAttribute("q:prewarm");
            this.nn = s !== null && e > 0 && e >= +s ? yield* le(this, this.tn) : yf(this, this.tn);
        }
        __EXPERIMENTAL__.suspense && (yield* ve(this));
        this.rr();
        t.setAttribute(xr, "resumed");
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    $n() {
        this.vNodeLocate = () => null;
        this.tn.length = 0;
        this.nn.length = 0;
        this._ = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        __EXPERIMENTAL__.suspense && (t.qSegmentVnodeData = void 0);
        t.removeAttribute(xr);
        const n = t.ownerDocument;
        this.un = void 0;
        this.ln = 0;
        const e = n.querySelector(Or) !== null;
        if (!e) {
            n.qVNodeData = void 0;
            n.qVNodeDataStarted = void 0;
            n.qVNodeDataReady = void 0;
            n.qVNodeDataState = void 0;
            n.qVNodeDataCallbacks = void 0;
            n.qVNodeDataProcessed = void 0;
            n.qProcessVNodeDataPatch = void 0;
        }
        __EXPERIMENTAL__.suspense && (e || (n.qProcessOOOS = void 0));
    }
    rr() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(Er);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    Kn(t, n) {
        this.nn[t] = n;
    }
    parseQRL(t) {
        return Fn(t, this);
    }
    handleError(t, n, e = "render") {
        if (!__EXPERIMENTAL__.errorBoundary) {
            const e = n && this.resolveContext(n, xf);
            if (!e) {
                throw t;
            }
            e.error = t;
            return;
        }
        const s = t ?? Ff(t);
        let o = n;
        for (;o; ) {
            const n = this.resolveContextHost(o, xf);
            if (!n) {
                break;
            }
            const r = me(this, n);
            if (r && r.error === void 0) {
                r.error = s;
                const o = this.getHostProp(n, Vr);
                Df(o?.onError$, t, e, r.boundaryId ?? "");
                wn(this, n, 4);
                return;
            }
            if (n.dirty & 4) {
                Be(t);
                return;
            }
            o = this.getParentHost(n);
        }
        ((t, ...n) => {
            Qe(!0, t, ...n);
        })(t);
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, kr);
        s == null && this.setHostProp(t, kr, s = []);
        Je(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        const e = this.resolveContextHost(t, n);
        return e ? Ye(this.getHostProp(e, kr), n.id, 0) : void 0;
    }
    resolveContextHost(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, kr);
            if (e != null && Ge(e, n.id, 0)) {
                return t;
            }
            t = this.getParentHost(t);
        }
        return null;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (Tl(n)) {
                if (Ml(n, hr, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        ql(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case Ur:
          case Vr:
          case hr:
          case kr:
          case Rr:
            s = this._;
            break;

          case zr:
          case Yr:
            s = parseInt;
            break;
        }
        return Ml(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (S(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    _=t => $e(t, this.nn);
    Zt(t) {
        return this.en?.[t];
    }
    getSyncFn(t) {
        const n = this.Ke[t];
        return n;
    }
    ir(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, Sr);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, Sr, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.tr == null) {
            this.tr = new Set;
            const t = this.document.querySelectorAll(gr);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.tr.add(e.getAttribute(_r));
            }
        }
        if (!this.tr.has(n)) {
            this.tr.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(_r, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    nr() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === ti) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.pn = {
            containerAttributes: t
        };
    }
}

let ra;

let Jd;

if (We) {
    const t = Vc();
    t && (Jd = new t);
}

function Ne(t) {
    if (Jd) {
        const t = Jd.getStore();
        if (t) {
            return t;
        }
    }
    if (ra === void 0) {
        const n = sa();
        if (n && n.fn) {
            return n.fn;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return ra;
}

function Ce(t, n) {
    if (Jd) {
        return Jd.run(t, n);
    }
    const e = ra;
    try {
        ra = t;
        return n();
    } finally {
        ra = e;
    }
}

let ia;

const sa = () => ia;

const oa = () => {
    const t = sa();
    if (!t) {
        throw rr(9);
    }
    return t;
};

const la = () => {
    const t = sa();
    if (!t || t.an !== Xr) {
        throw rr(10);
    }
    return t;
};

function Oe(t, n, ...e) {
    return je.call(this, t, n, e);
}

function je(t, n, e) {
    const s = ia;
    try {
        ia = t;
        return n.apply(this, e);
    } finally {
        ia = s;
    }
}

const ua = (t, n, e = Me(n)) => {
    const s = Ll(e.rootVNode, n);
    const o = e.fn;
    o && function r(t) {
        if (Jd) {
            Jd.enterWith(t);
            return;
        }
        ra = t;
    }(o);
    const i = Fe(o, s, t);
    i.$ = e;
    return i;
};

function Le(t, n, e) {
    const s = {
        m: n,
        an: Xr,
        hn: void 0,
        fn: t,
        $: e,
        dn: void 0
    };
    return s;
}

function Fe(t, n, e) {
    const s = t || (e && Ke(e) && "locale" in e ? e.locale : void 0);
    const o = {
        m: n,
        an: e,
        hn: void 0,
        fn: s,
        $: void 0
    };
    return o;
}

const ca = (t, ...n) => {
    if (typeof t === "function") {
        if (!ia) {
            return t(...n);
        }
        {
            const e = ia.hn;
            try {
                ia.hn = void 0;
                return t(...n);
            } finally {
                ia.hn = e;
            }
        }
    }
    if (Lu(t)) {
        return t.untrackedValue;
    }
    return tc(t);
};

const fa = /*#__PURE__*/ Le(void 0, void 0, void 0);

const aa = (t, n, e, s, o) => {
    const r = fa.hn;
    const i = fa.$;
    try {
        fa.hn = m(n, e, o);
        fa.$ = s;
        return je(fa, t);
    } finally {
        fa.hn = r;
        fa.$ = i;
    }
};

const ha = (t, n, e, s, o) => {
    t instanceof so && t.m !== n && n && (t.m = n);
    return aa(() => t.value, n, e, s, o);
};

const da = () => sa()?.m;

const pa = () => {
    const t = sa();
    if (t) {
        return t.an;
    }
};

const $a = () => {
    const t = sa();
    if (t) {
        return t.$;
    }
};

const ya = t => t;

const wa = t => t.l || Promise.resolve();

let ma;

let va = (t, n, e, s, o) => new ba(t, n, e, s, o);

class ba {
    gt;
    _t;
    sr;
    lr;
    $;
    constructor(t, n, e, s, o) {
        this.gt = t;
        this._t = n;
        this.sr = e;
        this.lr = s;
        s && this.ur(s);
        !o || s || typeof t !== "string" || e || (this.$ = o);
        Ve && t && De(t, .8);
    }
    get st() {
        return Od(this._t);
    }
    ur(t) {
        this.lr = t;
        ii(t) && t.then(t => this.lr = t, t => {
            const n = `qrl ${this._t} failed to load`;
            if (We) {
                console.error(n, t);
            } else if (Ve) {
                const e = this.gt === null ? "symbol:" + this._t : "chunk:" + this.gt;
                const s = this.$;
                let o = s && ma?.get(s);
                if (!o?.has(e)) {
                    if (s) {
                        if (!o) {
                            o = new Set;
                            (ma ||= new WeakMap).set(s, o);
                        }
                        o.add(e);
                    }
                    console.error(n, t);
                }
            }
            this.lr = null;
        });
    }
    cr() {
        if (this.lr != null) {
            return this.lr;
        }
        if (this.gt === "") {
            const t = this.$.Kt;
            const n = this.$.element?.ownerDocument || document;
            const e = Pr(n, t);
            return this.lr = e[+this._t];
        }
        Ve && this.gt && De(this.gt, 1);
        const t = this._t;
        const n = this.sr ? this.sr().then(n => n[t]) : Ri().importSymbol(this.$?.element, this.gt, t);
        this.ur(n);
        return this.lr;
    }
}

Ve && import.meta.hot && (t => {
    if (!Ve || !import.meta.hot) {
        return;
    }
    const n = new Map;
    (() => {
        va = (e, s, o, r, i) => {
            let c = n.get(s);
            if (!c) {
                c = new t(e, s, o, r, i);
                e !== "" && n.set(s, c);
            }
            return c;
        };
    })();
    const e = (t, n) => {
        const [e, s] = t.split("?", 2);
        if (!s) {
            return `${e}?t=${n}`;
        }
        const o = s.split("&").filter(t => !t.startsWith("t="));
        o.push("t=" + n);
        return `${e}?${o.join("&")}`;
    };
    document.addEventListener("qHmr", t => {
        const s = t.detail.files;
        const o = t.detail.t || document.__hmrT || Date.now();
        let r = !1;
        for (const t of n.values()) {
            const n = t.dev?.file || t.gt;
            if (!n || !s.some(t => n.startsWith(t))) {
                continue;
            }
            const i = t.gt;
            if (i) {
                t.gt = e(i, o);
                r = !0;
            }
            const c = t.sr?.toString();
            if (c) {
                const n = c.replace(/import\((['"])(.+?)\1\)/, (t, n, s) => {
                    const r = e(s, o);
                    return `import(${n}${r}${n})`;
                });
                if (n !== c) {
                    try {
                        t.sr = Function(`return (${n})`)();
                        r = !0;
                    } catch (n) {
                        console.error("Failed to update symbolFn for " + t._t, n);
                    }
                } else {
                    console.warn(`Couldn't find import() in symbolFn for ${t._t}, cannot update it for HMR`, c);
                }
            }
            if (r) {
                t.lr = void 0;
                if (t.qrls) {
                    for (const n of t.qrls) {
                        const e = n.deref();
                        e ? e.resolved && (e.resolved = void 0) : t.qrls.delete(n);
                    }
                }
            }
        }
    }, !0);
})(ba);

const _a = Symbol();

const ga = t => t?.[_a] ?? t;

class Ea {
    ar;
    resolved=void 0;
    jt;
    $;
    constructor(t, n, e) {
        this.ar = t;
        if (n) {
            this.jt = n;
            typeof n === "string" && (this.$ = e);
        }
        t.lr == null || this.jt && typeof this.jt === "string" || ii(t.lr) || (this.resolved = qa(this, t.lr));
    }
}

const Sa = function(t, ...n) {
    const e = ga(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = sa();
    return ka.call(e, s?.$).then(() => je.call(t, s, e.resolved, n));
};

const ka = async function(t) {
    const n = ga(this);
    return oi(Ia(n, t), () => n.resolved);
};

const Ra = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[_a].resolved;
        },
        set(t) {
            this[_a].resolved = t;
        }
    },
    jt: {
        get() {
            return this[_a].jt;
        },
        set(t) {
            this[_a].jt = t;
        }
    },
    $: {
        get() {
            return this[_a].$;
        },
        set(t) {
            this[_a].$ = t;
        }
    },
    ar: {
        get() {
            return this[_a].ar;
        }
    },
    gt: {
        get() {
            return this[_a].ar.gt;
        }
    },
    _t: {
        get() {
            return this[_a].ar._t;
        }
    },
    st: {
        get() {
            return this[_a].ar.st;
        }
    },
    dev: {
        get() {
            return this[_a].ar.dev;
        }
    },
    hr: {
        value: Sa
    },
    w: {
        value: function(t) {
            const n = ga(this);
            const e = new Ea(n.ar, t, n.jt ? n.$ : void 0);
            return Na(e);
        }
    },
    s: {
        value: function(t) {
            const n = ga(this);
            n.ar.ur(t);
            n.resolved = qa(n, t);
        }
    },
    resolve: {
        value: ka
    },
    getSymbol: {
        value: function() {
            return ga(this).ar._t;
        }
    },
    getHash: {
        value: function() {
            return ga(this).ar.st;
        }
    },
    getCaptured: {
        value: function() {
            const t = ga(this);
            Ma(t);
            return t.jt;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = ga(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return ka.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return je(t, e.resolved, o);
            };
            return s;
        }
    }
});

let Pa = null;

const Ta = t => {
    Pa = t;
};

const Aa = (t, n, e = 0, s) => {
    const o = [];
    let r = s;
    let i = e;
    for (let s = e; s <= n.length; s++) {
        if (s === n.length || n.charCodeAt(s) === 32) {
            if (s > i) {
                const e = +n.slice(i, s);
                r = r === void 0 ? e : r + e;
                o.push(t._(r));
            }
            i = s + 1;
        }
    }
    return o;
};

const Ma = t => {
    const n = t.jt;
    const e = t.$;
    if (typeof n === "string") {
        if (!e) {
            throw rr(13);
        }
        const s = ff;
        Pa = t.jt = ((t, n) => {
            const e = n.indexOf("#");
            if (e === -1) {
                return Aa(t, n);
            }
            const s = n.indexOf("#", e + 1);
            const o = +n.slice(0, e) + +n.slice(e + 1, s);
            return Aa(t, n, s + 1, o);
        })(e, n);
        if (ff !== s) {
            return ff;
        }
    } else {
        Pa = n || null;
    }
};

const qa = (t, n) => {
    if (typeof n !== "function" || !t.jt) {
        return n;
    }
    return function e(...s) {
        Ma(t);
        return n.apply(this, s);
    };
};

const Ia = (t, n) => {
    const e = t.ar;
    const s = typeof t.jt === "string";
    s && !t.$ && (t.$ = n || sa()?.$);
    if (t.resolved) {
        return;
    }
    const o = La();
    const r = sa();
    const i = e.cr();
    const c = oi(i, n => {
        t.resolved = qa(t, n);
    });
    if (c) {
        const t = e._t;
        Oa(t, r?.m instanceof ls ? r?.m.node : void 0, o);
    }
    const l = s && t.$ && Ma(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const xa = (t, n, e, s, o, r) => {
    const i = va(t, n, s, e, r);
    const c = new Ea(i, o, r);
    return Na(c);
};

const Na = t => {
    const n = async function(...t) {
        return Sa.call(n, this, ...t);
    };
    n[_a] = t;
    Object.setPrototypeOf(n, Ra);
    return n;
};

const Ca = /*#__PURE__*/ new Set;

const Oa = (t, n, e) => {
    if (!Ca.has(t)) {
        Ca.add(t);
        ja("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const ja = (t, n) => {
    jd() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const La = () => {
    if (jd()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let Fa = 0;

const Xa = t => xa(null, "s" + Fa++, t, null, null);

const Da = Xa;

const Wa = t => t;

const Va = t => xa("", ir, t, null, null);

const Ua = (t, n) => {
    n === void 0 && (n = t.toString());
    t.serialized = n;
    return xa("", ir, t, null, null);
};

const za = t => {
    function n(n, e, s = 0) {
        const o = t.st.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[Ba] = [ t ];
        return _o(i, n, null, n.children, s, r);
    }
    n[Ba] = [ t ];
    return n;
};

const Ba = Symbol();

const Qa = t => typeof t == "function" && t[Ba] !== void 0;

const Ha = t => za(Da(t));

const Ja = Ws(Wa);

const Ya = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const Ga = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !Gi(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(xr, "resumed");
    const s = Me(t);
    s.pn = e.serverData || {};
    const o = s.rootVNode;
    ql(o, ds, n);
    wn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            St(s, [], s.rootVNode);
        }
    };
};

const Za = (t, n) => {
    const {val: e, set: s, iCtx: o} = Zo();
    if (e != null) {
        return e;
    }
    const r = er(t) ? Oe(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.$;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = ec(r, i, t);
        s(c);
        return c;
    }
};

const Ka = t => {
    const n = Zi(t);
    return (t => t.toString(36))(n.Be++);
};

const th = () => {
    const {val: t, set: n, iCtx: e} = Zo();
    if (t != null) {
        return t;
    }
    const s = e.$.Qe || "";
    const o = s ? yi(s).substring(0, 3) : "";
    const r = e.$.getHostProp(e.m, hr);
    const i = r?.getHash().substring(0, 3) || "";
    const c = Ka(e.$) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function Xe(t, n) {
    const e = sa();
    return e?.$?.pn[t] ?? n;
}

const nh = /*#__PURE__*/ new Map;

const eh = (t, n) => {
    let e = nh.get(n);
    e || nh.set(n, e = rh(t, n));
    return e;
};

const rh = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = uh;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === Ch) {
            r++;
            e = Ih;
        }
        const s = Vh[c];
        for (let d = 0; d < s.length; d++) {
            const p = s[d];
            const [$, y, w] = p;
            if (($ === l || $ === wh || $ === mh && ih(l) || $ === bh && lh(l)) && (y === e || y === wh || y === mh && ih(e) || y === vh && !ih(e) && e !== Th || y === bh && lh(e)) && (p.length == 3 || a(p))) {
                p.length > 3 && (e = t.charCodeAt(r - 1));
                if (w === $h || w == yh) {
                    if (w === yh) {
                        if (c !== ch || h()) {
                            if (!sh(e)) {
                                const t = y == vh ? 1 : y == Rh ? 2 : 0;
                                f(r - t);
                            }
                        } else {
                            sh(e) ? u(r - 2) : f(r - 2);
                            i++;
                        }
                    }
                    if (y === vh) {
                        r--;
                        e = l;
                    }
                    do {
                        c = o.pop() || uh;
                        if (c === fh) {
                            u(r - 1);
                            i++;
                        }
                    } while (oh(c));
                } else {
                    o.push(c);
                    if (c === fh && w === uh) {
                        u(r - 8);
                        i = r;
                    } else {
                        w === ah && f(n);
                    }
                    c = w;
                }
                break;
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === fh || h()) {
            return;
        }
        u(t);
        s.push(".", pr, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === Ph) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === Ph) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | jh) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        return o.indexOf(fh) !== -1 || o.indexOf(hh) !== -1;
    }
};

const ih = t => t >= Ah && t <= Mh || t >= Ih && t <= xh || t >= Lh && t <= Fh || t >= 128 || t === Oh || t === Ph;

const sh = t => t === qh || t === Th || t === Nh || t === kh || ih(t);

const oh = t => t === dh || t === hh || t === ph || t === fh;

const lh = t => t === Sh || t === _h || t === gh || t === Eh;

const uh = 0;

const ch = 2;

const fh = 5;

const ah = 6;

const hh = 10;

const dh = 11;

const ph = 12;

const $h = 17;

const yh = 18;

const wh = 0;

const mh = 1;

const vh = 2;

const bh = 3;

const _h = 9;

const gh = 10;

const Eh = 13;

const Sh = 32;

const kh = 35;

const Rh = 41;

const Ph = 45;

const Th = 46;

const Ah = 48;

const Mh = 57;

const qh = 58;

const Ih = 65;

const xh = 90;

const Nh = 91;

const Ch = 92;

const Oh = 95;

const jh = 32;

const Lh = 97;

const Fh = 122;

const Xh = 123;

const Dh = 125;

const Wh = /*@__PURE__*/ (() => [ [ wh, 39, 14 ], [ wh, 34, 15 ], [ wh, 47, 16, "*" ] ])();

const Vh = /*@__PURE__*/ (() => [ [ [ wh, 42, ch ], [ wh, Nh, 7 ], [ wh, qh, ah, ":", "before", "after", "first-letter", "first-line" ], [ wh, qh, fh, "global" ], [ wh, qh, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ wh, qh, 4 ], [ wh, mh, 1 ], [ wh, Th, 1 ], [ wh, kh, 1 ], [ wh, 64, hh, "keyframe" ], [ wh, 64, dh, "media", "supports", "container" ], [ wh, 64, ph ], [ wh, Xh, 13 ], [ 47, 42, 16 ], [ wh, 59, $h ], [ wh, Dh, $h ], [ wh, Rh, $h ], ...Wh ], [ [ wh, vh, yh ] ], [ [ wh, vh, yh ] ], [ [ wh, 40, uh ], [ wh, vh, yh ] ], [ [ wh, 40, 8 ], [ wh, vh, yh ] ], [ [ wh, 40, uh ], [ wh, vh, $h ] ], [ [ wh, vh, $h ] ], [ [ wh, 93, yh ], [ wh, 39, 14 ], [ wh, 34, 15 ] ], [ [ wh, Rh, $h ], ...Wh ], [ [ wh, Dh, $h ], ...Wh ], [ [ wh, Dh, $h ], [ bh, mh, 1 ], [ wh, qh, fh, "global" ], [ wh, Xh, 13 ], ...Wh ], [ [ wh, Xh, uh ], [ wh, 59, $h ], ...Wh ], [ [ wh, 59, $h ], [ wh, Xh, 9 ], ...Wh ], [ [ wh, Dh, $h ], [ wh, Xh, 13 ], [ wh, 40, 8 ], ...Wh ], [ [ wh, 39, $h ] ], [ [ wh, 34, $h ] ], [ [ 42, 47, $h ] ] ])();

const Uh = t => ({
    styleId: Hh(t, t => t, !1)
});

const zh = /*#__PURE__*/ Ws(Uh);

const Bh = t => ({
    scopeId: pr + Hh(t, eh, !0)
});

const Qh = /*#__PURE__*/ Ws(Bh);

const Hh = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = Zo();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${yi(t.st)}-${n}`)(t, i);
    const l = r.m;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.$.ir(n(t, c), c, l, e));
    }
    r.$.ir(n(t.resolved, c), c, l, e);
    return c;
};

const Jh = (t, n) => {
    t.resolve();
    return Bs(t, n);
};

const Yh = (t, n) => nl(Jh, t, n);

const Gh = Ws(Yh);

const Zh = t => {
    t.resolve();
    return Hs(t);
};

const Kh = t => nl(Zh, t);

const td = Ws(Kh);

const nd = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = Zo();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !jd()) {
            e.h |= 32;
            ed(e, i);
        }
        return;
    }
    let c;
    if (jd()) {
        c = 1;
    } else {
        c = 5;
        t.resolve();
        wn(r.$, r.m, 1);
    }
    const l = new Cu(c, o, r.m, t, null);
    s(l);
    ed(l, i);
};

const ed = (t, n) => {
    n === "intersection-observer" ? ef("qvisible", rd(t)) : n === "document-ready" ? rf("qinit", rd(t)) : n === "document-idle" && rf("qidle", rd(t));
};

const rd = t => xa(null, "_task", qn, null, [ t ]);

const id = Ws(Kc);

const sd = /*#__PURE__*/ Ws(xu);

const od = /*#__PURE__*/ Ws(nd);

const ld = (t, n) => {
    t.resolve();
    return Qs(t, n);
};

const ud = (t, n) => nl(ld, t, n);

const cd = Ws(ud);

const fd = () => Object.defineProperty({
    error: void 0
}, "error", {
    enumerable: !1
});

async function Yd(t, n, e, s) {
    const o = n + "";
    const r = await e.container.S(o, e);
    t.write(`<template ${vr}="${n}"${s?.attrs ?? ""}>`);
    t.write(r.html);
    t.write("</template>");
    t.emitOutOfOrderSegmentScripts(r.scripts);
    t.emitOutOfOrderExecutorIfNeeded();
    t.emitInlineScript(`qO(${n})`);
    const i = e.container.P;
    if (__EXPERIMENTAL__.errorBoundary && i?.length) {
        t.emitErrorSwapExecutorIfNeeded();
        for (let n = 0; n < i.length; n++) {
            t.emitInlineScript(`qErr(${i[n]})`);
        }
    }
    await t.streamHandler.flush();
}

const ad = () => {
    const [t] = Pa;
    const n = sa()?.$;
    const e = Ve;
    e && t && n && function s(t, n) {
        const e = t.resolveContextHost(n, xf);
        if (!e) {
            return;
        }
        const s = me(t, e);
        if (!s) {
            return;
        }
        (function o(t, n, e) {
            let s = n;
            let o = null;
            let r = ku(n);
            let i = !1;
            for (;r; ) {
                if (Tl(r)) {
                    if (Ml(r, $r, null) !== null) {
                        i = !0;
                    } else if (Ml(r, hr, null) !== null) {
                        if (!i) {
                            const n = me(t, r);
                            if (!n || n.error !== void 0) {
                                o && (s = o);
                                o = r;
                                if (n?.error !== void 0 || !k(r.props)) {
                                    break;
                                }
                            }
                        }
                        i = !1;
                    }
                }
                r = ku(r);
            }
            if (e && e !== o) {
                s = o ?? s;
                o = e;
            }
            if (o) {
                s.key = `${s.key ?? ""}${hd}`;
                wn(t, o, 4);
            } else {
                wn(t, n, 4);
            }
        })(t, e, s.projectedContentOwner ?? null);
        s.error = void 0;
    }(n, t);
};

const hd = "\0";

const dd = t => {
    if (!__EXPERIMENTAL__.errorBoundary) {
        throw Error('<ErrorBoundary> requires the `errorBoundary` experimental feature. Enable it in your Qwik Vite config: qwikVite({ experimental: ["errorBoundary"] }).');
    }
    const n = (() => {
        const t = Za(fd);
        Mf(xf, t);
        return t;
    })();
    const e = sa();
    const s = e?.$;
    s && (Gu(n) ?? n).boundaryId === void 0 && (n.boundaryId = Ka(s));
    const o = !Ve;
    if (!o && n.error === void 0) {
        /*#__PURE__*/
        return bo(qo, null, null, null, 0, null);
    }
    const r = /*#__PURE__*/ Cc(ad, "_ebR", [ e?.m ]);
    if (o) {
        const e = t.fallback$;
        n.It = Rf(t => e(t, r));
        const o = t.onError$;
        o && (n.Ze = Rf((t, n) => o(t, n)));
        return ((t, n) => {
            const e = n?.nextOutOfOrderId(!1) ?? 0;
            return [ 
            /*#__PURE__*/ bo("div", {
                [br]: e + "",
                style: "display:contents"
            }, null, 
            /*#__PURE__*/ bo(qo, null, null, null, 0, null), 1, null), 
            /*#__PURE__*/ bo(Kd, {
                boundaryId: e,
                store: t
            }, null, null, 1, null) ];
        })(n, s);
    }
    const i = Xf(n.error, !0);
    /*#__PURE__*/
    return bo(Ao, null, null, ((t, n, e) => t(n, e).catch(n => {
        if (t.resolved !== void 0) {
            throw n;
        }
        /*#__PURE__*/
        return bo("div", {
            role: "alert"
        }, null, "Something went wrong.", 0, null);
    }))(t.fallback$, i, r), 0, null);
};

const pd = 
/*#__PURE__*/ za(
/*#__PURE__*/ Cc(dd, "_ebC"));

const Gd = (t, n) => {
    const e = n.It;
    delete n.It;
    const s = Xf(n.error, Ue, t.A);
    return e(s);
};

const Zd = __EXPERIMENTAL__.errorBoundary ? /*#__PURE__*/ Vd((t, n, e, s) => {
    const o = n.varProps.boundaryId;
    const r = n.varProps.store;
    if (n.varProps.deliverLate) {
        const n = async n => {
            if (!r.It) {
                return;
            }
            r.error !== n && Bf(r, n, "render");
            const s = await t.segment("" + o, Gd(t, r), e);
            s.container.I(o);
            await t.C(() => Yd(t, o, s, null));
        };
        r.Nt = Rf(n);
        t.write(`<template ${vr}="${o}"></template>`);
        if (r.error !== void 0) {
            return n(r.error);
        }
        return;
    }
    if (r.error === void 0 || !r.It) {
        return;
    }
    Dd(t) ? t.I(o) : s(() => {
        t.emitErrorSwapExecutorIfNeeded();
        t.emitInlineScript(`qErr(${o})`);
    });
    s(Gd(t, r));
}) : null;

const Kd = __EXPERIMENTAL__.errorBoundary ? /*#__PURE__*/ Vd((t, n, e, s) => {
    const o = n.varProps.boundaryId;
    const r = n.varProps.store;
    const i = __EXPERIMENTAL__.suspense && t.outOfOrderStreaming && !Dd(t) && (r.error === void 0 || (t => Wf.has(t))(r));
    s(
    /*#__PURE__*/ bo("div", {
        [i ? Ld : "q:ebf"]: o + "",
        style: "display:none"
    }, null, 
    /*#__PURE__*/ bo(Zd, {
        boundaryId: o,
        store: r,
        deliverLate: i
    }, null, null, 1, null), 1, null));
}) : null;

const $d = async ({track: t}) => {
    const n = Pa[0];
    t(() => n.items);
    const e = sa();
    const s = e.m;
    const o = e.$;
    wn(o, s, 256);
    const r = We;
    r && await o.l;
};

const yd = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    xu(/*#__PURE__*/ Cc($d, "_eaT", [ t ]));
    return Io;
};

const wd = /*#__PURE__*/ za(
/*#__PURE__*/ Cc(yd, "_eaC"));

const md = (t, n, e) => sr(t) ? t.getFn(n)(e) : t(e);

const vd = ({track: t}) => {
    const n = Pa[0];
    const e = sa();
    const s = e.m;
    const o = e.$;
    const r = We;
    return oi(t(() => md(n.when$, sa(), void 0)), t => {
        const i = t ? n.then$ : n.else$;
        return oi(i ? md(i, e, t) : null, t => {
            const n = i ? [ t ] : [];
            if (r) {
                const t = o;
                return t.renderJSX(n, {
                    currentStyleScoped: null,
                    parentComponentFrame: t.getComponentFrame(0)
                });
            }
            zt(s, n);
            wn(o, s, 2);
        });
    });
};

const bd = t => {
    if (!__EXPERIMENTAL__.show) {
        throw Error('Show is experimental and must be enabled with `experimental: ["show"]` in the `qwikVite` plugin.');
    }
    xu(/*#__PURE__*/ Cc(vd, "_shT", [ t ]));
    return Io;
};

const _d = /*#__PURE__*/ za(
/*#__PURE__*/ Cc(bd, "_shC"));

const gd = /*#__PURE__*/ Af("qk-reveal");

const Ed = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: Js(0)
});

const Sd = () => {
    const t = Pa[0];
    if (t !== null && t.reveal.version.value < 0) {
        return !1;
    }
    if (!Ve) {
        const n = t?.reveal.ooos;
        if (n) {
            return n.canReveal(t);
        }
    }
    return Ud(t);
};

const kd = ({cleanup: t}) => {
    const n = Pa[0];
    t(() => {
        if (!Ve) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const Rd = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = nl(Ed, t);
    Mf(gd, n);
    const e = !Ve;
    if (__EXPERIMENTAL__.suspense && e && Hd()) {
        const t = (t => {
            const n = t.ooos;
            if (n) {
                return n;
            }
            const e = ((t, n) => {
                const e = sa().$;
                const s = (zd.get(e) || 0) + 1;
                zd.set(e, s);
                return new Bd(s, t, n);
            })(t.order, t.collapsed);
            t.ooos = Rf(e);
            return e;
        })(n);
        /*#__PURE__*/
        return bo(tp, {
            coordinator: t
        }, null, null, 0, "u7_0");
    }
    /*#__PURE__*/
    return bo(qo, null, null, null, 0, "u7_0");
};

const Pd = /*#__PURE__*/ za(
/*#__PURE__*/ Cc(Rd, "_reC"));

const tp = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Vd((t, n, e, s) => {
    const o = n.varProps.coordinator;
    s(() => {
        const n = o.script();
        if (!n) {
            return;
        }
        t.emitOutOfOrderExecutorIfNeeded();
        t.emitInlineScript(n);
    });
    s(/*#__PURE__*/ bo(qo, null, null, null, 0, "u7_0"));
}) : null;

const Td = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback == null || t.fallback === !1 || !e.value && s.reveal.collapsed ? "none" : "contents"
});

const np = '{display:p1.value==="fallback"&&p0.fallback!=null&&p0.fallback!==false&&(p2.value||!p3.reveal.collapsed)?"contents":"none"}';

const Ad = (t, n) => ({
    display: t.value === "content" && n.value ? "contents" : "none"
});

const Md = ({track: t, cleanup: n}) => {
    const e = Pa[0], s = Pa[1], o = Pa[2], r = Pa[3];
    const i = t(e);
    const c = Ve;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const qd = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Suspense is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = tl("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.suspense) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
        }
        return tl(0);
    })();
    const s = (t => {
        const n = qf(gd, null);
        const e = nl(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && xu(/*#__PURE__*/ Cc(kd, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = Yh(
    /*#__PURE__*/ Cc(Sd, "_reR", [ s ]));
    xu(
    /*#__PURE__*/ Cc(Md, "_suT", [ e, t, n, s ]));
    const r = !Ve;
    const i = r && Hd();
    const c = i ? (() => sa().$.nextOutOfOrderId())() : 0;
    const l = i ? s?.reveal.ooos?.register(s) ?? null : null;
    const u = i && ca(() => t.fallback != null && t.fallback !== !1) && (l === null || l.showFallback);
    const f = u && function a(t) {
        return typeof t === "number" && Number.isFinite(t) && t > 0;
    }(t.delay) ? {
        contentResolved: !1,
        delay: t.delay,
        delayTimer: null
    } : null;
    const h = /*#__PURE__*/ Uc(Ad, [ n, o ], '{display:p0.value==="content"&&p1.value?"contents":"none"}');
    const d = i ? /*#__PURE__*/ bo(ep, {
        boundary: f,
        fallbackStyle: Uc(Td, [ t, n, o, s ], np),
        showFallback: u,
        state: n
    }, null, eo(t, "fallback"), 1, null) : /*#__PURE__*/ bo("div", {
        style: Uc(Td, [ t, n, o, s ], np)
    }, null, eo(t, "fallback"), 1, null);
    return [ d, 
    /*#__PURE__*/ bo("div", null, i ? {
        [Ld]: c + "",
        style: h
    } : {
        style: h
    }, 
    /*#__PURE__*/ bo(i ? sp : qo, i ? {
        [Zr]: e,
        boundary: f,
        boundaryId: c,
        contentStyle: h,
        reveal: l
    } : {
        [Zr]: e
    }, null, null, 3, "u6_0"), 1, null) ];
};

const Id = /*#__PURE__*/ za(
/*#__PURE__*/ Cc(qd, "_suC"));

const ep = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Vd((t, n, e, s) => {
    const o = n.varProps.boundary;
    const r = n.varProps.fallbackStyle;
    const i = n.varProps.showFallback === !0;
    const c = n.varProps.state;
    i && (o ? s(() => function n(t, e, s) {
        e.delayTimer = setTimeout(() => {
            e.delayTimer = null;
            t.C(async () => {
                if (e.contentResolved) {
                    return;
                }
                s.value = "fallback";
                t.emitBackpatchDataAndExecutorIfNeeded();
                await t.streamHandler.flush();
            });
        }, e.delay);
    }(t, o, c)) : c.value = "fallback");
    s(
    /*#__PURE__*/ bo("div", {
        style: r
    }, null, n.children, 1, null));
}) : null;

const sp = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Vd(async (t, n, e) => {
    const s = n.varProps.boundaryId;
    const o = "" + s;
    const r = n.varProps.boundary;
    const i = n.varProps.contentStyle;
    const c = n.varProps.reveal;
    const l = __EXPERIMENTAL__.errorBoundary && e.parentComponentFrame ? t.resolveContext(e.parentComponentFrame.componentNode, xf) : void 0;
    const u = t.segment(o, function f(t, n, e) {
        const s = e.parentComponentFrame;
        if (!s) {
            /*#__PURE__*/
            return bo(qo, n.varProps, n.constProps, n.children, n.flags, n.key);
        }
        const o = R(s.componentNode, n, t);
        const r = n.children || null;
        const i = s.claimChildrenForSlot(o) || r;
        r && i !== r && t.addUnclaimedProjection(s, "", r);
        /*#__PURE__*/
        return bo(qo, n.varProps, n.constProps, i, n.flags, n.key);
    }(t, n, e), e);
    t.write(`<template ${vr}="${s}"></template>`);
    t.emitOutOfOrderExecutorIfNeeded();
    t.queueOutOfOrderSegment(u.then(n => async function e(t, n, s, o, r, i) {
        if (i) {
            i.contentResolved = !0;
            if (i.delayTimer) {
                clearTimeout(i.delayTimer);
                i.delayTimer = null;
            }
        }
        r?.resolve();
        await t.C(async () => {
            t.addRoot(o);
            await Yd(t, n, s, r);
        });
    }(t, s, n, i, c, r)).catch(t => {
        if (l?.Nt) {
            return l.Nt(t);
        }
        if (l?.error !== void 0) {
            return;
        }
        throw t;
    }));
}) : null;

const xd = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    t?.path?.startsWith?.("/") ? e.path = t.path : e.path = n + e.path;
    let s = Nd.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return bo("script", null, o, null, 0, "prefetch-service-worker");
};

const Nd = /*#__PURE__*/ "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const Cd = () => null;

globalThis.__qwik && rr(30, [ globalThis.__qwik, Yi ]);

globalThis.__qwik = Yi;

import.meta.hot && import.meta.hot.dispose(() => {
    globalThis.__qwik = void 0;
});

export { Xa as $, wd as Each, pd as ErrorBoundary, Ao as Fragment, Pf as NoSerializeSymbol, Cd as PrefetchGraph, xd as PrefetchServiceWorker, Mo as RenderOnce, tf as Resource, Pd as Reveal, No as SSRComment, xo as SSRRaw, Oo as SSRStream, Co as SSRStreamBlock, Tf as SerializerSymbol, _d as Show, Io as SkipRender, qo as Slot, Id as Suspense, ws as _CONST_PROPS, ea as _DomContainer, Ki as _EFFECT_BACK_REF, Ur as _ELEMENT_SEQ, Es as _EMPTY_ARRAY, Ss as _EMPTY_OBJ, _s as _IMMUTABLE, zc as _SharedContainer, oo as _SubscriptionData, uc as _SubscriptionPatch, Cu as _Task, gs as _UNINITIALIZED, ms as _VAR_PROPS, ee as _addProjection, Pa as _captures, b as _chk, ye as _createDeserializeContainer, xa as _createQRL, xn as _createStore, li as _delay, pe as _deserialize, Rc as _dumpState, yd as _eaC, $d as _eaT, dd as _ebC, ad as _ebR, $n as _executeSsrChores, Uc as _fnSignal, Vc as _getAsyncLocalStorage, qs as _getConstProps, $a as _getContextContainer, pa as _getContextEvent, da as _getContextHostElement, Me as _getDomContainer, Ie as _getQContainerElement, m as _getSubscriber, Ms as _getVarProps, Jn as _handleSSRError, Ku as _hasStoreEffects, uf as _hmr, zs as _injectAsyncSignalValue, Oe as _invoke, co as _isJSXNode, Qu as _isSignalNotInvalid, nc as _isStore, Un as _isStringifiable, Ou as _isTask, ya as _jsxBranch, go as _jsxC, So as _jsxQ, Eo as _jsxS, bo as _jsxSorted, _o as _jsxSplit, He as _mapApp_findIndx, Ye as _mapArray_get, Je as _mapArray_set, Bu as _markSignalAsExternallyOwned, Fe as _newInvokeContext, Oc as _noopQrl, jc as _noopQrlDEV, Dn as _preprocessState, Ua as _qrlSync, jn as _qrlToString, Lc as _qrlWithChunk, Fc as _qrlWithChunkDEV, Rd as _reC, Sd as _reR, kd as _reT, Lf as _redactToGeneric, Wc as _regSymbol, se as _removeProjection, _ as _res, If as _resolveContextWithoutSequentialScope, Do as _restProps, n as _retryOnPromise, Zc as _rsc, N as _run, de as _serialize, Kn as _setEvent, re as _setProjectionTarget, bd as _shC, vd as _shT, qd as _suC, Md as _suT, qn as _task, ie as _updateProjectionProps, ne as _useHmr, v as _val, _f as _verifySerializable, Nl as _vnode_ensureElementInflated, Eu as _vnode_getAttrKeys, eu as _vnode_getElementName, su as _vnode_getFirstChild, Ml as _vnode_getProp, Dl as _vnode_getVNodeForChildNode, Gl as _vnode_insertBefore, Sl as _vnode_isElementVNode, Rl as _vnode_isMaterialized, Pl as _vnode_isTextVNode, Tl as _vnode_isVirtualVNode, gl as _vnode_newVirtual, tu as _vnode_remove, ql as _vnode_setProp, Sn as _vnode_toString, wa as _waitUntilRendered, Bn as _walkJSX, eo as _wrapProp, io as _wrapSignal, Ha as component$, za as componentQrl, Gs as createAsync$, Qs as createAsyncQrl, Ys as createComputed$, Bs as createComputedQrl, Af as createContextId, g as createElement, Zs as createSerializer$, Hs as createSerializerQrl, Js as createSignal, Ja as event$, Wa as eventQrl, Zu as forceStoreEffects, Ya as getClientManifest, Me as getDomContainer, Ne as getLocale, Ri as getPlatform, g as h, Ws as implicit$FirstArg, Cc as inlinedQrl, Dc as inlinedQrlDEV, Ue as isDev, Lu as isSignal, Ro as jsx, Po as jsxDEV, To as jsxs, Rf as noSerialize, Nc as qrl, Xc as qrlDEV, Ga as render, ki as setPlatform, Va as sync$, ca as untrack, tc as unwrapStore, cd as useAsync$, ud as useAsyncQrl, Gh as useComputed$, Yh as useComputedQrl, nl as useConstant, qf as useContext, Mf as useContextProvider, th as useId, Gc as useLexicalScope, ef as useOn, rf as useOnDocument, sf as useOnWindow, id as useResource$, Kc as useResourceQrl, td as useSerializer$, Kh as useSerializerQrl, Xe as useServerData, tl as useSignal, Za as useStore, zh as useStyles$, Uh as useStylesQrl, Qh as useStylesScoped$, Bh as useStylesScopedQrl, sd as useTask$, xu as useTaskQrl, od as useVisibleTask$, nd as useVisibleTaskQrl, Yi as version, Ce as withLocale };
